import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutdoor = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "_\\u017D\\xD3\\u0165_1",
	"data-name": "\\u2014\\u017D\\xD3\\u0165_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 739.14 526.4",
	width: "100%",
	height: "100%",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("style", { children: "\n      .cls-1 {\n        fill: #a2c61a;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-4 {\n        fill: #418448;\n      }\n\n      .cls-5 {\n        clip-path: url(#clip-path-2);\n      }\n\n      .cls-6 {\n        fill: #539694;\n      }\n\n      .cls-7 {\n        fill: #306d6d;\n      }\n\n      .cls-13,\n      .cls-8 {\n        fill: #0072bb;\n      }\n\n      .cls-8 {\n        opacity: 0.35;\n      }\n\n      .cls-15,\n      .cls-9 {\n        fill: #263238;\n      }\n\n      .cls-9 {\n        opacity: 0.5;\n      }\n\n      .cls-10 {\n        fill: #70ca7b;\n      }\n\n      .cls-11 {\n        fill: #10275b;\n      }\n\n      .cls-12 {\n        fill: #fff;\n      }\n\n      .cls-14 {\n        clip-path: url(#clip-path-3);\n      }\n\n      .cls-16 {\n        fill: #d0f2c2;\n      }\n\n      .cls-17 {\n        fill: #e8f1f9;\n      }\n\n      .cls-18 {\n        fill: #6f96bc;\n      }\n\n      .cls-19 {\n        fill: #eae468;\n      }\n\n      .cls-20 {\n        fill: #547d9e;\n      }\n\n      .cls-21 {\n        fill: #ffd500;\n      }\n\n      .cls-22 {\n        fill: #c8c8c8;\n      }\n\n      .cls-23 {\n        fill: #b8d8a9;\n      }\n\n      .cls-24 {\n        clip-path: url(#clip-path-4);\n      }\n\n      .cls-25 {\n        fill: #2b3472;\n      }\n\n      .cls-26 {\n        fill: #000543;\n      }\n\n      .cls-27 {\n        fill: #6d72a0;\n      }\n\n      .cls-28 {\n        fill: #cde5f9;\n      }\n\n      .cls-29 {\n        fill: #ce5151;\n      }\n\n      .cls-30 {\n        fill: #ecdfee;\n      }\n\n      .cls-31 {\n        fill: #ffb573;\n      }\n\n      .cls-32 {\n        fill: #c9e7ff;\n      }\n\n      .cls-33 {\n        fill: #3a2d3f;\n      }\n\n      .cls-34 {\n        fill: #ffb288;\n      }\n\n      .cls-35 {\n        fill: #452a51;\n      }\n\n      .cls-36 {\n        fill: #817387;\n      }\n\n      .cls-37 {\n        fill: #c3dced;\n      }\n\n      .cls-38 {\n        fill: #ffa27f;\n      }\n\n      .cls-39 {\n        fill: #f9764a;\n      }\n\n      .cls-40 {\n        fill: #3aaa35;\n      }\n\n      .cls-41 {\n        fill: #f5b3b3;\n      }\n\n      .cls-42 {\n        fill: #6cbab6;\n      }\n\n      .cls-43 {\n        fill: #fbcac7;\n      }\n    " }),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip-path",
				transform: "translate(-69.81 -46.82)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M731.5,402.67c-1.84-6.33-5.21-12.15-6.51-18.62-2.64-13,3.36-27.21-1.22-39.64-3.68-10-13.75-17.36-14.23-28.05-.27-6,2.72-11.85,2.52-17.9-.21-6.73-4.25-12.57-6.92-18.71-7.45-17.15-1.11-43.64-16.94-56.14-7.24-5.72-17.05-7.33-26-5.35-7.52,1.68-9.09,9.66-10.75,16.92C648.57,248,639.08,254.41,639,267.63c0,6,2.26,11.85,1.85,17.82-.74,10.52-9.57,18.6-11.87,28.87-2.71,12.07,4,24.25,4.17,36.63.13,10.51-4.45,20.36-8.19,30.13s-6.71,20.72-3.36,30.64c2.48,7.36,8.1,13.06,11.74,19.89,3.54,6.65,5.12,14.21,7.9,21.25,3.64,9.25,9.67,17.84,18.19,22.46s19.71,4.57,27.15-1.76C692,469,694.85,461.8,700,456.93c4.61-4.34,10.68-6.53,15.89-10C729.51,437.74,736.18,418.79,731.5,402.67Z"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip-path-2",
				transform: "translate(-69.81 -46.82)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M107.61,445.85c-1.69-3.07-2.52-6.47-4.27-9.51-3.83-6.66-11.88-11.32-13.81-18.58-.8-3-.44-6.14-1-9.18-1.5-8-9-14-12.55-21.42a23.37,23.37,0,0,1,1.61-22.68c2.68-4.12,6.6-7.49,9.72-11.35s5.52-8.62,4.46-13.28c-1.72-7.59-11.69-11.93-13.89-19.43-1.87-6.38,2.46-12.9,2.4-19.49,0-3.71-1.46-7.3-2-11-2.06-13.26,8.81-27.1,23.61-30.06,6.32-1.26,13.07-.76,19.18-2.67,13.52-4.24,21.08-19.33,35.36-20.64,9.47-.87,18.1,4.85,27.54,6,6.46.78,13-.61,19.52,0,16.51,1.6,28.24,16.44,29.52,31,.66,7.5-.75,15.34,2.41,22.33,3.74,8.3,13.52,14.3,14.65,23.18,1.42,11-11,19.61-13.55,30.45-2.62,11.24,5.77,22.09,7.38,33.49s-3.64,22.54-10.66,32.08-15.87,18-22.83,27.53c-6.3,8.67-11.39,18.6-21.1,24.3-12.84,7.54-32.55,6.58-45.63-.05C131.56,460.82,114.18,457.8,107.61,445.85Z"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip-path-3",
				transform: "translate(-69.81 -46.82)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					d: "M216.26,350.1l-16.43,32.84a2.51,2.51,0,0,0,2.23,3.64l70.67.31a2.49,2.49,0,0,0,2.35-1.61l12.62-32.86a2.51,2.51,0,0,0-2.33-3.41l-66.85-.3A2.53,2.53,0,0,0,216.26,350.1Z"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip-path-4",
				transform: "translate(-69.81 -46.82)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					d: "M501.71,142.81l-28.35,56.66a4.34,4.34,0,0,0,3.86,6.27l121.9.55a4.34,4.34,0,0,0,4.06-2.78L625,146.82a4.32,4.32,0,0,0-4-5.88l-115.33-.52A4.34,4.34,0,0,0,501.71,142.81Z"
				})
			})
		] }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M731.5,402.67c-1.84-6.33-5.21-12.15-6.51-18.62-2.64-13,3.36-27.21-1.22-39.64-3.68-10-13.75-17.36-14.23-28.05-.27-6,2.72-11.85,2.52-17.9-.21-6.73-4.25-12.57-6.92-18.71-7.45-17.15-1.11-43.64-16.94-56.14-7.24-5.72-17.05-7.33-26-5.35-7.52,1.68-9.09,9.66-10.75,16.92C648.57,248,639.08,254.41,639,267.63c0,6,2.26,11.85,1.85,17.82-.74,10.52-9.57,18.6-11.87,28.87-2.71,12.07,4,24.25,4.17,36.63.13,10.51-4.45,20.36-8.19,30.13s-6.71,20.72-3.36,30.64c2.48,7.36,8.1,13.06,11.74,19.89,3.54,6.65,5.12,14.21,7.9,21.25,3.64,9.25,9.67,17.84,18.19,22.46s19.71,4.57,27.15-1.76C692,469,694.85,461.8,700,456.93c4.61-4.34,10.68-6.53,15.89-10C729.51,437.74,736.18,418.79,731.5,402.67Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "cls-3",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "cls-4",
					d: "M738.31,300.76a257.37,257.37,0,0,1-5.39,51.81c-2.08,9.81-4.79,19.45-7.41,28.77-4.27,15.23-8.69,31-10.44,47.68-1.31,12.63-1.09,25.77-.88,38.49.25,14.43.5,29.35-1.5,43.59l-1-.09c-.11-10.95-.67-21.59-1.21-31.87s-1.1-20.94-1.22-31.92c-.08-7.54-.16-15.32.43-22.93,1.13-14.49,4.67-28.23,8.09-41.52.52-2,1-4,1.54-6,13.69-54,17-98.77,10.21-136.77l1-.24c6.86,38.2,3.51,83.12-10.23,137.34-.51,2-1,4-1.54,6-3.41,13.23-6.93,26.92-8,41.28-.58,7.55-.5,15.31-.42,22.81.11,11,.67,21.59,1.21,31.87.41,7.82.83,15.84,1.06,24.06,1-11.74.82-23.84.62-35.6-.22-12.75-.44-25.94.89-38.65,1.75-16.82,6.19-32.62,10.48-47.9,2.61-9.31,5.31-18.93,7.38-28.7a262.31,262.31,0,0,0,2.64-90.59l1-.2A261.88,261.88,0,0,1,738.31,300.76Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-4",
					d: "M739.33,349c-1.56,8.63-3.49,17.09-5.79,25.29-1,3.61-2.12,7.23-3.18,10.73-1.75,5.73-3.55,11.66-5,17.71-7.53,30.94-6.67,66.09-5.91,97.1l1,0c-.76-30.92-1.62-66,5.87-96.74,1.46-6,3.26-11.93,5-17.64,1.07-3.51,2.17-7.13,3.19-10.75,1.83-6.5,3.42-13.17,4.79-20Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-4",
					d: "M739.2,378.42c-.94,3.6-2,7.18-3,10.73-1.68,6-3.42,12.11-4.81,18.23-5.82,25.54-6.09,53.71-5.59,77.91l1,0c-.5-24.11-.22-52.18,5.56-77.58,1.39-6.08,3.12-12.23,4.79-18.17q1-3.47,1.95-7Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-4",
					d: "M722.48,321.09c0,2.6-.09,5.21-.24,7.79-.93,15.39-4.79,29.92-8.52,44-3.9,14.7-7.93,29.89-8.57,46-.41,10.56.65,21.28,1.68,31.64.75,7.61,1.53,15.47,1.73,23.25.44,17.18-1.85,35.58-7,56.28l-1-.33c5.11-20.57,7.38-38.86,6.94-55.91-.19-7.74-1-15.57-1.72-23.15-1-10.41-2.1-21.17-1.68-31.83.65-16.22,4.69-31.49,8.61-46.25,3.71-14,7.55-28.47,8.47-43.72.58-9.56,0-19.36-.56-28.84-.19-3.29-.39-6.7-.54-10-.49-11-.48-22.3-.46-33.24,0-24.14.06-49.1-5.4-71.93l1-.32c5.51,23,5.47,48,5.44,72.25,0,10.92,0,22.21.46,33.18.15,3.34.35,6.74.55,10C722.09,306.85,722.51,314,722.48,321.09Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-4",
					d: "M715.44,249a160.73,160.73,0,0,1-1.35,20.53c-.58,4.3-1.36,8.61-2.11,12.77a171.07,171.07,0,0,0-2.9,20.94c-.51,8.94.33,18.1,1.15,27,.91,9.85,1.84,20,.93,30-.83,9.05-3.16,17.56-5.42,25.78-1.22,4.45-2.48,9-3.49,13.68-4.29,19.71-4.31,41.21-4.32,62,0,16.75,0,34.07-2.25,50.53l-1-.18c2.21-16.37,2.22-33.64,2.24-50.35,0-20.87,0-42.43,4.35-62.29,1-4.66,2.28-9.28,3.51-13.74,2.24-8.17,4.56-16.62,5.37-25.56.9-9.81,0-19.93-.93-29.72-.82-8.91-1.67-18.12-1.16-27.17A172.6,172.6,0,0,1,711,282c.75-4.15,1.52-8.44,2.1-12.71,4-30.28-1.92-62.1-6.77-83.4l1-.3C711.08,202.22,715.55,225.22,715.44,249Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-4",
					d: "M704.88,239.94A213.87,213.87,0,0,1,703.29,265c-.44,3.51-1,7.07-1.48,10.51-1.33,8.91-2.71,18.14-2.5,27.4A160.79,160.79,0,0,0,701.25,322a155.48,155.48,0,0,1,2,20.27c.15,14.07-3.45,27.22-6.92,39.92-2.5,9.15-5.08,18.61-6.29,28.42-1.7,13.78-.67,28.2.31,42.14.2,2.79.4,5.58.57,8.36,1,16.06,1.37,34.55-3.78,49.87l-1-.43c5.08-15.1,4.74-33.42,3.72-49.35-.17-2.78-.37-5.56-.57-8.35-1-14-2-28.49-.31-42.4,1.22-9.91,3.82-19.42,6.33-28.61,3.45-12.62,7-25.66,6.88-39.56a156.92,156.92,0,0,0-1.95-20.09,164.58,164.58,0,0,1-2-19.27c-.21-9.39,1.18-18.67,2.52-27.64.51-3.43,1-7,1.48-10.48a211.57,211.57,0,0,0-3.77-73.1l1-.31A211.08,211.08,0,0,1,704.88,239.94Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-4",
					d: "M695.61,254.81a56.51,56.51,0,0,1-.81,9.77,72.77,72.77,0,0,1-2.32,8.67c-.7,2.28-1.44,4.62-2,7-2.47,11.1-.92,23.47.58,35.43,1.64,13.15,3.35,26.74-.37,38.51a69.54,69.54,0,0,1-3.24,8c-.94,2.05-1.9,4.16-2.7,6.39-4.48,12.48-3.71,27.76-3,42.55.05,1.16.11,2.32.17,3.47a547,547,0,0,1-1.77,77.28l-1-.13a545.62,545.62,0,0,0,1.76-77.08c-.05-1.15-.11-2.31-.17-3.47-.74-14.92-1.52-30.34,3.05-43.08.82-2.27,1.8-4.41,2.74-6.48a68.83,68.83,0,0,0,3.19-7.83c3.63-11.49,1.94-24.94.31-37.94-1.51-12.08-3.07-24.57-.56-35.9.55-2.46,1.29-4.84,2-7.14a74.68,74.68,0,0,0,2.28-8.51c1.22-6.64.75-14,.34-20.47l-5-79.29,1-.09,5,79.29C695.39,247.28,695.63,251,695.61,254.81Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-4",
					d: "M684.3,329.45c0,9.38-2.07,18.59-4,27.57a175.43,175.43,0,0,0-3.78,21.39,178.47,178.47,0,0,0-.34,19.76c.09,4.75.19,9.67,0,14.49-.17,4.36-.57,8.74-1,13s-.77,8.45-.95,12.7c-.44,10.89.57,22,1.54,32.73,1.06,11.77,2.16,23.93,1.37,35.88l-1-.09c.79-11.84-.31-24-1.36-35.66-1-10.79-2-21.93-1.54-32.91.17-4.29.57-8.6,1-12.77s.79-8.58,1-12.9c.19-4.78.09-9.68,0-14.41a181.36,181.36,0,0,1,.35-19.91,176.5,176.5,0,0,1,3.8-21.56c2.6-11.81,5-23,3.58-34.75a98.75,98.75,0,0,0-2.85-13.2,86.15,86.15,0,0,1-3.11-15.69c-.69-9,1.28-17.75,3.18-26.17a124.77,124.77,0,0,0,3.22-18.58c.56-8-.39-16.14-1.32-24-.18-1.56-.36-3.12-.53-4.68a326,326,0,0,1,.63-76.67l1,.17a324.35,324.35,0,0,0-.64,76.35l.54,4.67c.93,8,1.89,16.18,1.32,24.29a126.24,126.24,0,0,1-3.25,18.79c-2,8.71-3.82,16.93-3.15,25.77A85.46,85.46,0,0,0,681,308.43a101.32,101.32,0,0,1,2.89,13.38A59.52,59.52,0,0,1,684.3,329.45Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-4",
					d: "M675.73,336.31c0,7.71-1.46,15.32-2.85,22.73a166.76,166.76,0,0,0-2.66,17.59c-.65,8.33,0,16.89.55,25.18.23,3.28.47,6.68.63,10,.65,13.45,0,27.28-.54,40.66-1,22.3-2,45.37,2.91,66.6l-1,.3c-4.94-21.4-3.93-44.56-2.95-67,.59-13.35,1.19-27.15.55-40.53-.16-3.33-.4-6.72-.63-10-.6-8.34-1.21-17-.55-25.38a168.41,168.41,0,0,1,2.67-17.74c1.75-9.32,3.56-19,2.54-28.63a96.52,96.52,0,0,0-2.69-13.27A88,88,0,0,1,668.87,302c-.64-8.41,1-16.71,2.59-24.72,1.65-8.32,3.36-16.93,2.43-25.52a79,79,0,0,0-3.58-15c-1-3.18-2-6.46-2.75-9.85-2.2-10-2-21-1.63-30.48.37-9.68,1-19.45,1.78-29l1,.11c-.81,9.58-1.41,19.33-1.78,29-.36,9.41-.56,20.28,1.6,30.13.73,3.33,1.74,6.59,2.72,9.74a79.58,79.58,0,0,1,3.64,15.27c1,8.8-.78,17.51-2.45,25.93-1.57,7.93-3.19,16.13-2.57,24.35a87.56,87.56,0,0,0,2.81,14.66A96.15,96.15,0,0,1,675.42,330,55.6,55.6,0,0,1,675.73,336.31Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-4",
					d: "M667.37,349.39c0,8.8-.83,17.6-1.61,26.22-.37,4.14-.75,8.42-1,12.62-1.3,18.59-.93,37.68-.56,56.14.31,16.22.64,33-.16,49.4l-1-.06c.81-16.36.48-33.12.16-49.32-.36-18.49-.73-37.61.57-56.25.3-4.22.68-8.5,1.05-12.65,1.18-13.05,2.39-26.55.95-39.68-.37-3.33-.91-6.68-1.43-9.93a110.9,110.9,0,0,1-1.91-18.41c0-3.76.47-7.49.87-11.11.28-2.45.57-5,.73-7.49.65-10-.61-20.08-1.83-29.87-.6-4.8-1.22-9.77-1.61-14.67-1.2-15.1-.34-30.12.81-46.78l1,.09c-1.15,16.61-2,31.58-.81,46.58.39,4.87,1,9.82,1.6,14.61,1.23,9.85,2.5,20,1.84,30.13-.16,2.54-.45,5.09-.73,7.56a107,107,0,0,0-.86,11,109.42,109.42,0,0,0,1.88,18.18c.53,3.26,1.08,6.64,1.45,10A120.91,120.91,0,0,1,667.37,349.39Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-4",
					d: "M661.3,382.79c0,7.94-.18,15.91-.51,23.8-.28,6.56-.69,13.24-1.09,19.7-1.15,18.46-2.34,37.56-.4,56.12l-1,.15c-1.95-18.68-.76-37.83.39-56.36.41-6.45.82-13.12,1.1-19.67.71-16.8.53-34,.36-50.55-.19-18.42-.38-37.47-1.92-56.08-.61-7.34-1.45-14.8-2.25-22-2-18-4.1-36.63-2.88-55l1,.09c-1.21,18.22.87,36.78,2.87,54.73.81,7.23,1.64,14.7,2.26,22.06,1.54,18.66,1.74,37.73,1.93,56.17C661.25,364.79,661.34,373.78,661.3,382.79Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-4",
					d: "M654.9,336.14c0,9.54-.87,19.07-1.67,28.36-.67,7.75-1.37,15.77-1.6,23.69-.33,11.54.29,23.44.89,34.94,1,19.63,2.1,39.93-1.63,58.81l-1-.26c3.7-18.72,2.64-38.93,1.61-58.48-.6-11.53-1.23-23.45-.89-35.05.23-8,.93-16,1.6-23.77,1-12.07,2.12-24.55,1.46-36.88-.45-8.44-1.71-16.86-2.94-25-.52-3.46-1.06-7-1.53-10.56a316.37,316.37,0,0,1-2.32-57.27l1,.07a313.66,313.66,0,0,0,2.32,57c.46,3.52,1,7.09,1.52,10.53,1.23,8.18,2.5,16.64,3,25.14C654.85,330.32,654.91,333.23,654.9,336.14Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-4",
					d: "M649,469.09l-1,.39c-6.06-20-5.27-43.51-4.14-59.44.4-5.77.93-11.63,1.43-17.29,1.24-13.88,2.53-28.23,2.18-42.47-.29-11.93-1.73-23.92-3.13-35.52-1.08-9-2.2-18.29-2.78-27.54-1.09-17.33-.32-34.74.55-51.1l1,.08c-.87,16.31-1.63,33.68-.55,50.94.58,9.2,1.7,18.48,2.78,27.46,1.4,11.63,2.84,23.65,3.14,35.65.35,14.31-.94,28.7-2.19,42.62-.5,5.66-1,11.5-1.43,17.27C643.81,426,643,449.28,649,469.09Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-4",
					d: "M643.63,472.08l-1,.18c-3.68-16.59-7.47-33.76-7.47-51.69,0-9.65,1.14-19.32,2.24-28.65s2.24-18.85,2.23-28.44c0-11.86-1.72-23.71-3.39-35.17-.85-5.86-1.73-11.91-2.38-17.92a243.71,243.71,0,0,1,2.09-66.74l1,.23a242.2,242.2,0,0,0-2.07,66.37c.64,6,1.52,12,2.37,17.86,1.68,11.51,3.41,23.41,3.4,35.36,0,9.63-1.14,19.3-2.24,28.61s-2.22,18.91-2.23,28.49c0,16.56,3.28,32.51,6.68,48l.58,0Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-4",
					d: "M636.4,462l-1,.37c-6-21-5.16-44.58-4.36-67.34.4-11.65.82-23.7.34-35.33-.72-17.21-3.46-34.24-6.12-50.71l1-.22c2.66,16.51,5.41,33.58,6.13,50.87.49,11.68.07,23.76-.34,35.43C631.3,417.7,630.49,441.14,636.4,462Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-4",
					d: "M628.76,452.58l-1,.15c-1.89-17.06-2-34.64-2.15-51.64-.05-6.93-.1-14.1-.28-21.13-.51-20.84-2.19-47.63-10.72-70l.95-.48c8.6,22.58,10.3,49.52,10.81,70.46.17,7.05.22,14.22.28,21.16C626.75,418.05,626.89,435.59,628.76,452.58Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-4",
					d: "M625,450.9l-1,.23a542.72,542.72,0,0,1-7.29-69.91c-.16-4.14-.29-8.39-.41-12.5-.61-21.06-1.24-42.84-7.43-61.54l1-.43c6.25,18.89,6.89,40.77,7.5,61.93.12,4.11.24,8.35.4,12.49A541.71,541.71,0,0,0,625,450.9Z",
					transform: "translate(-69.81 -46.82)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M107.61,445.85c-1.69-3.07-2.52-6.47-4.27-9.51-3.83-6.66-11.88-11.32-13.81-18.58-.8-3-.44-6.14-1-9.18-1.5-8-9-14-12.55-21.42a23.37,23.37,0,0,1,1.61-22.68c2.68-4.12,6.6-7.49,9.72-11.35s5.52-8.62,4.46-13.28c-1.72-7.59-11.69-11.93-13.89-19.43-1.87-6.38,2.46-12.9,2.4-19.49,0-3.71-1.46-7.3-2-11-2.06-13.26,8.81-27.1,23.61-30.06,6.32-1.26,13.07-.76,19.18-2.67,13.52-4.24,21.08-19.33,35.36-20.64,9.47-.87,18.1,4.85,27.54,6,6.46.78,13-.61,19.52,0,16.51,1.6,28.24,16.44,29.52,31,.66,7.5-.75,15.34,2.41,22.33,3.74,8.3,13.52,14.3,14.65,23.18,1.42,11-11,19.61-13.55,30.45-2.62,11.24,5.77,22.09,7.38,33.49s-3.64,22.54-10.66,32.08-15.87,18-22.83,27.53c-6.3,8.67-11.39,18.6-21.1,24.3-12.84,7.54-32.55,6.58-45.63-.05C131.56,460.82,114.18,457.8,107.61,445.85Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "cls-5",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "cls-6",
					d: "M245.84,261.45a350,350,0,0,1-7.33,70.46c-2.84,13.34-6.52,26.46-10.08,39.14-5.81,20.71-11.82,42.13-14.19,64.85-1.8,17.17-1.49,35.05-1.2,52.34.33,19.63.67,39.92-2,59.29l-1.4-.12c-.15-14.9-.91-29.36-1.65-43.35s-1.5-28.48-1.65-43.42c-.11-10.24-.22-20.84.59-31.18,1.53-19.7,6.34-38.39,11-56.47.7-2.71,1.4-5.42,2.08-8.13,18.63-73.49,23.17-134.33,13.9-186l1.38-.33c9.32,52,4.76,113.05-13.93,186.8-.68,2.71-1.38,5.42-2.08,8.14-4.64,18-9.44,36.61-10.95,56.15-.8,10.27-.69,20.82-.58,31,.15,14.9.91,29.36,1.65,43.34.56,10.64,1.13,21.55,1.44,32.73,1.39-16,1.11-32.42.84-48.42-.29-17.34-.59-35.28,1.21-52.56,2.39-22.88,8.42-44.37,14.25-65.16,3.56-12.65,7.23-25.74,10-39,8.28-39,9.56-82.78,3.58-123.21l1.39-.28A356.41,356.41,0,0,1,245.84,261.45Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-6",
					d: "M247.23,327.06c-2.13,11.74-4.75,23.25-7.88,34.4-1.38,4.91-2.88,9.83-4.33,14.59-2.37,7.79-4.83,15.85-6.83,24.08-10.24,42.09-9.07,89.9-8,132.07l1.4-.05c-1-42.06-2.19-89.73,8-131.58,2-8.18,4.43-16.22,6.8-24,1.45-4.77,3-9.7,4.34-14.62q3.72-13.27,6.51-27.14Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-6",
					d: "M247.05,367.07c-1.28,4.9-2.65,9.77-4,14.59-2.29,8.1-4.65,16.48-6.55,24.8-7.91,34.74-8.28,73.06-7.6,106l1.4,0c-.67-32.79-.3-71,7.56-105.51,1.89-8.28,4.25-16.63,6.53-24.71.88-3.15,1.78-6.32,2.65-9.5Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-6",
					d: "M224.3,289.1c0,3.54-.11,7.08-.32,10.6-1.27,20.92-6.51,40.69-11.59,59.82-5.3,20-10.78,40.64-11.65,62.5-.57,14.37.88,28.94,2.28,43,1,10.34,2.08,21,2.35,31.62.6,23.36-2.51,48.39-9.49,76.54l-1.35-.44c6.94-28,10-52.87,9.44-76-.27-10.52-1.33-21.18-2.35-31.49-1.4-14.15-2.86-28.79-2.28-43.29.88-22.06,6.38-42.83,11.71-62.9,5-19,10.27-38.72,11.52-59.46.79-13,0-26.33-.76-39.22-.26-4.48-.54-9.12-.74-13.67-.67-15-.65-30.34-.63-45.21,0-32.84.09-66.79-7.34-97.84l1.35-.43c7.49,31.26,7.44,65.32,7.4,98.27,0,14.85,0,30.21.62,45.12.21,4.54.48,9.17.75,13.65C223.77,269.73,224.35,279.44,224.3,289.1Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-6",
					d: "M214.74,191a219.6,219.6,0,0,1-1.84,27.91c-.79,5.86-1.85,11.71-2.87,17.37-1.67,9.23-3.4,18.78-3.95,28.49-.69,12.15.46,24.62,1.57,36.67,1.23,13.39,2.51,27.24,1.27,40.76-1.13,12.32-4.31,23.89-7.37,35.08-1.66,6-3.38,12.3-4.75,18.6-5.84,26.81-5.86,56.05-5.88,84.32,0,22.79,0,46.34-3.06,68.73l-1.39-.25c3-22.27,3-45.76,3-68.48,0-28.38,0-57.71,5.92-84.71,1.39-6.35,3.11-12.63,4.77-18.7,3.05-11.11,6.2-22.6,7.32-34.75,1.22-13.35-.05-27.12-1.27-40.43-1.12-12.12-2.28-24.65-1.58-37,.56-9.82,2.3-19.42,4-28.71,1-5.64,2.08-11.47,2.86-17.28,5.51-41.18-2.62-84.45-9.21-113.42l1.36-.42C208.81,127.43,214.88,158.71,214.74,191Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-6",
					d: "M200.37,178.74a288.86,288.86,0,0,1-2.16,34.08c-.59,4.79-1.32,9.63-2,14.31-1.81,12.12-3.68,24.66-3.4,37.26a222.91,222.91,0,0,0,2.64,26c1.27,9,2.58,18.25,2.68,27.57.19,19.14-4.7,37-9.42,54.3-3.4,12.44-6.92,25.31-8.56,38.65-2.31,18.75-.91,38.36.43,57.32.27,3.79.54,7.58.78,11.36,1.39,21.85,1.86,47-5.16,67.83l-1.31-.58c6.91-20.54,6.44-45.46,5.06-67.13q-.36-5.67-.77-11.35c-1.35-19.05-2.75-38.75-.42-57.67,1.66-13.48,5.19-26.41,8.61-38.92,4.69-17.15,9.53-34.89,9.35-53.79-.09-9.2-1.4-18.41-2.66-27.33a223.25,223.25,0,0,1-2.66-26.21c-.28-12.77,1.6-25.39,3.43-37.59.69-4.67,1.42-9.49,2-14.25a287.33,287.33,0,0,0-5.12-99.43l1.36-.42A286.32,286.32,0,0,1,200.37,178.74Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-6",
					d: "M187.76,199a74.94,74.94,0,0,1-1.1,13.28,99.27,99.27,0,0,1-3.15,11.8c-1,3.09-2,6.28-2.69,9.57-3.35,15.09-1.25,31.92.79,48.19,2.24,17.88,4.56,36.37-.49,52.38A95.21,95.21,0,0,1,176.7,345c-1.27,2.78-2.58,5.66-3.67,8.68-6.09,17-5.05,37.77-4,57.87.08,1.59.16,3.17.23,4.73a742.41,742.41,0,0,1-2.41,105.1l-1.39-.17a743.15,743.15,0,0,0,2.4-104.83l-.24-4.73c-1-20.29-2.06-41.26,4.15-58.58,1.11-3.09,2.44-6,3.73-8.83a92.84,92.84,0,0,0,4.33-10.65c4.93-15.62,2.64-33.91.43-51.59-2.06-16.43-4.19-33.42-.76-48.82.75-3.36,1.75-6.59,2.73-9.71a99.36,99.36,0,0,0,3.1-11.59c1.66-9,1-19,.46-27.84L178.92,76.23l1.4-.12L187.16,184C187.46,188.72,187.78,193.83,187.76,199Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-6",
					d: "M172.38,300.47c-.06,12.76-2.81,25.29-5.5,37.49-2.08,9.47-4.23,19.25-5.14,29.1a245.83,245.83,0,0,0-.46,26.87c.12,6.47.25,13.16,0,19.71-.23,5.93-.78,11.89-1.31,17.65s-1.06,11.48-1.29,17.26c-.6,14.81.76,29.92,2.08,44.52,1.44,16,2.94,32.56,1.86,48.8l-1.4-.12c1.07-16.1-.42-32.57-1.86-48.51-1.32-14.66-2.69-29.82-2.09-44.76.24-5.83.78-11.69,1.3-17.36s1.08-11.67,1.3-17.55c.26-6.5.13-13.16,0-19.6a247.2,247.2,0,0,1,.47-27.07c.92-10,3.09-19.81,5.18-29.33,3.53-16.06,6.86-31.22,4.87-47.26a136.72,136.72,0,0,0-3.88-17.95c-1.81-6.83-3.68-13.88-4.24-21.34-.93-12.29,1.75-24.14,4.33-35.59,1.85-8.19,3.77-16.65,4.37-25.28.77-10.85-.53-22-1.78-32.69-.25-2.12-.5-4.24-.73-6.36a444,444,0,0,1,.86-104.28l1.4.23a441.42,441.42,0,0,0-.86,103.85c.23,2.11.48,4.23.72,6.35,1.27,10.82,2.57,22,1.8,33-.62,8.77-2.55,17.3-4.41,25.55-2.68,11.84-5.2,23-4.3,35,.55,7.28,2.4,14.26,4.18,21a136.33,136.33,0,0,1,3.93,18.19A82.6,82.6,0,0,1,172.38,300.47Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-6",
					d: "M160.72,309.8c0,10.49-2,20.84-3.88,30.92a226.9,226.9,0,0,0-3.61,23.93c-.89,11.31-.06,23,.74,34.23.32,4.47.65,9.09.87,13.64.88,18.28,0,37.1-.74,55.29-1.33,30.34-2.7,61.71,4,90.58l-1.36.42c-6.71-29.12-5.33-60.61-4-91.08.8-18.15,1.62-36.92.74-55.12-.21-4.52-.54-9.14-.86-13.59-.81-11.34-1.64-23.06-.74-34.52a226,226,0,0,1,3.64-24.12c2.38-12.68,4.84-25.79,3.44-38.94a130.2,130.2,0,0,0-3.65-18.05c-1.64-6.49-3.33-13.2-3.86-20.24-.87-11.44,1.36-22.72,3.52-33.62,2.24-11.32,4.56-23,3.31-34.72-.77-7.17-2.86-13.91-4.88-20.42-1.34-4.32-2.73-8.79-3.74-13.39-3-13.61-2.71-28.54-2.22-41.45.51-13.17,1.32-26.47,2.43-39.52l1.4.15c-1.11,13-1.92,26.29-2.42,39.44-.49,12.8-.77,27.58,2.17,41,1,4.53,2.37,9,3.7,13.25,2.05,6.59,4.17,13.41,5,20.76,1.28,12-1.07,23.82-3.34,35.27-2.13,10.79-4.34,21.93-3.49,33.13.52,6.88,2.19,13.51,3.81,19.92a132.16,132.16,0,0,1,3.7,18.31A76.88,76.88,0,0,1,160.72,309.8Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-6",
					d: "M149.36,327.59c-.06,12-1.14,23.94-2.19,35.66-.51,5.63-1,11.46-1.43,17.17-1.77,25.27-1.26,51.24-.77,76.35.43,22.06.88,44.88-.22,67.19l-1.4-.09c1.09-22.25.64-45,.21-67.07-.49-25.15-1-51.15.78-76.51.4-5.73.92-11.56,1.43-17.2,1.6-17.75,3.25-36.11,1.29-54-.5-4.52-1.24-9.09-1.95-13.51-1.32-8.12-2.65-16.55-2.59-25a149.26,149.26,0,0,1,1.18-15.11c.38-3.33.77-6.78,1-10.19.88-13.55-.83-27.31-2.49-40.63-.81-6.53-1.65-13.28-2.18-20-1.64-20.53-.47-41,1.09-63.62l1.41.12c-1.57,22.59-2.73,43-1.1,63.35.52,6.63,1.36,13.36,2.17,19.87,1.67,13.4,3.4,27.26,2.51,41-.23,3.46-.62,6.93-1,10.29a149.37,149.37,0,0,0-1.18,14.91c-.07,8.38,1.27,16.67,2.57,24.73.72,4.43,1.46,9,2,13.59A166.42,166.42,0,0,1,149.36,327.59Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-6",
					d: "M141.09,373c0,10.81-.23,21.64-.68,32.37-.38,8.93-.94,18-1.49,26.8-1.57,25.11-3.18,51.08-.54,76.33l-1.4.2c-2.66-25.41-1-51.46.53-76.65.55-8.77,1.12-17.85,1.49-26.75,1-22.86.73-46.19.5-68.76-.26-25.05-.52-51-2.62-76.26-.83-10-2-20.14-3.06-30-2.74-24.49-5.57-49.82-3.91-74.77l1.4.12c-1.65,24.79,1.17,50,3.9,74.44,1.1,9.83,2.24,20,3.07,30,2.1,25.37,2.37,51.31,2.62,76.4C141,348.53,141.15,360.76,141.09,373Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-6",
					d: "M132.39,309.57c-.06,13-1.18,25.94-2.27,38.57-.91,10.55-1.86,21.45-2.17,32.22-.46,15.7.39,31.88,1.21,47.52,1.4,26.7,2.85,54.31-2.22,80l-1.38-.35c5-25.46,3.59-52.95,2.2-79.54-.82-15.68-1.67-31.9-1.22-47.67.32-10.83,1.26-21.76,2.18-32.33,1.42-16.41,2.88-33.39,2-50.17-.61-11.47-2.33-22.93-4-34-.71-4.7-1.44-9.55-2.08-14.36a429.94,429.94,0,0,1-3.16-77.89l1.4.09A427.25,427.25,0,0,0,126,249.2c.63,4.78,1.36,9.63,2.07,14.32,1.67,11.13,3.4,22.63,4,34.19C132.33,301.66,132.41,305.62,132.39,309.57Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-6",
					d: "M124.39,490.39l-1.33.54c-8.24-27.23-7.16-59.18-5.63-80.85.55-7.85,1.26-15.81,1.95-23.52,1.69-18.87,3.44-38.39,3-57.75-.4-16.24-2.36-32.54-4.26-48.31-1.47-12.23-3-24.88-3.78-37.46-1.48-23.57-.44-47.26.74-69.5l1.41.1c-1.19,22.19-2.22,45.81-.75,69.28.79,12.52,2.31,25.15,3.77,37.35,1.91,15.82,3.87,32.17,4.27,48.49.48,19.47-1.27,39-3,58-.69,7.69-1.4,15.64-2,23.48C117.31,431.73,116.24,463.45,124.39,490.39Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-6",
					d: "M117.07,494.46l-1.38.25c-5-22.58-10.16-45.92-10.16-70.31,0-13.13,1.55-26.27,3-39s3-25.65,3-38.69c0-16.13-2.34-32.25-4.61-47.83-1.16-8-2.35-16.2-3.23-24.37a331.53,331.53,0,0,1,2.83-90.78l1.38.32a329.32,329.32,0,0,0-2.81,90.26c.87,8.13,2.06,16.35,3.22,24.3,2.28,15.65,4.63,31.83,4.63,48.1,0,13.1-1.55,26.23-3,38.91s-3,25.71-3,38.74c0,22.52,4.45,44.22,9.08,65.25l.79-.06Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-6",
					d: "M107.24,480.71l-1.34.51c-8.13-28.62-7-60.64-5.94-91.6.56-15.84,1.13-32.23.47-48.05-1-23.41-4.71-46.57-8.32-69l1.39-.3c3.61,22.45,7.35,45.67,8.33,69.19.67,15.89.09,32.31-.46,48.19C100.3,420.5,99.19,452.37,107.24,480.71Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-6",
					d: "M96.85,467.94l-1.4.2c-2.56-23.2-2.74-47.11-2.92-70.23-.07-9.43-.14-19.18-.38-28.75-.69-28.34-3-64.77-14.58-95.22l1.29-.65c11.7,30.7,14,67.34,14.7,95.82.24,9.59.31,19.35.38,28.79C94.11,421,94.29,444.83,96.85,467.94Z",
					transform: "translate(-69.81 -46.82)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-6",
					d: "M91.77,465.65l-1.38.31a736.6,736.6,0,0,1-9.92-95.08c-.22-5.63-.39-11.4-.55-17-.84-28.65-1.69-58.27-10.11-83.71l1.31-.58c8.5,25.7,9.37,55.45,10.2,84.23.16,5.58.33,11.36.55,17A734.84,734.84,0,0,0,91.77,465.65Z",
					transform: "translate(-69.81 -46.82)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-7",
			x: 164.68,
			y: 469.77,
			width: 2.47,
			height: 11.14,
			transform: "translate(-67.67 -47.56) rotate(0.26)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-8",
			d: "M650.45,317.89c-1.37-2.34-2.73-4.7-4.05-7.08-9.22-16.6-16.81-34.63-15-54q.18-2,.48-3.9A75.13,75.13,0,0,1,637.73,231c2-5.93,4.26-11.83,6.11-17.82.26-1.16.52-2.37.75-3.64,1.67-8,4-14.74,4.13-22.78,2.1-45.58-37.24-72.57-66.1-88.11a290.13,290.13,0,0,0-42.39-19A276.32,276.32,0,0,0,424,64.86q-4.41.38-8.81.88c-26.77,3.23-54,7.13-77.06,25.12-15.93,13.34-29.14,28-46.54,37.34-24.19,12.62-51.72,4.46-78.56,11.71-34.81,9.23-59.25,42.64-64.58,86.86-2.45,19.43,1.91,40.23,10.14,59,1.93,4.51,6,13.53,9.2,22.5,1.74,4,3.37,8.05,5,12.11a175.66,175.66,0,0,1,7.88,26l22.52-.29,338.46-4.35,120-1.54C658.06,333.44,654.69,326.65,650.45,317.89Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-9",
			d: "M679.9,372c-8.23-13.74-13.45-22.77-18.23-31.77l-481,6.18a133.72,133.72,0,0,1,3.58,23.47,126.73,126.73,0,0,1,.55,15.66q-.37,4.56-1.13,9c-.72,9-1.66,17.94-1.81,27a61.47,61.47,0,0,0,2.47,10.57l500.33,2.24a97.07,97.07,0,0,0,2.65-18.2A109.14,109.14,0,0,0,679.9,372Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-10",
			d: "M172.61,320.34C179,337.28,183,352.8,184.29,370.67c.78,10.55-.38,21-1.27,31.38l459.15,2.06.1-60.58c-38.55-1.47-76.64-5.55-116.19-8-88.07-5.57-154.42-66-242.71-69.53-39.51-1.57-77.82,8.71-113.65,20.21-3.51,1.12-6.21,2-9.89,3.12C164.12,299.58,168.65,309.9,172.61,320.34Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-11",
			d: "M674.67,359.9c-2.64-5.39-5.53-10.64-8.54-15.83-8,0-15.93-.24-23.86-.54l-.1,60.58,45,.2C686.1,388.85,681.55,374,674.67,359.9Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M283.93,395a.44.44,0,0,1-.44-.42L282.24,364a.44.44,0,0,1,.88,0l1.25,30.66a.44.44,0,0,1-.42.46Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M208.37,394.7a.33.33,0,0,1-.17,0,.44.44,0,0,1-.22-.58l4.13-9.18a.43.43,0,1,1,.79.36l-4.12,9.18A.46.46,0,0,1,208.37,394.7Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M261.23,394.94a.58.58,0,0,1-.18,0,.44.44,0,0,1-.22-.58l4.13-9.18a.44.44,0,1,1,.8.36l-4.13,9.18A.46.46,0,0,1,261.23,394.94Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-11",
			d: "M218.12,352.37l-16.43,32.84a2.52,2.52,0,0,0,2.24,3.64l70.66.31a2.49,2.49,0,0,0,2.35-1.61l12.62-32.86a2.51,2.51,0,0,0-2.33-3.41l-66.85-.3A2.54,2.54,0,0,0,218.12,352.37Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-11",
			points: "217.49 303.11 219.4 305.42 217.32 306.4 217.49 303.11"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-13",
			points: "130.4 338.95 132.18 341.1 133.93 340.5 132.4 339.03 130.4 338.95"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-13",
			d: "M216.25,350.1l-16.44,32.84a2.51,2.51,0,0,0,2.24,3.63l70.66.32a2.54,2.54,0,0,0,2.36-1.61l12.62-32.86a2.51,2.51,0,0,0-2.34-3.41l-66.85-.3A2.48,2.48,0,0,0,216.25,350.1Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "cls-14",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					className: "cls-15",
					x: 249.7,
					y: 313.46,
					width: .44,
					height: 79.11,
					transform: "translate(-174.03 554.53) rotate(-89.74)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "cls-15",
					x: 247.14,
					y: 319.48,
					width: .44,
					height: 79.11,
					transform: "translate(-182.58 557.96) rotate(-89.74)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "cls-15",
					x: 244.59,
					y: 325.49,
					width: .44,
					height: 79.11,
					transform: "translate(-191.14 561.4) rotate(-89.74)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "cls-15",
					x: 242.03,
					y: 331.5,
					width: .44,
					height: 79.11,
					transform: "translate(-199.7 564.83) rotate(-89.74)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "cls-15",
					x: 239.48,
					y: 337.52,
					width: .44,
					height: 79.11,
					transform: "translate(-208.25 568.26) rotate(-89.74)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "cls-15",
					x: 236.93,
					y: 343.53,
					width: .44,
					height: 79.11,
					transform: "translate(-216.81 571.7) rotate(-89.74)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "cls-15",
					x: 189.19,
					y: 368.46,
					width: 45.33,
					height: .44,
					transform: "translate(-282.07 352.29) rotate(-64.22)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "cls-15",
					x: 202.39,
					y: 368.24,
					width: 45.05,
					height: .44,
					transform: "translate(-273.9 369.61) rotate(-64.98)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "cls-15",
					x: 215.58,
					y: 368.02,
					width: 44.78,
					height: .44,
					transform: "translate(-265.29 387.39) rotate(-65.78)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "cls-15",
					x: 228.76,
					y: 367.8,
					width: 44.51,
					height: .44,
					transform: "translate(-256.28 405.17) rotate(-66.57)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "cls-15",
					x: 241.94,
					y: 367.58,
					width: 44.25,
					height: .44,
					transform: "translate(-246.84 423.15) rotate(-67.36)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "cls-15",
					x: 255.12,
					y: 367.36,
					width: 44,
					height: .44,
					transform: "translate(-237.03 441.04) rotate(-68.13)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M285.57,395.56l-78.4-.36a1.2,1.2,0,1,1,0-2.4l78.4.35a1.21,1.21,0,1,1,0,2.41Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-16",
			d: "M312.92,330.16h13.25a4.25,4.25,0,0,1,4.25,4.25v59a0,0,0,0,1,0,0H308.67a0,0,0,0,1,0,0v-59A4.25,4.25,0,0,1,312.92,330.16Z",
			transform: "translate(-68.18 -48.25) rotate(0.26)"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-12",
			points: "190.96 132.09 187.65 238.84 195.66 238.88 193.19 132.1 190.96 132.09"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M272.51,278.77l-21.08-.09a3.53,3.53,0,1,0,0,7.06l21.08.1a3.54,3.54,0,0,0,0-7.07Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-17",
			d: "M264.51,180.73l-5.4,0a2.48,2.48,0,0,1,0-5l5.39,0a2.48,2.48,0,0,1,0,4.95Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M259.92,167.25c0,6.41-.92,11.61-2,11.6s-1.91-5.2-1.89-11.62a37.07,37.07,0,0,1,2-11.61A37,37,0,0,1,259.92,167.25Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M247.86,184.5c4.73-4.34,9.14-7.22,9.87-6.43s-2.53,4.94-7.25,9.28a37,37,0,0,1-9.87,6.43A37.24,37.24,0,0,1,247.86,184.5Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M267.76,184.59c-4.69-4.38-9.08-7.3-9.81-6.52s2.48,5,7.17,9.34a37,37,0,0,0,9.8,6.52A36.83,36.83,0,0,0,267.76,184.59Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-18",
			d: "M258,179.5H255.9a1.25,1.25,0,1,1,0-2.49h2.14a1.25,1.25,0,1,1,0,2.49Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-19",
			d: "M409.24,253.61a19.25,19.25,0,0,0-2.86,2.91C407.38,255.52,408.34,254.53,409.24,253.61Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M183.78,392.8c-.23,3.09-.5,6.17-.76,9.25l507,2.28,0-9.25Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-12",
			points: "515.28 348.8 250.29 347.61 297.71 252.83 515.71 253.8 515.28 348.8"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-20",
			points: "404.02 278.09 406.15 272.77 294 272.27 256.79 346.63 262.43 346.65 296.97 277.61 404.02 278.09"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-18",
			points: "404.02 278.09 296.97 277.61 262.43 346.65 376.33 347.15 404.02 278.09"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-12",
			x: 406.69,
			y: 226.31,
			width: 218,
			height: 70,
			transform: "matrix(1, 0, 0, 1, -68.63, -49.13)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-21",
			d: "M631.39,256.78c1-10.34,4.33-20.13,7.8-29.92l-130.34-.58-.31,70,130.82.59C633.74,284.24,630.08,270.87,631.39,256.78Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-15",
			d: "M667.31,346.13c-6.78-11.87-14.26-23.36-20.91-35.32-2-3.58-3.89-7.23-5.65-10.94l-149.23-.67L455.1,394l212,.95Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-21",
			d: "M638.92,295.86l-274.63-1.23a2.75,2.75,0,0,0-2.76,2.73v2.5a2.76,2.76,0,0,0,2.74,2.77l278.45,1.25C641.37,301.24,640.1,298.57,638.92,295.86Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M641.3,220.87l-243-1.09a2.36,2.36,0,0,0-2.38,2.36l0,3.25a2.39,2.39,0,0,0,2.37,2.39l240.27,1.08C639.42,226.2,640.37,223.54,641.3,220.87Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-12",
			x: 520.47,
			y: 228.39,
			width: 26,
			height: 166,
			transform: "translate(-68.4 -49.21) rotate(0.26)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-11",
			x: 552.47,
			y: 233.5,
			width: 12,
			height: 155,
			transform: "translate(-68.4 -49.32) rotate(0.26)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-11",
			x: 571.49,
			y: 233.65,
			width: 43,
			height: 33,
			transform: "translate(-68.68 -49.47) rotate(0.26)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-11",
			x: 568.3,
			y: 343.59,
			width: 21,
			height: 13,
			transform: "translate(-68.23 -49.41) rotate(0.26)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-11",
			x: 406.68,
			y: 233.03,
			width: 93,
			height: 62,
			transform: "translate(-68.62 -48.85) rotate(0.26)"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-13",
			points: "438.51 298.46 415.51 298.36 415.5 301.02 435 301.11 434.79 347.44 438.29 347.46 438.51 298.46"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-11",
			x: 471.78,
			y: 361.3,
			width: 46.33,
			height: 19.5,
			transform: "translate(51.88 817.51) rotate(-89.74)"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-11",
			points: "536.29 347.9 543.29 347.93 543.55 289.89 536.55 289.81 536.29 347.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-11",
			d: "M658.9,332l-52.52-.24,0,4.92,7,.08s48.52.17,48.52.17C660.89,335.24,659.9,333.59,658.9,332Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-11",
			d: "M667.31,346.13c-1.77-3.1-3.59-6.18-5.43-9.25l-48.52-.21-.26,58.07,54,.25Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-13",
			x: 452.78,
			y: 196.7,
			width: 1,
			height: 92.98,
			transform: "translate(138.25 648.57) rotate(-89.74)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-13",
			x: 454.16,
			y: 268.65,
			width: 51.67,
			height: 1,
			transform: "translate(138.89 701.11) rotate(-89.74)"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-22",
			points: "390.9 347.4 389.97 347.05 422.33 261.38 450.7 261.51 450.69 262.51 423.02 262.39 390.9 347.4"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-23",
			x: 504.66,
			y: 288.38,
			width: 1,
			height: 30.68,
			transform: "matrix(0, -1, 1, 0, 129.37, 760.7)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-23",
			x: 509.62,
			y: 284.7,
			width: 1,
			height: 21.17,
			transform: "translate(142.75 757.26) rotate(-89.74)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-22",
			d: "M635.51,287.09l-67.93-.3.25-55.5,69.7.31c.12-.33.23-.66.34-1l-71-.31-.26,57.49,69.27.32Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-22",
			x: 546.34,
			y: 340.52,
			width: 107.33,
			height: 1,
			transform: "translate(186.49 892.67) rotate(-89.74)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-22",
			x: 581.48,
			y: 320.74,
			width: 1,
			height: 35.23,
			transform: "matrix(0, -1, 1, 0, 171.21, 872)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-22",
			d: "M515.13,317.8a3.19,3.19,0,1,1,3.2-3.17A3.19,3.19,0,0,1,515.13,317.8Zm0-5.37a2.19,2.19,0,1,0,2.18,2.2A2.2,2.2,0,0,0,515.15,312.43Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-13",
			points: "399.74 248.28 398.74 248.28 398.91 208.66 379.04 208.56 378.86 248.19 377.86 248.19 378.04 207.56 399.92 207.66 399.74 248.28"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M368,294.64h-2l.06-11.91a4.59,4.59,0,0,1,4.61-4.57l132.4.59v2l-132.41-.59a2.58,2.58,0,0,0-2.6,2.58Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-12",
			x: 388.25,
			y: 285.6,
			width: 16.33,
			height: 2,
			transform: "translate(38.23 634.91) rotate(-89.74)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-12",
			x: 436.74,
			y: 285.82,
			width: 16.33,
			height: 2,
			transform: "translate(86.29 683.63) rotate(-89.74)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-12",
			x: 485.24,
			y: 286.04,
			width: 16.33,
			height: 2,
			transform: "translate(134.35 732.34) rotate(-89.74)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-13",
			x: 592.53,
			y: 221.53,
			width: 1,
			height: 42.75,
			transform: "translate(277.66 788.02) rotate(-89.74)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-13",
			x: 580.85,
			y: 254.28,
			width: 23.75,
			height: 1,
			transform: "translate(265.48 799.53) rotate(-89.74)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-13",
			x: 558.26,
			y: 240.25,
			width: 1,
			height: 12,
			transform: "translate(240.2 757.08) rotate(-89.74)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-13",
			x: 558.19,
			y: 256.36,
			width: 1,
			height: 12,
			transform: "matrix(0, -1, 1, 0, 224.01, 773.05)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-13",
			x: 558.12,
			y: 272.48,
			width: 1,
			height: 12,
			transform: "translate(207.83 789.02) rotate(-89.74)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-13",
			x: 558.04,
			y: 288.59,
			width: 1,
			height: 12,
			transform: "matrix(0, -1, 1, 0, 191.64, 804.99)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-13",
			x: 557.97,
			y: 304.71,
			width: 1,
			height: 12,
			transform: "translate(175.46 820.96) rotate(-89.74)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-13",
			x: 557.9,
			y: 320.82,
			width: 1,
			height: 12,
			transform: "translate(159.27 836.93) rotate(-89.74)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-13",
			x: 557.83,
			y: 336.94,
			width: 1,
			height: 12,
			transform: "translate(143.08 852.9) rotate(-89.74)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-13",
			x: 557.75,
			y: 353.05,
			width: 1,
			height: 12,
			transform: "translate(126.9 868.87) rotate(-89.74)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-13",
			x: 557.68,
			y: 369.16,
			width: 1,
			height: 12,
			transform: "translate(110.71 884.84) rotate(-89.74)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M618.44,220.33a.76.76,0,0,1-.75-.72l-2.15-52.9a.76.76,0,0,1,.72-.79.77.77,0,0,1,.79.73l2.15,52.9a.74.74,0,0,1-.72.78Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M488.11,219.75a.7.7,0,0,1-.31-.07.76.76,0,0,1-.38-1l7.13-15.83a.75.75,0,1,1,1.37.62L488.8,219.3A.76.76,0,0,1,488.11,219.75Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M579.28,220.16a.7.7,0,0,1-.31-.07.75.75,0,0,1-.37-1l7.12-15.83a.76.76,0,0,1,1.38.62L580,219.71A.75.75,0,0,1,579.28,220.16Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-11",
			d: "M504.93,146.73l-28.35,56.65a4.33,4.33,0,0,0,3.85,6.27l121.9.55a4.34,4.34,0,0,0,4.07-2.78l21.77-56.68a4.33,4.33,0,0,0-4-5.89l-115.32-.52A4.32,4.32,0,0,0,504.93,146.73Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-11",
			points: "554.44 95.7 557.74 99.68 554.15 101.37 554.44 95.7"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-13",
			points: "404.2 157.52 407.28 161.24 410.3 160.19 407.66 157.66 404.2 157.52"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-13",
			d: "M501.69,142.81l-28.35,56.65a4.33,4.33,0,0,0,3.85,6.27l121.91.55a4.33,4.33,0,0,0,4.06-2.78l21.77-56.69a4.32,4.32,0,0,0-4-5.88l-115.33-.52A4.31,4.31,0,0,0,501.69,142.81Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "cls-24",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					className: "cls-15",
					x: 559.39,
					y: 79.61,
					width: .76,
					height: 136.48,
					transform: "matrix(0, -1, 1, 0, 339.61, 660.13)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "cls-15",
					x: 554.98,
					y: 89.98,
					width: .76,
					height: 136.48,
					transform: "matrix(0, -1, 1, 0, 324.85, 666.05)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "cls-15",
					x: 550.58,
					y: 100.36,
					width: .76,
					height: 136.48,
					transform: "translate(310.08 671.97) rotate(-89.74)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "cls-15",
					x: 546.17,
					y: 110.73,
					width: .76,
					height: 136.48,
					transform: "translate(295.32 677.9) rotate(-89.74)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "cls-15",
					x: 541.77,
					y: 121.11,
					width: .76,
					height: 136.48,
					transform: "translate(280.56 683.82) rotate(-89.74)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "cls-15",
					x: 537.36,
					y: 131.48,
					width: .76,
					height: 136.48,
					transform: "translate(265.8 689.74) rotate(-89.74)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "cls-15",
					x: 455.02,
					y: 174.48,
					width: 78.21,
					height: .76,
					transform: "translate(52 496.97) rotate(-64.23)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "cls-15",
					x: 477.78,
					y: 174.1,
					width: 77.72,
					height: .76,
					transform: "translate(70.24 522.04) rotate(-64.98)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "cls-15",
					x: 500.53,
					y: 173.72,
					width: 77.24,
					height: .76,
					transform: "translate(89.43 547.6) rotate(-65.79)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "cls-15",
					x: 523.28,
					y: 173.34,
					width: 76.78,
					height: .76,
					transform: "translate(109.07 573.14) rotate(-66.56)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "cls-15",
					x: 546.02,
					y: 172.97,
					width: 76.34,
					height: .76,
					transform: "translate(129.51 598.96) rotate(-67.36)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "cls-15",
					x: 568.75,
					y: 172.59,
					width: 75.91,
					height: .76,
					transform: "translate(150.46 624.82) rotate(-68.14)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-12",
			x: 483.96,
			y: 216.77,
			width: 139.41,
			height: 4.16,
			rx: 1.38,
			transform: "translate(-68.82 -49.3) rotate(0.26)"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-12",
			points: "249 106.85 243.52 283.52 256.78 283.58 252.68 106.87 249 106.85"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-17",
			x: 311.99,
			y: 148.47,
			width: 17.12,
			height: 8.19,
			rx: 2.48,
			transform: "translate(-69.12 -48.25) rotate(0.26)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M317.41,134.37c-.05,10.62-1.52,19.22-3.29,19.21S311,145,311,134.35a61.44,61.44,0,0,1,3.28-19.21A61.06,61.06,0,0,1,317.41,134.37Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M297.45,162.92c7.82-7.18,15.13-11.94,16.33-10.64s-4.18,8.18-12,15.36a61.18,61.18,0,0,1-16.33,10.64A61.35,61.35,0,0,1,297.45,162.92Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M330.38,163.07c-7.76-7.25-15-12.08-16.23-10.79s4.1,8.22,11.86,15.47a61.15,61.15,0,0,0,16.23,10.78A61.22,61.22,0,0,0,330.38,163.07Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-18",
			x: 308.7,
			y: 150.52,
			width: 7.66,
			height: 4.12,
			rx: 1.25,
			transform: "translate(-69.12 -48.22) rotate(0.26)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-15",
			d: "M684.64,434.3l-500.33-2.24a70.47,70.47,0,0,0,23.82,33.1L670,467.24A101.46,101.46,0,0,0,684.64,434.3Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-9",
			d: "M667.5,470.82q1.31-1.77,2.53-3.58l-461.9-2.08c14.27,11.2,33.21,18.15,54.37,18.25l371.3,1.66C646.45,485.13,658.37,479.87,667.5,470.82Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M646.33,203.89l-237.88-1.07a7.52,7.52,0,0,0-7.53,7.47l-.06,12.5h2l.06-12.5a5.51,5.51,0,0,1,5.53-5.48l237.42,1.07C646,205.23,646.18,204.56,646.33,203.89Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-12",
			x: 439.83,
			y: 211.59,
			width: 17.17,
			height: 2,
			transform: "translate(164.01 613.22) rotate(-89.74)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-12",
			x: 488.33,
			y: 211.8,
			width: 17.17,
			height: 2,
			transform: "translate(212.07 661.94) rotate(-89.74)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-12",
			x: 536.83,
			y: 212.02,
			width: 17.17,
			height: 2,
			transform: "matrix(0, -1, 1, 0, 260.14, 710.65)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-12",
			x: 585.33,
			y: 212.24,
			width: 17.17,
			height: 2,
			transform: "translate(308.2 759.37) rotate(-89.74)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-13",
			d: "M620.53,394.78h-1l.23-51.26h.5c14.91.07,29,.13,44.23,0v1c-15.07.1-29,0-43.75,0Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-13",
			x: 634.24,
			y: 337.48,
			width: 12.25,
			height: 1,
			transform: "matrix(0, -1, 1, 0, 229.71, 930)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-13",
			x: 612.81,
			y: 343.56,
			width: 1,
			height: 14,
			transform: "translate(190.19 915.48) rotate(-89.74)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-13",
			x: 646.65,
			y: 331.51,
			width: 1,
			height: 53.58,
			transform: "translate(216.15 957.02) rotate(-89.74)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M183.27,399.05c-.07.89-.15,1.78-.22,2.67l108.94.49v-2.67Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-20",
			points: "292.32 280.79 292.32 281.79 402.35 282.28 402.75 281.28 292.32 280.79"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-20",
			points: "289.09 287.57 289.08 288.57 399.62 289.07 400.02 288.07 289.09 287.57"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-20",
			points: "285.85 294.37 285.85 295.37 396.89 295.86 397.29 294.87 285.85 294.37"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-20",
			points: "282.62 301.15 282.61 302.15 394.16 302.65 394.56 301.66 282.62 301.15"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-20",
			points: "279.38 307.94 279.38 308.94 391.43 309.45 391.83 308.45 279.38 307.94"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-20",
			points: "276.15 314.73 276.14 315.73 388.7 316.24 389.1 315.24 276.15 314.73"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-20",
			points: "272.91 321.52 272.91 322.52 385.97 323.03 386.37 322.03 272.91 321.52"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-20",
			points: "269.68 328.31 269.67 329.31 383.24 329.82 383.64 328.82 269.68 328.31"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-20",
			points: "266.44 335.1 266.44 336.1 380.5 336.62 380.91 335.62 266.44 335.1"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-20",
			points: "263.2 341.89 263.2 342.89 377.77 343.41 378.18 342.41 263.2 341.89"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-25",
			x: 314.13,
			y: 390.83,
			width: .99,
			height: 4.11,
			transform: "translate(-149.48 658.93) rotate(-89.74)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M321,380.94c.11,7.39-3.91,12.47-8.2,12.45-4.5,0-8.12-5.41-8.09-12,0-.16,0-.32,0-.48Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-26",
			d: "M324.88,381.44c0,6.63-3.7,12-8.2,12s-8.12-5.42-8.09-12,3.7-12,8.2-12S324.91,374.81,324.88,381.44Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-27",
			d: "M311.66,381.61c0,4.7,2.32,8.53,5.23,8.54s5.28-3.79,5.3-8.5-2.32-8.52-5.23-8.54S311.68,376.9,311.66,381.61Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M316.5,374.19a3.07,3.07,0,0,1,1.34.11C317.69,375.55,316.56,375.46,316.5,374.19Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M318.86,374.83A5.08,5.08,0,0,1,320,376C319.47,377,318.51,376,318.86,374.83Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M320.69,377.29a9.47,9.47,0,0,1,.61,1.93C320.57,379.64,320,378,320.69,377.29Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M321.52,380.91a11.67,11.67,0,0,1-.07,2.17C320.68,382.85,320.75,381,321.52,380.91Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M321.12,384.73a9.6,9.6,0,0,1-.73,1.82C319.79,385.72,320.41,384.19,321.12,384.73Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M319.59,387.71a4.39,4.39,0,0,1-1.19,1C318.13,387.5,319.15,386.68,319.59,387.71Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M317.35,389.07A2.87,2.87,0,0,1,316,389C316.15,387.71,317.29,387.8,317.35,389.07Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M315,388.43a5.07,5.07,0,0,1-1.12-1.18C314.38,386.29,315.33,387.28,315,388.43Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M313.16,386a9.09,9.09,0,0,1-.61-1.93C313.28,383.62,313.8,385.24,313.16,386Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M312.33,382.35a10.92,10.92,0,0,1,.07-2.17C313.17,380.42,313.1,382.25,312.33,382.35Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M312.73,378.54a9.44,9.44,0,0,1,.73-1.83C314.06,377.55,313.43,379.07,312.73,378.54Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M314.26,375.55a4.39,4.39,0,0,1,1.19-1C315.71,375.76,314.7,376.59,314.26,375.55Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M317,379.46c.3,0,.3-.74,0-.74S316.71,379.46,317,379.46Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M317.58,379.31c-.15.43.25.78.4.37a.53.53,0,0,0-.08-.51C317.79,379.07,317.65,379.13,317.58,379.31Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M318.13,380.65c.15.42.55.06.39-.37S318,380.23,318.13,380.65Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M318.27,381.75c0,.5.45.49.45,0S318.27,381.27,318.27,381.75Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M318,382.82c-.15.44.25.79.4.38S318.19,382.41,318,382.82Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M317.83,383.71c-.06-.18-.2-.24-.31-.14-.26.25,0,.89.23.64A.48.48,0,0,0,317.83,383.71Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M316.84,383.8c-.3,0-.3.74,0,.74S317.14,383.8,316.84,383.8Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M316.18,383.45c-.26-.25-.49.39-.23.64S316.44,383.69,316.18,383.45Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M315.72,382.61c-.15-.42-.55-.06-.4.37S315.87,383,315.72,382.61Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M315.58,381.51c0-.49-.45-.49-.46,0S315.58,382,315.58,381.51Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M315.49,380.57c.26.24.49-.38.23-.64S315.23,380.32,315.49,380.57Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M316.32,379.69a.52.52,0,0,0,.09-.51c-.06-.17-.2-.24-.31-.13C315.83,379.29,316.06,379.93,316.32,379.69Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M316,381.63c0,.86.42,1.56,1,1.57s1-.7,1-1.56-.42-1.57-1-1.57S316,380.76,316,381.63Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-11",
			d: "M417.41,341.67l1,0a31.77,31.77,0,0,1,7,5.27l-.06,2.23-8-5.67Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-13",
			d: "M298.41,375.89c.1-.56.22-1.12.36-1.67a4,4,0,0,0,5.94-1.73,4.74,4.74,0,0,0-1.59-5.76c5.19-4.45,17.06-9.8,17.24-9.87,10.29-7.64,18.66-12.95,34.9-17.3a33.36,33.36,0,0,1,7.84-.88l47.2.22a19.48,19.48,0,0,1,8.14,2.76l-1,0v-.13l0,.13h-.45l.49,0,0,1.81-.64-.46.64.46,0,1.89,0-1.89,8,5.67-1,36.32-22.45-.1-28.36-.13a1.3,1.3,0,0,1-1.29-1.3l0-2.65-15.81-.08,0,4-55.87-.25a2.35,2.35,0,0,0-2.3-2.87h-.13A25.84,25.84,0,0,1,298.41,375.89Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-11",
			d: "M435.26,373.94a4.58,4.58,0,0,1,1.61,3.51,5.65,5.65,0,0,1,0,.59,1.64,1.64,0,0,1,0,.23l0,6a1.29,1.29,0,0,1-1.29,1.29l-11.15,0,1-38.55C430.67,352.24,435.21,360.73,435.26,373.94Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-28",
			d: "M304.74,372.42a4.76,4.76,0,0,0-1.62-5.69,10.36,10.36,0,0,0-1.86,2,2.39,2.39,0,0,0-.13.21,17.93,17.93,0,0,0-2.36,5.32A4,4,0,0,0,304.74,372.42Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-25",
			x: 390.66,
			y: 391.17,
			width: .99,
			height: 4.11,
			transform: "translate(-73.63 735.81) rotate(-89.74)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M397.56,381.29c.2,6.11-3.17,12.46-8.19,12.44-4.5,0-8.12-5.41-8.09-12,0-.16,0-.32,0-.48Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-26",
			d: "M401.42,381.78c0,6.63-3.7,12-8.2,12s-8.12-5.41-8.09-12,3.7-12,8.2-12S401.45,375.15,401.42,381.78Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-27",
			d: "M388.19,382c0,4.71,2.33,8.53,5.23,8.54s5.29-3.79,5.31-8.49-2.32-8.53-5.23-8.54S388.22,377.25,388.19,382Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M393,374.54a2.82,2.82,0,0,1,1.34.11C394.23,375.89,393.1,375.81,393,374.54Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M395.39,375.18a5.26,5.26,0,0,1,1.13,1.17C396,377.31,395.05,376.34,395.39,375.18Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M397.23,377.63a10.13,10.13,0,0,1,.61,1.93C397.1,380,396.58,378.36,397.23,377.63Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M398.06,381.25a11,11,0,0,1-.08,2.17C397.22,383.19,397.28,381.36,398.06,381.25Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M397.65,385.07a8.75,8.75,0,0,1-.73,1.82C396.32,386.06,397,384.53,397.65,385.07Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M396.13,388.05a4.4,4.4,0,0,1-1.2,1C394.67,387.84,395.68,387,396.13,388.05Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M393.88,389.41a2.83,2.83,0,0,1-1.33-.11C392.69,388.06,393.82,388.14,393.88,389.41Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M391.53,388.77a5,5,0,0,1-1.12-1.17C390.92,386.64,391.87,387.62,391.53,388.77Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M389.69,386.31a9.81,9.81,0,0,1-.61-1.92C389.82,384,390.34,385.59,389.69,386.31Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M388.86,382.69a12.65,12.65,0,0,1,.07-2.16C389.7,380.76,389.64,382.59,388.86,382.69Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M389.27,378.88a8,8,0,0,1,.73-1.82C390.6,377.9,390,379.41,389.27,378.88Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M390.8,375.89a4.58,4.58,0,0,1,1.19-1C392.25,376.11,391.23,376.93,390.8,375.89Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M393.54,379.8c.3,0,.31-.73,0-.73S393.24,379.8,393.54,379.8Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M394.2,380.16c.27.24.5-.4.24-.64S393.94,379.9,394.2,380.16Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M394.66,381c.16.43.55.06.4-.36S394.51,380.57,394.66,381Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M394.8,382.1c0,.49.46.48.46,0S394.8,381.61,394.8,382.1Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M394.9,383c-.26-.25-.5.39-.24.63S395.16,383.29,394.9,383Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M394.06,383.92c-.26.24,0,.88.23.64S394.32,383.68,394.06,383.92Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M393.6,384.52c0-.49-.45-.49-.45,0S393.6,385,393.6,384.52Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M392.72,383.79c-.26-.24-.5.39-.23.64S393,384,392.72,383.79Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M392.26,383c-.16-.42-.55-.06-.4.37S392.41,383.37,392.26,383Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M392.12,381.85c0-.49-.46-.49-.46,0S392.12,382.34,392.12,381.85Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M392,380.92c.26.23.49-.39.23-.65S391.76,380.66,392,380.92Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M392.86,380c.27-.24,0-.88-.22-.64S392.6,380.27,392.86,380Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M392.49,382c0,.86.43,1.57,1,1.57s1-.7,1-1.56-.43-1.57-1-1.57S392.5,381.11,392.49,382Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-29",
			d: "M411.09,341.59v0Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-13",
			d: "M436.17,377.45c0-1.4-1.53-2.67-2.5-3.52a37.9,37.9,0,0,0-1.5-16.3l-5.75-.14a10.87,10.87,0,0,1-9.73-6.77l-3.23-7.79a.89.89,0,0,1,.83-1.27h4.18c-4.55-1.9-4.67-1.56-17-1.62-2.89,0-4.65-.16-7.37.75-11.43,3.79-16.65,9.16-19.34,12.81a13.75,13.75,0,0,1-6.34,4.78c-14.24,5.2-18.58,10.23-18.93,10.72l-.1.15a10.08,10.08,0,0,0-1.31,6.85,18.36,18.36,0,0,0,.37,2h-.11l0,7,50.59.23h3l13.74.06,19.16.09a1.3,1.3,0,0,0,1.28-1.29l0-6a1.94,1.94,0,0,0,0-.24A5.44,5.44,0,0,0,436.17,377.45Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M360.87,369.6c-3.59,1.74-6.16,6.25-6.19,11.55a16.26,16.26,0,0,0,.49,4l9.1,0,.07-15.59Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M364.18,368.83a7.41,7.41,0,0,0-3.31.77h3.47l-.07,15.59,8.78,0C375.15,377.32,370.72,368.86,364.18,368.83Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-13",
			d: "M411.87,379.88c.25-.89.15.71.66-22.7l-2.91-14.49a2.13,2.13,0,0,0-2.06-1.7l-8.77,0a15.18,15.18,0,0,0-5.38,1c-3.89,1.44-10.84,4.57-15.34,9.73a13.23,13.23,0,0,0-3.17,8.62l-.06,13.27a10.26,10.26,0,0,0,2,6.19Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-11",
			d: "M411.85,380.13,376.79,380a.26.26,0,0,1-.2-.1,10.58,10.58,0,0,1-2-6.34l.06-13.27a13.43,13.43,0,0,1,3.23-8.78c4.56-5.23,11.63-8.39,15.45-9.81a15.63,15.63,0,0,1,5.46-1l8.77,0a2.37,2.37,0,0,1,2.3,1.9l2.92,14.49c-.12,5.4-.2,9.45-.27,12.51-.2,9.65-.2,9.65-.36,10.18l0,.13A.26.26,0,0,1,411.85,380.13Zm-34.93-.66,34.74.16c.13-.43.14-.84.33-10,.07-3.06.15-7.11.27-12.46l-2.91-14.43a1.87,1.87,0,0,0-1.81-1.5l-8.77,0a15.17,15.17,0,0,0-5.29.94c-3.77,1.4-10.76,4.52-15.24,9.67a12.94,12.94,0,0,0-3.11,8.45l-.06,13.27A10.09,10.09,0,0,0,376.92,379.47Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-11",
			d: "M407.11,383.7l-24.25-.1a10,10,0,0,1-3.84-1.47.24.24,0,0,1-.11-.28.27.27,0,0,1,.24-.18l31.42.14a.28.28,0,0,1,.23.16.26.26,0,0,1-.06.27A5.14,5.14,0,0,1,407.11,383.7Zm-27-1.52a9.66,9.66,0,0,0,2.81.92l24.21.1a4.56,4.56,0,0,0,2.77-.89Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M377.91,354.93c-.09.24-.64,1.95,1.07,2.1l4.6,0,0-8.46A24.59,24.59,0,0,0,377.91,354.93Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-25",
			x: 361.61,
			y: 391.05,
			width: .99,
			height: 4.11,
			transform: "translate(-102.42 706.63) rotate(-89.74)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M368.52,381.16l-8.11,0,0,4.06-7.81,0c1,4.88,4.09,8.43,7.74,8.45C364.62,393.62,368.62,388.54,368.52,381.16Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-26",
			d: "M372.37,381.65c0,6.63-3.7,12-8.2,12s-8.12-5.41-8.09-12,3.7-12,8.2-12S372.4,375,372.37,381.65Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-27",
			d: "M359.14,381.82c0,4.7,2.32,8.53,5.23,8.54s5.28-3.79,5.3-8.49-2.32-8.53-5.22-8.54S359.16,377.11,359.14,381.82Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M364.37,380.29c.23,0,.24-.57,0-.57S364.13,380.29,364.37,380.29Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M364.82,380.17c-.12.34.19.62.31.3S364.94,379.85,364.82,380.17Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M365.25,381.23c.11.33.43,0,.31-.29S365.13,380.89,365.25,381.23Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M365.35,382.09c0,.39.36.39.36,0S365.36,381.71,365.35,382.09Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M365.18,382.93c-.12.35.2.62.31.3S365.3,382.61,365.18,382.93Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M364.77,383.52c-.2.19,0,.7.18.51S365,383.33,364.77,383.52Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M364.41,384c0-.39-.35-.39-.35,0S364.41,384.38,364.41,384Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M363.72,383.43c-.21-.2-.39.31-.18.5S363.92,383.61,363.72,383.43Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M363.36,382.77c-.12-.34-.43,0-.31.28S363.48,383.1,363.36,382.77Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M363.25,381.9c0-.39-.36-.38-.36,0S363.25,382.29,363.25,381.9Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M363.42,381.06c.12-.34-.19-.61-.31-.29S363.3,381.39,363.42,381.06Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M363.83,380.47c.21-.18,0-.69-.17-.5S363.63,380.66,363.83,380.47Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-11",
			d: "M436.25,378.27l-5.34,0a1.2,1.2,0,0,1,0-2.33l5.34,0c.51,0,.9.51.9,1.17A1.05,1.05,0,0,1,436.25,378.27Zm-5.33-1.86c-.2,0-.41.27-.41.67s.21.66.4.66l5.34,0c.19,0,.41-.28.41-.67s-.21-.66-.41-.66Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M420.05,369.86c-3.59,1.74-6.16,6.26-6.19,11.56a15.85,15.85,0,0,0,.5,4l9.09,0,.07-15.59Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M432.75,381.5c0-8.59-6.5-14.64-12.7-11.64l3.47,0-.07,15.59,8.78,0A15.79,15.79,0,0,0,432.75,381.5Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-25",
			x: 420.79,
			y: 391.31,
			width: .99,
			height: 4.11,
			transform: "translate(-43.77 766.07) rotate(-89.74)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M427.7,381.42l-8.11,0,0,4.06-7.81,0c1,4.89,4.09,8.44,7.74,8.46C423.68,393.89,427.78,389,427.7,381.42Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-26",
			d: "M431.55,381.92c0,6.63-3.7,12-8.2,12s-8.12-5.41-8.09-12,3.7-12,8.2-12S431.58,375.29,431.55,381.92Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-27",
			d: "M418.32,382.09c0,4.7,2.32,8.52,5.23,8.54s5.28-3.79,5.3-8.5-2.31-8.53-5.22-8.54S418.35,377.38,418.32,382.09Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M423.53,380.27c0,.16.08.29.18.29s.18-.13.18-.29C423.89,379.89,423.53,379.89,423.53,380.27Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M424.16,380.44a.42.42,0,0,0,.06.4c.09.08.2,0,.25-.11a.38.38,0,0,0-.06-.39C424.32,380.26,424.21,380.3,424.16,380.44Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M424.66,381.1a.4.4,0,0,0-.07.4c.05.14.16.18.24.1a.38.38,0,0,0,.07-.39C424.85,381.07,424.74,381,424.66,381.1Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M424.88,382.07c-.1,0-.18.13-.18.29s.08.29.18.29.17-.13.17-.29S425,382.07,424.88,382.07Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M424.77,383.1c-.09-.08-.2,0-.25.1a.4.4,0,0,0,.07.4c.08.08.19,0,.24-.11A.4.4,0,0,0,424.77,383.1Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M424.36,383.9c-.05-.14-.16-.19-.25-.11a.42.42,0,0,0-.06.4c0,.13.15.18.24.1A.38.38,0,0,0,424.36,383.9Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M423.76,384.26c0-.38-.36-.39-.36,0,0,.16.08.29.18.29S423.76,384.42,423.76,384.26Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M423.06,383.69c-.21-.19-.39.31-.18.5S423.27,383.88,423.06,383.69Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M422.7,383c-.12-.33-.43,0-.31.29S422.82,383.36,422.7,383Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M422.59,382.17c0-.39-.36-.39-.36,0S422.59,382.55,422.59,382.17Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M422.76,381.33c.12-.34-.19-.62-.31-.29S422.65,381.65,422.76,381.33Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M423.17,380.74c.21-.19,0-.69-.17-.5S423,380.93,423.17,380.74Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-26",
			d: "M390.16,341.12c.81-.23.5-1.39-.35-1.4H389c-34.76-.16-33.2-.3-35.09.22-13.28,3.68-20.77,7.63-31.87,15.69-.38.28-.36.78.12.78l43.35.2c2.2,0,5.66-1,6.9-2.8A31.92,31.92,0,0,1,390.16,341.12Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-26",
			d: "M389.85,339.72H389l-16.25-.08a32,32,0,0,0-12.91,10.89c-1.25,1.77-4.7,2.81-6.91,2.8l-27.48-.13c-1.11.77-2.24,1.58-3.42,2.43-.38.28-.35.78.12.78l43.35.2c2.2,0,5.66-1,6.91-2.8a31.93,31.93,0,0,1,17.78-12.69C391,340.89,390.7,339.73,389.85,339.72Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-26",
			d: "M410.29,353.55l-1.69-9.81a2,2,0,0,0-1.93-1.63l-8.62,0a10.23,10.23,0,0,0-3.94.76,46.77,46.77,0,0,0-10.49,5.76V354l0,3.05,23.67.1A3.07,3.07,0,0,0,410.29,353.55Zm-1.42,0h0Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-26",
			d: "M410.29,353.55l-1.69-9.81a1.93,1.93,0,0,0-1-1.4s1.44,8.35,1.45,8.37a3.08,3.08,0,0,1-3,3.6l-22.38-.1,0,2.84,23.67.1A3.07,3.07,0,0,0,410.29,353.55Zm-1.42,0h0Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M390.08,357.1a1.94,1.94,0,0,1-1.85,2l-5.31,0a1.93,1.93,0,0,1-1.84-2v-1.68a2,2,0,0,1,1.85-2l5.31,0a1.93,1.93,0,0,1,1.84,2Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-11",
			x: 305.8,
			y: 370.5,
			width: 26.48,
			height: 5.23,
			rx: 2.59,
			transform: "translate(-68.13 -48.24) rotate(0.26)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-28",
			d: "M341.38,373.56a4,4,0,0,1-6.85-.94l0-.07c-.91-2.51.15-5.21,2.36-6l6.65-.81a2,2,0,0,1,1.72,3.44C344,370.5,342.6,372,341.38,373.56Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-11",
			d: "M301.38,376.06h44.09a4.43,4.43,0,0,1,4.43,4.43v.11a4.43,4.43,0,0,1-4.43,4.43h-44a4.43,4.43,0,0,1-4.43-4.43v-.24A4.29,4.29,0,0,1,301.38,376.06Z",
			transform: "translate(-68.09 -48.26) rotate(0.26)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-13",
			x: 300.85,
			y: 378.33,
			width: 40.72,
			height: 5.23,
			rx: 2.59,
			transform: "translate(-68.09 -48.25) rotate(0.26)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M304.06,383a1.25,1.25,0,0,1-1.25-1.23v-1.44a1.23,1.23,0,0,1,1.23-1.22,1.25,1.25,0,0,1,1.25,1.23v1.44A1.23,1.23,0,0,1,304.06,383Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M338.86,382.92a1.24,1.24,0,0,1-1.25-1.23v-1.44a1.24,1.24,0,0,1,2.47,0v1.44A1.24,1.24,0,0,1,338.86,382.92Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-11",
			d: "M409.49,361.05l-6.56,0a1.37,1.37,0,0,1,0-2.73l6.56,0a1.37,1.37,0,0,1,0,2.73Zm-6.55-2.26a.87.87,0,0,0,0,1.73l6.56,0a.87.87,0,0,0,0-1.73Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-11",
			d: "M425.91,348a20.25,20.25,0,0,0-8.39-6.34L413,341.4a1.09,1.09,0,0,0-1.06,1.51l3.23,7.67a11.35,11.35,0,0,0,10.23,6.94l5.66.11A32.87,32.87,0,0,0,425.91,348Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-26",
			d: "M429.27,353.32l-5-.1a11.34,11.34,0,0,1-10.22-6.94l-1.91-4.52a1,1,0,0,0-.21,1.15l3.23,7.68a11.32,11.32,0,0,0,10.23,6.93l5.66.11A34,34,0,0,0,429.27,353.32Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-22",
			d: "M432.83,365.36c0,2.08-1.26,3.77-2.78,3.76s-2.76-1.7-2.75-3.79,1.25-3.77,2.78-3.77S432.84,363.27,432.83,365.36Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-21",
			d: "M429.76,369.37c-1.66,0-3-1.82-3-4s1.37-4,3-4,3,1.82,3,4.05S431.43,369.38,429.76,369.37Zm0-7.56c-1.39,0-2.52,1.57-2.53,3.52s1.11,3.54,2.5,3.54,2.52-1.57,2.53-3.52S431.18,361.82,429.8,361.81Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-12",
			cx: 301.16,
			cy: 320.94,
			r: 1.11
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M363.92,374.06a3.1,3.1,0,0,1,1.34.11C365.12,375.42,364,375.34,363.92,374.06Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M366.28,374.7a5.08,5.08,0,0,1,1.12,1.18C366.89,376.84,365.94,375.86,366.28,374.7Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M368.11,377.16a9.28,9.28,0,0,1,.61,1.93C368,379.51,367.46,377.89,368.11,377.16Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M368.94,380.78a10.79,10.79,0,0,1-.07,2.16C368.1,382.72,368.17,380.88,368.94,380.78Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M368.54,384.6a9.6,9.6,0,0,1-.73,1.82C367.21,385.59,367.84,384.06,368.54,384.6Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M367,387.58a4.28,4.28,0,0,1-1.2,1C365.55,387.37,366.57,386.55,367,387.58Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M364.77,388.94a2.87,2.87,0,0,1-1.34-.11C363.57,387.58,364.71,387.66,364.77,388.94Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M362.41,388.3a5.07,5.07,0,0,1-1.12-1.18C361.8,386.16,362.75,387.15,362.41,388.3Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M360.58,385.84a9.09,9.09,0,0,1-.61-1.93C360.7,383.49,361.22,385.11,360.58,385.84Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M359.75,382.22a11,11,0,0,1,.07-2.17C360.59,380.29,360.52,382.12,359.75,382.22Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M360.15,378.41a9.44,9.44,0,0,1,.73-1.83C361.48,377.42,360.85,378.94,360.15,378.41Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M361.68,375.42a4.39,4.39,0,0,1,1.19-1C363.14,375.64,362.12,376.45,361.68,375.42Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M423.28,374.42a3,3,0,0,1,1.34.11C424.47,375.77,423.34,375.69,423.28,374.42Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M425.63,375.06a4.91,4.91,0,0,1,1.13,1.18C426.25,377.19,425.29,376.22,425.63,375.06Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M427.47,377.52a9.09,9.09,0,0,1,.61,1.93C427.34,379.87,426.82,378.25,427.47,377.52Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M428.3,381.14a10.83,10.83,0,0,1-.07,2.16C427.46,383.07,427.52,381.24,428.3,381.14Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M427.9,385a8.55,8.55,0,0,1-.74,1.82C426.56,385.94,427.19,384.42,427.9,385Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M426.37,387.94a4.43,4.43,0,0,1-1.2,1C424.91,387.73,425.93,386.9,426.37,387.94Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M424.13,389.29a2.86,2.86,0,0,1-1.34-.11C422.93,387.94,424.06,388,424.13,389.29Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M421.77,388.66a5.07,5.07,0,0,1-1.12-1.18C421.16,386.52,422.11,387.51,421.77,388.66Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M419.93,386.2a10.13,10.13,0,0,1-.61-1.93C420.06,383.84,420.58,385.47,419.93,386.2Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M419.1,382.58a11.91,11.91,0,0,1,.08-2.17C420,380.64,419.88,382.47,419.1,382.58Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M419.51,378.76a8.75,8.75,0,0,1,.73-1.82C420.84,377.78,420.21,379.3,419.51,378.76Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-25",
			d: "M421,375.78a4.39,4.39,0,0,1,1.19-1C422.49,376,421.48,376.81,421,375.78Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-21",
			d: "M456,379.84c-.71,0-1.05-.58-.78-1.29l2.13-5.36a2.12,2.12,0,0,1,1.79-1.28.85.85,0,0,1,.78,1.29l-2.13,5.36A2.12,2.12,0,0,1,456,379.84Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M457,377.36a.31.31,0,0,1-.28-.46l.76-1.92a.76.76,0,0,1,.64-.45c.26,0,.38.21.28.46l-.76,1.91A.75.75,0,0,1,457,377.36Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M442.65,392.42l-.35,0a3.63,3.63,0,0,1-2.25-1.47c-1.61-2.07-1.64-5-1.52-6.95,0-.77.12-1.54.19-2.31a32.16,32.16,0,0,0,.2-5,13.54,13.54,0,0,0-2.66-7.39,10.26,10.26,0,0,0-6.64-4,.24.24,0,0,1-.21-.28.25.25,0,0,1,.28-.22,10.78,10.78,0,0,1,7,4.16,14.21,14.21,0,0,1,2.76,7.67,33.19,33.19,0,0,1-.2,5.09c-.08.76-.15,1.53-.19,2.29-.12,1.91-.1,4.68,1.41,6.62a3.08,3.08,0,0,0,1.93,1.27c1.58.23,2.81-1.36,3.15-1.85a9,9,0,0,0,1.42-3.24,18.08,18.08,0,0,0,.32-3.2,13.34,13.34,0,0,1,.71-4.51,6.89,6.89,0,0,1,9.67-3.49.25.25,0,0,1-.24.44,6.39,6.39,0,0,0-9,3.24,12.94,12.94,0,0,0-.67,4.34,18.26,18.26,0,0,1-.33,3.29,9.36,9.36,0,0,1-1.5,3.42A4.22,4.22,0,0,1,442.65,392.42Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			className: "cls-12",
			cx: 429.96,
			cy: 365.34,
			rx: 1.55,
			ry: 1.14,
			transform: "translate(-7.11 746.83) rotate(-89.74)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M599.58,282.76a6,6,0,1,1-6-6A6,6,0,0,1,599.58,282.76Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-12",
			x: 546.42,
			y: 330.23,
			width: 94.79,
			height: 2,
			transform: "translate(190.12 876.73) rotate(-89.74)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M596,394.91l.09-18.89a2.43,2.43,0,0,0-4.85,0l-.08,18.89Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-22",
			x: 199.62,
			y: 450.72,
			width: 6,
			height: 1,
			transform: "translate(-73.85 -44.98) rotate(-0.52)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-22",
			d: "M661.48,448.49l-12,.06v-1l12-.06Zm-443.86,3.09v-1l11.91-.1.1,1Zm419.87-3-12,.06v-1l12-.06Zm-395.83,2.75,0-.5,0-.5,12-.1v1Zm371.84-2.62-12,.06v-1l12-.06Zm-347.82,2.42-.07-.5.06-.5,11.93-.1v1Zm323.83-2.29-12,.07,0-.5,0-.5,12-.07ZM289.66,451l-.05-.5,0-.5,12-.1v1Zm275.86-2-12,.07,0-.5,0-.5,12-.07Zm-251.91,1.75v-1l12-.09v1Zm227.92-1.61-12,.07v-1l12-.07ZM337.6,450.58v-1l12-.09v1Zm179.94-1.27-12,.08v-1l12-.08ZM361.59,450.4v-1l12-.09,0,1Zm132-.94-12,.08v-1l12-.08Zm-108,.75v-1l12-.08v1Zm84-.59-12,.08v-1l12-.08Zm-60,.42v-1l12-.09v1Zm24-.17v-1l12-.09v1Zm144-1.42v0Zm-24,.14v0Zm-24,.14v0Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-22",
			x: 673.49,
			y: 447.42,
			width: 6,
			height: 1,
			transform: "translate(-71.98 -43.51) rotate(-0.28)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-15",
			d: "M578.34,394.48c-.21-.74-1.56-.85-2-1.27-.26-.24-.37-.85-1.38-.84a6.45,6.45,0,0,0-1,.13,8.16,8.16,0,0,0-1.64.29,1.7,1.7,0,0,0-1.09,1l-.22.1c-2,1.11-.87,3.68-.77,4-.86.35-2.37-.48-3,.37-.24.33-.18.8-.38,1.15a1.28,1.28,0,0,1-1.36.49,6.3,6.3,0,0,1-1.42-.6,6,6,0,0,0-7.29,1.8,5.24,5.24,0,0,0,1.21,7.07,6,6,0,0,0,2.2.86c3.69.72,5.33.76,8.49-1.26.52-.34,2.67-1.57,2.48-3.81a15.28,15.28,0,0,0-.9-2.91,1.35,1.35,0,0,1,.07-.78,2.07,2.07,0,0,0,.34.15c1.06.36.73.45,1.11.73a3.29,3.29,0,0,0,3.58-1.59,10.9,10.9,0,0,0,1.71-1.9c.13-.42.74-.9,1-1.28A2.92,2.92,0,0,0,578.34,394.48Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-30",
			d: "M597.89,446.21h0Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-13",
			d: "M570.85,403.41l0-.1h-.1c-.07,0-6.26.7-8.52,4.64-1.2,2.06-1.12,4.64.23,7.66l.05.12.11-.05C562.7,415.64,572.77,410.8,570.85,403.41Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-31",
			d: "M588.86,417.79l-8.16-3.05-.9,2.57a45.12,45.12,0,0,0,9.13,1.81Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M561.6,449.59c-.12,0-.2-.08-.19-.19,0-.31,0-.54,0-.76s0-.42,0-.63v-.14l0-.49,0-.15a4.1,4.1,0,0,0-.06-.49v-.13l-.09-.54.17-.1-.19,0c-.08-.42-.18-.84-.3-1.25l0-.07c0-.17-.1-.34-.16-.5l-.06-.18-.15-.38-.08-.23a3.09,3.09,0,0,1-.14-.32l-.3-.63,0-.08-.21-.38-.06-.12-.24-.39,0-.07a13.84,13.84,0,0,0-11-6.51,13.46,13.46,0,0,0-3.8.33.19.19,0,1,1-.09-.37,13.93,13.93,0,0,1,3.91-.33,14.1,14.1,0,0,1,11.34,6.69l0,.06.24.4.06.11.22.41,0,.09c.11.21.21.42.31.64l.14.33.09.23.15.39.06.19c.06.17.12.34.17.51l0,.08c.12.42.23.85.31,1.28V446c0,.18.07.37.1.56v.1c0,.2.05.37.06.54l0,.15,0,.5V448c0,.21,0,.42,0,.64s0,.47,0,.7v.06A.21.21,0,0,1,561.6,449.59Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-26",
			d: "M589.73,420.07a.6.6,0,0,1-.36-.77l1.27-3.48a.6.6,0,0,1,1.13.41l-1.27,3.48A.6.6,0,0,1,589.73,420.07Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M590.56,420.17a.78.78,0,0,1-.79.78.77.77,0,0,1-.78-.79.79.79,0,0,1,1.57,0Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-18",
			d: "M588.56,420.14l-1.1.05,1.9,7.22a.52.52,0,0,0,.63.41h0a.57.57,0,0,0,.34-.71Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-18",
			d: "M589.62,420.68l-3.47,0a.42.42,0,0,1-.42-.42.41.41,0,0,1,.41-.42l3.47,0a.42.42,0,1,1,0,.84Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-26",
			d: "M585.79,420a.6.6,0,0,1-.36-.77l1.27-3.48a.6.6,0,0,1,1.12.41l-1.27,3.48A.59.59,0,0,1,585.79,420Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M586.73,420.21a.79.79,0,0,1-.79.79.8.8,0,0,1-.78-.79.79.79,0,0,1,.79-.79A.8.8,0,0,1,586.73,420.21Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-18",
			d: "M580.71,442.63l-4.24-1.41c-.21-.07-.46,0-.5.15l-.68,2.34c0,.13.12.26.34.26l4.54,0C581.37,444,581.76,443,580.71,442.63Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-15",
			d: "M575.89,420.57,568.43,419l-2.86,5.95,7.88.5a1.51,1.51,0,0,1,1.41,1.41c.19,2.93.63,10,.8,13.39.1,1.81.92,2.75,1.7,2.75s1.16-.69,1.14-2.45c0-3.05.31-5.82.44-8.27a43.34,43.34,0,0,0-.12-8.55A3.77,3.77,0,0,0,575.89,420.57Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M570.92,450.24a.71.71,0,0,1-.07-1l4.22-4.78a.72.72,0,0,1,1-.06.7.7,0,0,1,.07,1l-4.23,4.79A.71.71,0,0,1,570.92,450.24Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-26",
			d: "M577.18,445.18h-2.52a.62.62,0,1,1,0-1.24h2.52a.62.62,0,0,1,.62.62A.61.61,0,0,1,577.18,445.18Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M590.6,429c-4.51,1.23-6.54,5.75-8.51,10.13-2.38,5.3-4.63,10.31-11,9.05a1.09,1.09,0,0,0-.81.16,1.17,1.17,0,0,0-.48.74,1,1,0,0,0,.79,1.19,10.72,10.72,0,0,0,2,.2,10.15,10.15,0,0,0,9-5.43c.81-1.42,1.5-2.92,2.18-4.37.52-1.14,1.07-2.32,1.66-3.45,1.17-2.21,2.62-5,5.25-6l.08,0V429Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M579.3,436.13c.82-.93,1.66-1.89,2.52-2.78,1.93-2,4.34-4.47,7.63-4.26a1,1,0,0,0,1.09-.95,1.08,1.08,0,0,0-.27-.79,1,1,0,0,0-.75-.35c-4.95-.32-8.24,3.54-11.42,7.26-2.83,3.31-5.5,6.44-9.16,6.55h-.14v2h.15a10.66,10.66,0,0,0,7.09-3.1C577.19,438.55,578.26,437.32,579.3,436.13Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-11",
			d: "M561.06,448.47c0-.1,0-.2,0-.29l0-.18a1.09,1.09,0,0,0,0-.18c0-.15,0-.31,0-.46l0-.18c0-.16-.05-.33-.08-.49l0-.14c0-.17-.07-.34-.11-.51l0-.13c0-.16-.08-.33-.13-.49l0-.13a4.42,4.42,0,0,0-.15-.48l0-.15c-.05-.15-.1-.3-.16-.44l-.07-.18c-.06-.13-.11-.27-.18-.41l-.08-.19-.19-.38-.1-.21-.21-.37,0-.05a1.09,1.09,0,0,0-.08-.15l-.23-.37-.12-.18c-.09-.14-.18-.28-.28-.41l-.09-.12-.39-.52a13.64,13.64,0,0,0-2.45-2.35l-.54-.38,0,0-.51-.32-.06,0-.52-.3-.57-.28a13.35,13.35,0,0,0-5.65-1.28h-.62a13.32,13.32,0,0,0-8.84,3.86A13.74,13.74,0,0,0,536.4,442l-.25.42-.07.12c-.07.12-.14.24-.2.37l0,.08c-.11.2-.2.41-.3.61l-.13.31-.09.22q-.08.18-.15.39l-.06.16-.16.51,0,0c-.12.4-.22.81-.3,1.22v.06a4.89,4.89,0,0,0-.09.53l0,.13-.06.48,0,.14,0,.48v.14c0,.2,0,.4,0,.6s0,.45,0,.67c0,.05,0,.11,0,.16V450c0,.11,0,.21,0,.32l0,.25,0,.16,0,.24a2.5,2.5,0,0,0,0,.29l0,.13a1.7,1.7,0,0,0,0,.22c0,.11,0,.22.07.35V452l.06.24c0,.09,0,.19.08.32l0,.05a2.68,2.68,0,0,0,.07.27l.07.22,0,.06.12.35.08.22c0,.14.1.27.16.4l.07.17c.06.15.13.3.2.45l.05.1c.08.16.16.33.25.49l0,.05a13.58,13.58,0,0,0,2.27,3.06l.43.41a13.38,13.38,0,0,0,9,3.54c.32,0,.65,0,1,0h.06a13.46,13.46,0,0,0,1.92-.29l.13,0c.32-.07.61-.15.9-.24l.13-.05.73-.25.06,0,.17-.06.74-.34.27-.13c.22-.11.39-.21.56-.31l.42-.25.5-.32.31-.23.62-.47.2-.18.05-.05.53-.47,0-.05.07-.07a12.94,12.94,0,0,0,2.3-3.05c.11-.2.2-.36.28-.53l-.16-.08.18.05,0-.06.21-.46.06-.15c.06-.14.12-.27.17-.41l0-.06.06-.16.12-.36a2.82,2.82,0,0,0,.09-.27l.1-.32v-.05c0-.09,0-.18.07-.27l.06-.23,0-.12.06-.29c0-.07,0-.15,0-.22l0-.13c0-.1,0-.2,0-.29a2,2,0,0,0,0-.24l0-.16,0-.25c0-.11,0-.21,0-.32l0-.17c0-.05,0-.11,0-.16,0-.22,0-.44,0-.67V449C561.08,448.85,561.07,448.66,561.06,448.47Zm-2.7,3.93-.2,0c0,.15-.1.3-.17.48a11,11,0,0,1-2.71,4.1l-.36.32-.24.21-.46.36-.3.21-.31.21-.44.26-.37.2-.29.15-.58.26-.18.07c-.19.08-.37.15-.56.21l-.15.05c-.26.08-.5.15-.73.2l0,.18-.09-.17A11,11,0,0,1,543,459l-.13-.06a10.25,10.25,0,0,1-1.56-.94l-.14-.11a10.88,10.88,0,0,1-3.12-3.6l-.23-.45c-.07-.17-.13-.29-.18-.42l-.06-.13-.13-.33-.07-.18c0-.09,0-.17-.08-.25l0-.1-.06-.18a1.21,1.21,0,0,0-.05-.18l0-.09a2.33,2.33,0,0,1-.07-.25l-.05-.23c0-.1,0-.2-.07-.3l0-.21c0-.11,0-.21,0-.32l0-.21c0-.11,0-.22,0-.33v-.17c0-.12,0-.24,0-.37h-.19l.18-.05V449q0-.34,0-.69V448c0-.22.05-.45.09-.67s0-.15,0-.26.07-.35.11-.53a2.68,2.68,0,0,1,.07-.27c0-.19.1-.38.16-.57s.05-.15.08-.23.15-.44.24-.65l0-.11c.09-.21.19-.42.29-.62l0-.09c.12-.24.25-.47.39-.7a11,11,0,0,1,5.69-4.6l.13-.05a10.06,10.06,0,0,1,1.78-.44l.17,0c.25,0,.5-.07.76-.09a10.93,10.93,0,0,1,8.6,3.21c.26.27.51.55.75.85.11.13.22.27.32.41l.08.11.22.32.12.19.16.26.13.22.13.24.09.18,0,.06.12.24c0,.06.05.13.1.22s.08.18.11.27a.77.77,0,0,0,.07.16l0,.08c0,.09.07.18.1.27l.06.17,0,0,.09.29,0,.16,0,0c0,.1.05.2.08.3s0,.12,0,.19l0,.08c0,.08,0,.17.05.25a1.57,1.57,0,0,1,0,.23l0,.11,0,.18c0,.12,0,.25,0,.37l0,.15a10.24,10.24,0,0,1,0,1.1c0,.37,0,.75,0,1.1s0,.38-.08.56v.07c0,.15,0,.31-.09.46l0,.09c0,.15-.06.29-.1.44l0,.09c0,.14-.08.29-.13.43l.18,0Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-11",
			d: "M609.74,449.26c0-.19,0-.38,0-.57s0-.19,0-.28v-.19c0-.06,0-.12,0-.18s0-.3,0-.46l0-.18c0-.17-.05-.33-.08-.49l0-.14c0-.17-.07-.34-.11-.51l0-.13c0-.16-.09-.33-.14-.49l0-.14-.15-.47,0-.15c-.06-.15-.11-.3-.17-.44l-.07-.18c0-.14-.11-.27-.17-.41l-.09-.19c-.06-.13-.12-.26-.19-.38l-.1-.21-.2-.37,0-.05-.09-.15c-.07-.13-.15-.25-.23-.37l-.11-.18c-.09-.14-.19-.28-.29-.41l-.08-.13c-.13-.17-.25-.33-.4-.51a13.31,13.31,0,0,0-2.45-2.35l-.53-.38,0,0-.51-.32-.1.16.05-.19-.53-.3-.56-.28a13.27,13.27,0,0,0-5.65-1.28h-.63a13.4,13.4,0,0,0-10.76,6.27c-.1.17-.18.29-.25.42l-.07.12-.2.37,0,.08c-.1.2-.2.4-.29.61s-.1.21-.14.31-.05.13-.09.22-.09.25-.15.39l-.05.15c-.06.16-.11.32-.17.52-.13.44-.23.85-.32,1.26v.06l-.09.53,0,.13-.06.47V448c0,.16,0,.32,0,.48v.14c0,.2,0,.4,0,.6s0,.44,0,.67a1,1,0,0,0,0,.17v.16c0,.11,0,.21,0,.32l0,.24,0,.17,0,.24a2.74,2.74,0,0,0,.05.28l0,.15c0,.07,0,.14,0,.21s0,.22.07.35l0,.06a1.55,1.55,0,0,0,0,.23c0,.1.05.19.07.28l0,.1c0,.09.05.18.07.26l.08.23v.05l.12.36.08.22c0,.14.11.27.16.4l.07.17.2.45.05.1c.08.16.16.33.25.49l0,.05a13.26,13.26,0,0,0,2.26,3.05l.44.42a13.29,13.29,0,0,0,9,3.53c.31,0,.64,0,1,0h.06a13.91,13.91,0,0,0,1.92-.29l.12,0q.48-.11.9-.24l.14,0c.24-.08.48-.16.72-.26l.07,0,.16-.07c.25-.1.5-.21.74-.33l.28-.14.56-.3.41-.25a5.39,5.39,0,0,0,.5-.33l.31-.22.62-.47.21-.18,0-.05c.18-.15.35-.31.52-.47l.05-.05.08-.07a13.43,13.43,0,0,0,2.3-3l.28-.53,0-.09.21-.46.07-.15c0-.14.11-.28.16-.41l0-.06.06-.16c.05-.12.09-.24.13-.36l0-.05a1.87,1.87,0,0,1,.07-.22,2.76,2.76,0,0,1,.08-.27l0-.1c0-.09,0-.18.08-.27s0-.16,0-.24l0-.12.06-.28a1.7,1.7,0,0,0,0-.22l0-.13a2.5,2.5,0,0,1,.05-.29l0-.25,0-.15,0-.25,0-.32v-.17c0-.05,0-.11,0-.16,0-.23,0-.45,0-.67ZM599,460.11l-.1-.17a11.06,11.06,0,0,1-7.25-.77l-.13-.06a10,10,0,0,1-1.56-.95l-.14-.1a12.34,12.34,0,0,1-1.13-1,11.06,11.06,0,0,1-2-2.64c-.08-.14-.15-.28-.22-.43l0-.06-.17-.38,0-.13c0-.11-.09-.22-.13-.33l-.07-.18c0-.09-.06-.19-.1-.29l0-.06a1.21,1.21,0,0,1-.05-.18l-.06-.19,0-.09c0-.08,0-.16-.07-.24l0-.23-.06-.3,0-.21c0-.11,0-.22-.05-.33l0-.17c0-.12,0-.24,0-.36l0-.18c0-.12,0-.24,0-.36h-.19l.19,0c0-.18,0-.36,0-.55s0-.46,0-.69v-.05a1,1,0,0,1,0-.17c0-.22,0-.45.08-.67,0-.07,0-.15,0-.22,0-.22.08-.39.12-.57l.06-.27c.05-.19.11-.38.17-.57s0-.15.07-.23.16-.44.25-.65l.05-.11c.09-.21.18-.42.28-.62l0-.09c.13-.25.26-.48.39-.7a11.07,11.07,0,0,1,5.69-4.6l.13,0a10.06,10.06,0,0,1,1.78-.44l.17,0c.25,0,.51-.07.76-.09a10.93,10.93,0,0,1,8.6,3.21,10.27,10.27,0,0,1,.76.84l.31.41.08.12.22.32.12.19a2.26,2.26,0,0,1,.16.26l.09.14,0,.08.13.24.11.22.13.26.09.19,0,.05a2.72,2.72,0,0,0,.11.25l.06.17,0,.05c0,.09.07.19.11.28l.07.22.09.29a1.33,1.33,0,0,1,.05.19,3.4,3.4,0,0,1,.09.33c0,.06,0,.11,0,.17l0,.1a2,2,0,0,1,0,.24c0,.09,0,.18.05.29v0l0,.18c0,.13,0,.25,0,.38l0,.15c0,.37.05.74.05,1.1s0,.74-.07,1.12c0,.18,0,.36-.07.53v.08c0,.15-.05.3-.08.45l0,.1c0,.15-.06.29-.1.43l0,.09c0,.15-.08.29-.13.44l0,.06c-.05.16-.1.31-.16.48a11.19,11.19,0,0,1-2.72,4.11l-.35.32-.25.21-.46.36-.3.21a3.28,3.28,0,0,1-.31.2l-.43.27-.38.2-.28.15-.59.26-.18.07c-.18.08-.37.14-.56.21l-.15.05c-.25.08-.49.14-.73.2Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M582.28,450a.19.19,0,0,1-.19-.18v-.09c0-.23,0-.47,0-.7s0-.43,0-.64v-.15c0-.16,0-.33,0-.5v-.15c0-.17,0-.34.07-.51v-.13c0-.19.07-.37.1-.56v-.06c.09-.44.2-.87.32-1.28.08-.26.14-.43.19-.59l.07-.19.15-.39.09-.23.15-.33c.09-.21.2-.43.31-.64l0-.09.21-.39.07-.12.24-.4a14.41,14.41,0,0,1,2.06-2.58,14,14,0,0,1,9.31-4.07,13.68,13.68,0,0,1,3.87.37.18.18,0,0,1-.08.36,13.67,13.67,0,0,0-14.8,6.06l0,.06c-.08.13-.16.26-.23.39l-.06.1-.22.4,0,.08q-.16.32-.3.63a3.09,3.09,0,0,0-.14.32l-.09.22-.15.38-.06.18c-.06.16-.11.33-.16.49l0,.08c-.12.41-.23.83-.31,1.25l-.19,0,.18,0c0,.18-.07.37-.1.55v.13c0,.16-.05.32-.07.49v.15c0,.16,0,.32,0,.49v.14c0,.2,0,.41,0,.62s0,.46,0,.68v.09a.19.19,0,0,1-.17.2Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M533.49,449.34v-.1c0-.23,0-.46,0-.7s0-.43,0-.64v-.14c0-.17,0-.34,0-.5l0-.16.06-.5,0-.13c0-.19.06-.38.1-.57v-.06c.09-.43.2-.87.32-1.28l0-.05c.06-.2.12-.37.18-.54l.06-.18.15-.4.1-.22c0-.11.09-.22.14-.33s.2-.43.31-.65l.05-.09.21-.38.07-.13.24-.4a14.45,14.45,0,0,1,2.07-2.58,14.27,14.27,0,0,1,13.28-3.7.19.19,0,0,1-.09.37,13.44,13.44,0,0,0-3.79-.36,13.84,13.84,0,0,0-9.14,3.95,14.18,14.18,0,0,0-2,2.46l0,.06-.24.39-.06.12a3.59,3.59,0,0,0-.21.38l0,.09-.3.62-.14.32-.08.2-.16.4-.06.18-.17.5,0,.08a12.48,12.48,0,0,0-.31,1.24l-.2,0,.19,0c0,.18-.07.36-.1.54l0,.13-.06.49,0,.15,0,.49v.14c0,.21,0,.42,0,.62s0,.46,0,.69v0l-.19,0Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-12",
			points: "492.89 377.8 496.98 390.71 497.82 390.35 493.85 377.94 492.89 377.8"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M566.07,429.9a.77.77,0,0,0-1-.53l-.66.16a.82.82,0,0,0-.5.39.77.77,0,0,0-.06.63L570,449.71l2-.74Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-18",
			d: "M564,423.21l-5.4,0a1.44,1.44,0,1,0,0,2.87l5.4,0a1.43,1.43,0,1,0,0-2.86Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-18",
			points: "527.46 402.42 523.03 387.26 521.52 387.67 525.91 402.41 527.46 402.42"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-18",
			d: "M571.86,445.84a3.41,3.41,0,1,0,3.39,3.42A3.41,3.41,0,0,0,571.86,445.84Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M565.78,456a.71.71,0,0,1-.07-1l5.44-6.16a.72.72,0,0,1,1.07.95L566.78,456A.7.7,0,0,1,565.78,456Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-26",
			d: "M566.81,456.57l-2.27-1.09a.62.62,0,0,1,.54-1.12l2.27,1.09a.62.62,0,1,1-.54,1.12Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M593,433.51l-2.17-7.31a.77.77,0,0,0-.38-.47.78.78,0,0,0-.6-.05l-.8.25a.79.79,0,0,0-.51,1l2.12,7.31a.77.77,0,0,0,.37.46.81.81,0,0,0,.37.09.83.83,0,0,0,.22,0l.86-.25a.77.77,0,0,0,.46-.37A.76.76,0,0,0,593,433.51Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-32",
			d: "M579.14,414.17l-3.28-9.36c-1.06-1.67-3.65-1.21-3.28.82a50.23,50.23,0,0,0,2,5.45c.89,2.18,1.92,4.36,2.24,4.91a7.78,7.78,0,0,0,3,1.32l.9-2.57Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-31",
			d: "M591.49,418a.37.37,0,0,0,0-.23.36.36,0,0,0-.21-.13l-.51-.09-.21-.53a.35.35,0,0,0-.43-.19l-1.13.53a.72.72,0,0,0-.48.56s-.07.43-.07.43a.66.66,0,0,0,.13.54.74.74,0,0,0,.48.29l1,.16.81.14h.06a.31.31,0,0,0,.28-.45.26.26,0,0,0,.14-.2.28.28,0,0,0,0-.22.3.3,0,0,0,.13-.2.29.29,0,0,0,0-.24A.37.37,0,0,0,591.49,418Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-31",
			d: "M587.14,418.33a.32.32,0,0,0,.1-.18.29.29,0,0,0-.06-.22.31.31,0,0,0-.2-.11l-.23,0a.3.3,0,0,0-.25-.26l-.77-.09a.29.29,0,0,0-.31.2l-.23,0a.7.7,0,0,0-.77.62l0,.41a.69.69,0,0,0,.62.76l1,.11.76.09a.34.34,0,0,0,.22-.06.31.31,0,0,0,.11-.2.29.29,0,0,0,0-.18.3.3,0,0,0,.12-.2.26.26,0,0,0-.06-.21.32.32,0,0,0,.12-.2A.29.29,0,0,0,587.14,418.33Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-12",
			points: "498.74 403.28 498.75 401.2 479.97 401.11 494.96 385.8 495.01 385.74 494.43 383.94 477.66 401.07 477.57 401.17 477.65 401.25 477.64 403.19 498.74 403.28"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-33",
			d: "M550.25,448.72a2.4,2.4,0,1,1-2.39-2.41A2.41,2.41,0,0,1,550.25,448.72Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-18",
			d: "M567.34,453.75l-3.19-3.13c-.16-.15-.42-.19-.53-.08L562,452.35c-.1.1,0,.29.19.38l4.08,2C567.34,455.27,568.14,454.53,567.34,453.75Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-15",
			d: "M575.26,429.54l-.47-.6-6-5.78-8.77-.35c-2.18,0,.31,3,2.13,4.2l10.25,6.9a1.22,1.22,0,0,1,.1,1.17c-1.22,2.87-4.43,10.25-8.09,14.07-1.4,1.46-1.66,2.65-1.07,3.22a.93.93,0,0,0,.65.25c.49,0,.91-.49,1.72-1.32,6.53-6.69,9.11-11,11.11-15.36C578,433.23,576.55,431.27,575.26,429.54Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-31",
			d: "M577.3,418.32a75.08,75.08,0,0,0,7.57,1l0-1.39L578,416.11Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M574.45,411.61l0,.07a3,3,0,0,1,.2-.29.45.45,0,0,1,.08-.17l.31-.39a6.36,6.36,0,0,0,.82-5.73c-.8-1.75-.94-2.81-4.38-2.29-2.58.4-4.64,3.61-4.85,5.57-.47,2.17-.57,3.71-2.44,5.69-.44.47-.93.94-1.41,1.38a16.88,16.88,0,0,0-2.72,3,9.4,9.4,0,0,0-.92,4.45v.19l.08,0s2.41,1.22,8.35,1.29a3.7,3.7,0,0,0,3.17-1.9l0-.09a37.24,37.24,0,0,0,1.22-4.17c.25-1,.91-3.21.88-3.26a12.12,12.12,0,0,1,.6-1.78A9.14,9.14,0,0,1,574.45,411.61Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M575.91,415.24c-.38-1-2.21-5.68-3.33-8.6a2.39,2.39,0,0,0-1.49-1.42,2.42,2.42,0,0,0-2.06.26,2.45,2.45,0,0,0-.8,3.29l.39.69c.48.81,1,1.66,1.34,2.41a52.18,52.18,0,0,0,3.35,5.67c.42.61,1.7,1.15,3.8,1.61l.4.08.88-3Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-32",
			d: "M577.07,419.35c-2.15-.47-3.47-1-3.93-1.7a50.65,50.65,0,0,1-3.36-5.69c-.39-.77-.91-1.67-1.34-2.4l-.39-.68a.18.18,0,0,1,0-.16.19.19,0,0,1,.09-.12.22.22,0,0,1,.16,0,.2.2,0,0,1,.12.1l.41.71c.45.77,1,1.64,1.34,2.4a52.08,52.08,0,0,0,3.32,5.64c.28.39,1.14,1,3.68,1.53l.22,0,.78-2.65-2.34-.92-.07-.05,0-.06c-.51-1.31-2.26-5.81-3.33-8.59a2.18,2.18,0,0,0-1.36-1.31.22.22,0,0,1-.17-.11.22.22,0,0,1,0-.16.23.23,0,0,1,.1-.12.22.22,0,0,1,.16,0,2.64,2.64,0,0,1,1.67,1.56c1.06,2.78,2.76,7.14,3.29,8.51l2.57,1-1,3.38Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-34",
			d: "M578.31,396.16a3.33,3.33,0,1,1-3.29-2.89A3.1,3.1,0,0,1,578.31,396.16Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-31",
			d: "M579.15,398.36l-.5-1.19-.4,1.8.69-.19A.31.31,0,0,0,579.15,398.36Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-31",
			d: "M578.45,395.8a3.24,3.24,0,0,0-.76-1.3l-1.44.83c-1.53,1-1.71,1.89-1.71,1.89s-.06,0-.09,0a.81.81,0,0,0-.74.87.92.92,0,0,0,.42.81l-.19.36-.65,1.09,2.51,1.16a.59.59,0,0,1,.49-.17c1.64.2,2.32-.87,2.33-2.2l0-2.29A3,3,0,0,0,578.45,395.8Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-31",
			d: "M575.81,401.51l-2.21-1.16s-.83,3-.83,3c.62.31,1.33.62,2,1l.69-2.41A.91.91,0,0,1,575.81,401.51Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M577.44,399.37a.46.46,0,0,0,.37.47s.44.08.4-.36Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-26",
			d: "M578.15,396.41h-.63a.17.17,0,0,0-.17.17.17.17,0,0,0,.16.17h.64a.17.17,0,0,0,.17-.17A.18.18,0,0,0,578.15,396.41Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-15",
			d: "M577.61,394c0-.38-2-.95-2.33-1-1.85-.12-5.37,1.26-2.83,6.34.21.42-.1,1.33.24,1.6l.62-.24a2.1,2.1,0,0,0,.84-1.78.89.89,0,0,1-.44-.81.81.81,0,0,1,.74-.87l.09,0c.13-.71,2.76-2.18,3.41-2.52,0,0,.59.06,0-.53C577.82,394,577.62,394.46,577.61,394Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-26",
			d: "M578,397.22c0,.17-.09.3-.2.3s-.19-.13-.19-.3.09-.3.19-.3S578,397.06,578,397.22Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-26",
			points: "507.97 350.11 508.3 350.11 508.1 350.31 507.97 350.11"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-31",
			d: "M574.68,403.3c.78.69,1.34,1.8.93,2.27s-1.62.1-2.4-.58-1.09-1.62-.68-2.09S573.9,402.62,574.68,403.3Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-33",
			d: "M597.81,449.13a1.29,1.29,0,1,1-1.28-1.29A1.29,1.29,0,0,1,597.81,449.13Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-18",
			d: "M454.37,445.17l-4.3-1.52a.69.69,0,0,0-.53,0,.4.4,0,0,0-.22.24l-.73,2.37a.28.28,0,0,0,.05.29.58.58,0,0,0,.46.22l4.64.11c.83,0,1.28-.4,1.35-.79S455,445.39,454.37,445.17Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-11",
			d: "M481.61,450.37v-.6c0-.1,0-.2,0-.3v-.19a1.15,1.15,0,0,0,0-.19c0-.16,0-.32-.05-.48v-.19c0-.18-.05-.35-.08-.52l0-.15c0-.18-.07-.36-.11-.53l0-.14c0-.17-.08-.35-.12-.52l0-.14-.15-.5,0-.16-.16-.46-.07-.19-.18-.43-.09-.21-.18-.4,0-.05-.08-.17-.21-.39-.11-.21-.24-.4,0-.06-.07-.13-.29-.43-.09-.13-.4-.55a14.31,14.31,0,0,0-2.53-2.51l-.55-.4,0,0-.53-.35-.06,0-.54-.32-.59-.31a14,14,0,0,0-5.9-1.45h-.65a13.91,13.91,0,0,0-9.33,3.88,14.34,14.34,0,0,0-2.07,2.49l-.27.44-.07.12-.22.38,0,.09c-.12.21-.22.42-.32.63l-.15.32a2.29,2.29,0,0,1-.1.23l-.15.39-.07.18-.18.5,0,.08c-.13.41-.25.84-.34,1.27l0,.06c0,.19-.07.37-.1.56l0,.13c0,.16-.05.33-.08.5v.15c0,.17,0,.33,0,.5v.15q0,.32,0,.63c0,.23,0,.47,0,.7a.91.91,0,0,0,0,.17v.18c0,.11,0,.22,0,.33a2.28,2.28,0,0,0,0,.26l0,.18c0,.08,0,.16,0,.24s0,.21,0,.31l0,.15a1.7,1.7,0,0,0,0,.22c0,.11,0,.21.06.32l0,.12c0,.08,0,.16,0,.24s.05.18.07.28l0,.09c0,.1.05.2.08.3s.05.16.07.23l0,.06.12.38.06.17,0,.06c.05.15.1.29.16.43l.07.17c.06.16.13.32.2.48l0,.1c.08.18.16.35.25.52l0,.05a13.56,13.56,0,0,0,2.32,3.25c.14.15.29.3.44.44a14,14,0,0,0,9.36,3.88c.33,0,.69,0,1.09,0h.06a13.62,13.62,0,0,0,2-.27l.13,0,.95-.24.14-.05c.26-.08.52-.16.77-.26l.07,0,.17-.07.79-.33.28-.14,0,0,.56-.29.43-.25.53-.33.34-.23c.22-.16.44-.32.65-.49l.23-.18.05-.05.55-.49.06-.05.08-.07a13.76,13.76,0,0,0,2.47-3.15l.3-.55.05-.1c.08-.16.15-.31.22-.47l.08-.16.18-.43,0-.06.07-.16c.05-.13.09-.25.13-.38l0-.06.07-.22a7.5,7.5,0,0,0,.2-.67,1.82,1.82,0,0,0,.07-.25l0-.12c0-.1.05-.2.07-.3a1.7,1.7,0,0,0,0-.22l0-.15.06-.3c0-.08,0-.16,0-.24l0-.18a2,2,0,0,0,0-.26l0-.33,0-.18c0-.06,0-.11,0-.17l0-.7Zm-11.44,11.18-.09-.17a11.54,11.54,0,0,1-7.6-.95l-.13-.05a10.33,10.33,0,0,1-1.64-1l-.13-.1a13.6,13.6,0,0,1-1.18-1,11.91,11.91,0,0,1-2-2.81c-.08-.15-.15-.3-.22-.45l0-.07c-.06-.13-.12-.27-.17-.41l-.06-.13c0-.11-.08-.23-.13-.35l-.06-.19c0-.1-.06-.19-.1-.3v-.06l-.06-.19-.06-.21,0-.08-.06-.27-.06-.25-.06-.31,0-.21c0-.12,0-.23-.05-.35l0-.18c0-.13,0-.25,0-.38v-.17c0-.13,0-.26,0-.4h-.19l.19-.05a5.61,5.61,0,0,1,0-.58c0-.24,0-.48,0-.72l0-.23c0-.24.06-.47.1-.71,0-.08,0-.16.05-.27s.08-.37.12-.55l.08-.29c.05-.2.11-.39.18-.59s.05-.16.08-.24c.09-.23.17-.46.27-.68l.06-.12c.09-.21.2-.43.31-.64l.05-.1c.14-.25.28-.49.43-.72a11.61,11.61,0,0,1,6.06-4.73l.13-.05a11.21,11.21,0,0,1,1.89-.42l.17,0a7,7,0,0,1,.8-.08,11.56,11.56,0,0,1,9.75,4.43c.11.14.22.29.32.44l.09.12c.07.11.15.22.22.34l.11.18.18.29.09.17,0,.05.14.28.09.19,0,.05.12.26a1.67,1.67,0,0,1,.08.2l.14.32a1.07,1.07,0,0,0,.07.19l.12.35a1.21,1.21,0,0,1,0,.18l.11.35c0,.06,0,.12.05.18l0,.07c0,.1.05.2.07.3s0,.13,0,.19l0,.09a2.38,2.38,0,0,0,.05.26,2.17,2.17,0,0,0,0,.25v.11l0,.19c0,.13,0,.26,0,.39l0,.16a11.3,11.3,0,0,1,0,1.16,11.71,11.71,0,0,1-.09,1.18c0,.19,0,.37-.08.55v.08c0,.16-.07.32-.1.48l0,.1c0,.15-.07.3-.11.45l0,.1c0,.15-.09.3-.14.45l0,.07c-.06.16-.11.31-.19.5a11.46,11.46,0,0,1-2.93,4.26c-.11.11-.23.21-.35.31l-.28.23c-.16.13-.33.26-.49.37l-.32.22-.33.21-.46.27-.4.21-.3.14c-.21.1-.41.19-.62.27l-.11,0-.08,0-.59.2-.16.05c-.27.08-.52.15-.77.2l0,.18Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-31",
			d: "M466,419.79a.51.51,0,0,0-.34-.44l-1.14-.42a.58.58,0,0,0-.19,0l-1.72,0a.51.51,0,0,0-.49.43l-.23,1.43.1,0a2.09,2.09,0,0,0,2.37-.47l.7-.09c0,.28.18.81.61,1l.09,0a.36.36,0,0,0,.2-.06.34.34,0,0,0,.12-.26Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-35",
			points: "363.95 379.36 362.84 379.35 364.69 383.07 365.88 383.1 363.95 379.36"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-35",
			d: "M437.6,423.78l-5.51-.12a1.5,1.5,0,0,0-.06,3l5.5.13a1.51,1.51,0,1,0,.07-3Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-36",
			d: "M451.7,448l-2.57,0a.63.63,0,0,1-.63-.65.62.62,0,0,1,.64-.62l2.58,0a.64.64,0,0,1,.62.65A.62.62,0,0,1,451.7,448Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-11",
			d: "M433.68,448.12a13.88,13.88,0,0,0-1.9-5.83l-.94-1.41a14.13,14.13,0,1,0,2.9,9.3Zm-14.33,13a11.63,11.63,0,0,1,.52-23.26,11.5,11.5,0,0,1,8.71,4.27l1.06,1.54.07.09a11.3,11.3,0,0,1,1.43,4.33l.05,1.88,0,.12A11.68,11.68,0,0,1,419.35,461.1Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-11",
			d: "M452.51,423.85c-1.31-2.57-7.07-2.26-7.7-2.22l-6.85.08-.67,5.72h7.21l3.15-.07a1,1,0,0,1,1,.91,70.6,70.6,0,0,1-.67,12.83,1,1,0,0,0,1.05,1.09l2.3-.1a1,1,0,0,0,.95-.94C452.49,437.2,453.66,426.1,452.51,423.85Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-31",
			d: "M449.15,442.13v1c.05,1.27.67,1.86,1.26,1.87s1-.45,1.06-1.67c0-.17.08-1.11.08-1.27Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M462.75,429.6,445,448.77l-11.41-.35h-.27l.05,1.91,12.37.33,7.79-8.16a.7.7,0,0,0,.1-.16l9.67-10.42Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-18",
			points: "394.44 388.89 396.77 399.78 398.27 399.4 396.01 388.59 394.44 388.89"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-12",
			points: "398.6 399.27 396.46 399.8 397 402.3 399.14 401.79 398.6 399.27"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-12",
			points: "368.81 389.08 369.93 391.29 385.99 390.69 388.05 388.45 368.81 389.08"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M443.57,450.65l1.95-1-10-20.85-1.85,0a.33.33,0,0,0-.27.15.33.33,0,0,0,0,.32l.07.15L422,446.76l0,0a3.19,3.19,0,0,0-1.86-.66,3.24,3.24,0,1,0,3.06,4l11.57.2-.63-1.93-10.42-.18,10.75-16.73Zm-22.67-3.18.22-.35a.21.21,0,0,1,.3-.07.18.18,0,0,1,.07.05Zm.78,2.65h.17l.46.28a.22.22,0,0,1,.08.3.22.22,0,0,1-.14.11.25.25,0,0,1-.17,0l-.6-.36A1.49,1.49,0,0,0,421.68,450.12Zm-2.25.82-.4.66a.21.21,0,0,1-.14.1.2.2,0,0,1-.17,0,.23.23,0,0,1-.08-.31l.4-.65A1.87,1.87,0,0,0,419.43,450.94Zm-1.09-1.35h-.73a.24.24,0,0,1-.22-.23.22.22,0,0,1,.23-.22h.69s0,.07,0,.1A1.45,1.45,0,0,0,418.34,449.59Zm.62-1.7-.31-.55a.25.25,0,0,1,.09-.31.23.23,0,0,1,.31.09l.29.54A1.83,1.83,0,0,0,419,447.89Zm-1.2.12a.22.22,0,0,1,.3-.08l.56.34a1.71,1.71,0,0,0-.21.4l-.58-.35A.23.23,0,0,1,417.76,448Zm.07,2.38.64-.36a2,2,0,0,0,.24.38l-.66.37a.23.23,0,0,1-.31-.09A.22.22,0,0,1,417.83,450.39Zm2.46-2.9a1.75,1.75,0,0,0-.45,0l0-.61a.22.22,0,0,1,.23-.22.22.22,0,0,1,.21.23Zm-.43,3.57a1.62,1.62,0,0,0,.44,0v.76a.29.29,0,0,1-.07.16.25.25,0,0,1-.16.06.22.22,0,0,1-.22-.23Zm1.24.54-.36-.65a1.47,1.47,0,0,0,.39-.21l.36.65a.25.25,0,0,1,0,.17.28.28,0,0,1-.11.13A.22.22,0,0,1,421.1,451.6Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-35",
			d: "M462.41,420.8l1.94,9.94a.56.56,0,0,1-.37.67h-.05a.51.51,0,0,1-.59-.45l-2-10.19Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-35",
			d: "M465.3,420.92l-4.43-.09a.43.43,0,0,1-.4-.42.41.41,0,0,1,.42-.4l4.43.09a.43.43,0,0,1,.4.42A.41.41,0,0,1,465.3,420.92Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-33",
			d: "M469.71,449.73A1.74,1.74,0,1,1,468,448,1.73,1.73,0,0,1,469.71,449.73Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-35",
			d: "M448.5,450.61a3.33,3.33,0,1,1-3.25-3.41A3.32,3.32,0,0,1,448.5,450.61Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M445.69,448.2a.51.51,0,0,1-.52.5.52.52,0,0,1-.51-.53.51.51,0,0,1,.53-.5A.51.51,0,0,1,445.69,448.2Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M443.41,448.92a.52.52,0,0,1-.54.88.52.52,0,0,1-.17-.71A.51.51,0,0,1,443.41,448.92Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M442.89,451.25a.52.52,0,0,1,.5.91.52.52,0,0,1-.7-.21A.51.51,0,0,1,442.89,451.25Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M444.66,452.87a.51.51,0,0,1,.52-.51.52.52,0,1,1-.52.51Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M446.94,452.15a.52.52,0,1,1,.71-.17A.52.52,0,0,1,446.94,452.15Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M447.46,449.81a.51.51,0,1,1,.2-.7A.51.51,0,0,1,447.46,449.81Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M445.5,450.07a.73.73,0,0,0-1,.05l-5.65,6.18a.75.75,0,0,0-.17.36,3.93,3.93,0,0,1,1.3.57l5.6-6.13A.73.73,0,0,0,445.5,450.07Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-36",
			d: "M440.06,457.83l-2.3-1.16a.63.63,0,0,1,.57-1.13l2.3,1.15a.64.64,0,0,1-.57,1.14Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-18",
			d: "M443.07,456.16l-3.2-3.25a.72.72,0,0,0-.5-.2.39.39,0,0,0-.3.12l-1.69,1.81a.34.34,0,0,0-.08.29.55.55,0,0,0,.32.39l4.12,2.12a1.86,1.86,0,0,0,.78.22,1,1,0,0,0,.79-.34C443.5,457.07,443.53,456.63,443.07,456.16Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M467.39,440.37l-3.09-13.94a1,1,0,0,0-1.09-.76l-.49.06a1,1,0,0,0-.83,1.19l2.93,14a1.31,1.31,0,0,0,1.27,1,.88.88,0,0,0,.28,0,1.31,1.31,0,0,0,1-1.57Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-31",
			d: "M441.33,450.38l-2.73-.24c0,.88,0,1.69,0,2.47,0,1.16.67,1.9,1.25,1.93s1.08-.72,1.22-1.94C441.13,451.87,441.22,451.14,441.33,450.38Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-31",
			d: "M452.7,412l-2.83,1.19c1,1.73,2.21,3.9,2.6,4.42s4.55,1.75,8.06,1.83a8.93,8.93,0,0,0,1.92-.13l.06-.31-8-3.44a1.41,1.41,0,0,1-.75-.77Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-11",
			d: "M443.82,434.93a24.34,24.34,0,0,0-1.12-3.75,43.21,43.21,0,0,0-5.7-10,3.23,3.23,0,0,0-4.72-.95,3,3,0,0,0-1,4.08c1.09,1.5,2,2.76,2.86,3.87,1.44,1.94,2.49,3.35,3.23,4.52,1.69,2.7,1.75,4,1.27,8.58-.07.7-.15,1.39-.22,2.09-.24,2.1-.49,4.29-.58,6.45l0,.5,4.26.37.06-.49c.38-2.83.79-5.12,1.12-7C443.91,439.54,444.31,437.3,443.82,434.93Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-13",
			d: "M443.3,402.77l0-.12h-.11c-.07,0-7,.28-9.81,4.46-1.48,2.2-1.6,5.06-.35,8.52l.05.13.13,0C433.3,415.67,444.84,411.1,443.3,402.77Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M452.58,411.66c-2.36-6.07-2.38-6.1-2.39-6.12a1.91,1.91,0,0,0-2.49-.32,2.47,2.47,0,0,0-1.36,2.8c.17.57,1.71,3.48,2.42,4.82a.84.84,0,0,0,1.08.37L452.7,412Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M450.24,405.88a4.35,4.35,0,0,0-.79-1.83c-.23-.29-.48-.58-.74-.86l0,0c-2.88-1.37-4.77-1.2-7.47.66-2.43,1.68-4.87,6-7.23,10.23-1,1.69-1.94,3.44-2.9,5a4.11,4.11,0,0,0-.38,3.58,4.05,4.05,0,0,0,2.54,2.52,13.86,13.86,0,0,0,4.09-.19c1.5-.28,5.12-1.65,5.56-3.1,1.78-5.8,4.7-5.31,6.54-9A9.67,9.67,0,0,0,450.24,405.88Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-31",
			d: "M448.21,415.26l-1-2.63-3.37,1.45c1.07,1.75,2.11,3.18,2.51,3.73.87,1.2,8,2.58,12.52,3.21l0-1.4Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-13",
			d: "M434.75,412.67a.18.18,0,0,1-.18-.16.17.17,0,0,1,.15-.2c8.55-1.26,10.74-3.33,11.07-4.84.49-2.23-3.05-4.55-3.08-4.57s0,0,.05-.14a.35.35,0,0,1,.37,0c.14.09,3.55,2.34,3,4.82s-4.34,4.08-11.36,5.12Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-31",
			d: "M448,402.85c.94.82,1.6,2.16,1.11,2.71s-1.94.13-2.88-.69-1.29-1.94-.8-2.5S447.08,402,448,402.85Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M447.13,412.52c-2.44-6.21-2.89-7.5-2.89-7.5l-.08-.07A2.62,2.62,0,0,0,440,408a58.77,58.77,0,0,0,2.93,5.73.74.74,0,0,0,.94.32l3.33-1.43Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-37",
			d: "M443.6,414.29a.84.84,0,0,1-.73-.44c0-.05-2.95-5.3-2.95-5.76h.19a63.77,63.77,0,0,0,2.93,5.67.64.64,0,0,0,.82.28l3.23-1.39c-2.2-5.61-2.79-7.22-2.89-7.48l.19-.07c.09.26.68,1.87,2.87,7.44l.08.22-3.41,1.46A1,1,0,0,1,443.6,414.29Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-15",
			d: "M453.36,393.55c0-.38-.05-.79-.36-.94a2.62,2.62,0,0,1-.39-.15c-.18-.13-.2-.4-.25-.64s-.14-.5-.38-.52-.51.2-.75.21-.58-.41-1-.24c-.15.07-.27.23-.43.28s-.37-.11-.59-.06a7.85,7.85,0,0,0-1.72.75c-.06.17,1.3,0,1.33.12a.88.88,0,0,0,.42.68c.3.13.7,0,1.06,0a1,1,0,0,1,1.13.87c0,.18,0,.38,0,.57a.52.52,0,0,0,.21.45,1.24,1.24,0,0,0,.48.06c.17,0,.34.07.37.23s0,.17,0,.24.29.17.46,0a.61.61,0,0,0,.22-.45A8.19,8.19,0,0,0,453.36,393.55Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-38",
			d: "M451,395.73l-3,0a.23.23,0,0,1-.24-.23V393.9a.47.47,0,0,1,.47-.47l2.74,0a1.12,1.12,0,0,1,1.11,1.12A1.13,1.13,0,0,1,451,395.73Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-15",
			d: "M446.21,398.83a3.15,3.15,0,0,0,.59,1.06,2.11,2.11,0,0,0,.62-1.49,1,1,0,0,1-.31-.83c0-.5.24-.9.52-.9,0,0,.5-2.31.52-2.31l-2.59.28A8.6,8.6,0,0,0,446.21,398.83Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-31",
			d: "M446.88,396.71a.85.85,0,0,0-.76.91.77.77,0,1,0,1.51,0A.85.85,0,0,0,446.88,396.71Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-31",
			d: "M451.56,393.64a3,3,0,0,1,1.09,2.33l0,2.38a2.63,2.63,0,0,1-2.64,2.83,3.07,3.07,0,0,1-3.11-2.88l0-2.31Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-31",
			d: "M446.1,404.29l1.88.4a.54.54,0,0,0,.62-.45l1.6-5.6a.55.55,0,0,0-.41-.67l-2.15-.49a.57.57,0,0,0-.66.44l-1.29,5.7A.56.56,0,0,0,446.1,404.29Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-12",
			d: "M450.07,398.85c0,.19.13.42.58.49,0,0,.67.08.61-.37Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-26",
			d: "M450.12,395.8h-.66a.17.17,0,1,0,0,.34h.65a.18.18,0,0,0,.18-.18A.18.18,0,0,0,450.12,395.8Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-26",
			d: "M452.69,395.81H452a.18.18,0,0,0-.17.17.18.18,0,0,0,.17.18h.66a.18.18,0,0,0,.17-.17A.18.18,0,0,0,452.69,395.81Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-26",
			d: "M452.24,396.61c0,.17-.09.31-.2.31s-.2-.14-.2-.31.09-.31.2-.31S452.24,396.44,452.24,396.61Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-26",
			d: "M449.79,396.65c0,.17-.09.3-.2.3s-.2-.14-.2-.31.09-.3.2-.3S449.79,396.48,449.79,396.65Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-39",
			d: "M451.43,397.59l0-.06a.35.35,0,0,1-.25.29l-.34.09a.24.24,0,0,1-.28-.11.28.28,0,0,0,.33.36l.34-.1A.35.35,0,0,0,451.43,397.59Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-38",
			d: "M451.46,393.59a4.38,4.38,0,0,0-3.2-.28l.72.62Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-15",
			d: "M452.54,394.68a2.7,2.7,0,0,0-2.27-.3c-1.62.29-1.09,2.17-2.87,2.46l-.86-.19.32-3.23s3.26-2.41,5.59.36Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-15",
			d: "M445.53,394.72a3.6,3.6,0,0,1,3.07-2.78,4.08,4.08,0,0,1,3.85,1.84Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-31",
			d: "M458.36,420.42l0-.38a.66.66,0,0,1,.42-.64l1.89-.75a.58.58,0,0,1,.32,0l1.25.14a.67.67,0,0,1,.56.46l.37,1.17a.32.32,0,0,1-.06.31.33.33,0,0,1-.3.13c-.51,0-.81-.59-.93-.89l-.74.29a2.12,2.12,0,0,1-2.17.84A.67.67,0,0,1,458.36,420.42Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-31",
			d: "M461.66,420.38a.62.62,0,1,1-.6-.63A.62.62,0,0,1,461.66,420.38Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M176.08,472.26a12,12,0,0,1,.58-1.06,7.64,7.64,0,0,0,.77-1.54c.55-1.79-.38-3.53-1.35-5.38a16.89,16.89,0,0,1-1.37-3c-1-3.12.08-6.29,1.09-9.35a26.52,26.52,0,0,0,1.44-5.79,24.54,24.54,0,0,0-1.14-8c-.35-1.35-.71-2.74-.94-4.13a24.93,24.93,0,0,1,.85-11.76,50.64,50.64,0,0,1,2.29-5.51,53.48,53.48,0,0,0,2.12-5.06c2.31-6.8,2.3-13.7,0-18.95a.32.32,0,0,1,0-.14c-2.24.46-2.81,2.27-3.33,3.95a128.48,128.48,0,0,1-5,13.4c-.55,1.27-1.21,2.63-3,2.75a2.9,2.9,0,0,1-.93-.07,25.07,25.07,0,0,1,.72,17.26c-.22.69-.48,1.38-.73,2a19.88,19.88,0,0,0-1.37,4.84c-.32,2.94.65,5.71,1.67,8.65a31.87,31.87,0,0,1,1.69,6.08,31.47,31.47,0,0,1,.11,5.31,20.37,20.37,0,0,0,1.68,10.52c.24.66.52,1.39.76,2.1a62.13,62.13,0,0,1,2.44,13l0,.07c0,.2,0,.4.05.59l1.76,0c-.17-.77-.36-1.51-.6-2.39C175.6,477.87,174.82,474.94,176.08,472.26Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M181.15,411.89A54.48,54.48,0,0,1,179,417a46.54,46.54,0,0,0-2.25,5.42,24.22,24.22,0,0,0-.83,11.4c.23,1.36.58,2.73.92,4.07a24.54,24.54,0,0,1,1.16,8.29,26.51,26.51,0,0,1-1.47,6c-1,3.08-2,6-1.08,8.89a17,17,0,0,0,1.31,2.86c1,1.9,2.05,3.87,1.4,6a8,8,0,0,1-.83,1.71,10.9,10.9,0,0,0-.55,1c-1.14,2.43-.43,5.09.32,7.91,0,.14.08.3.12.46a10.79,10.79,0,0,1,1-3.5c.37-.78.81-1.54,1.23-2.27a14.6,14.6,0,0,0,2-4.5,15,15,0,0,0-.19-5.13,16.55,16.55,0,0,1-.2-5.3c.5-2.76,2.31-4.94,4.06-7.06.75-.9,1.52-1.83,2.17-2.79a17.82,17.82,0,0,0,2.87-12.59c-1.94-1.08-2.61-3.27-3.05-5.34a46,46,0,0,1-.3-17.19c.63-3.68,1.73-7.3,1.86-11,.16-4.12-1.06-8.59-4.61-10.91a5.19,5.19,0,0,0-3-.86C184.38,399.88,182.54,407.81,181.15,411.89Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M169,478.77a15.94,15.94,0,0,0-3.08-2.51,14.94,14.94,0,0,1-3.45-2.9,14.75,14.75,0,0,1-2.34-5.65,13.8,13.8,0,0,0-2.29-5.46,14.12,14.12,0,0,0-3.1-2.53l-.68-.45a36,36,0,0,1-12.48-15,.32.32,0,0,1,0-.19,4.21,4.21,0,0,1-2.64.19,5.92,5.92,0,0,1-4-3.43c-2.67-6-7.67-11.43-14.07-13.26a5.11,5.11,0,0,0-2.84-.18,3.22,3.22,0,0,0-1.6,1.11c3.46.63,6.53,3.77,8.06,6.64a44.78,44.78,0,0,1,2,4.68,45.19,45.19,0,0,0,2,4.53,21.59,21.59,0,0,0,7.46,8.1c.78.5,1.62,1,2.43,1.41a22.41,22.41,0,0,1,4.75,3.18,23.14,23.14,0,0,1,4.08,6c1.32,2.5,2.57,4.85,4.7,6.46a19.5,19.5,0,0,0,3.59,2,13.8,13.8,0,0,1,4.9,3.15,18.08,18.08,0,0,0,4.4,3.61l1,.64a25.68,25.68,0,0,1,4.82,4.13l0,0h1.07c-.29-.47-.57-1-.81-1.4A16.76,16.76,0,0,0,169,478.77Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M174.33,482.48a34.87,34.87,0,0,0-4.27-7.72c-1.87-2.78-3.81-5.67-4.7-8.94a30.23,30.23,0,0,1-.72-3.94,33.65,33.65,0,0,0-.64-3.61,32.58,32.58,0,0,0-4.14-8.59c-.4-.65-.84-1.38-1.25-2.08-1.84-3.15-3.89-7.33-3.35-11.67a22.06,22.06,0,0,1,.56-2.71,13.47,13.47,0,0,0,.6-4c-.1-2.17-1.28-4.41-3.49-6.64-.78-.78-1.64-1.53-2.46-2.25a36.28,36.28,0,0,1-3.36-3.21,17.86,17.86,0,0,1-4-7.79,35.8,35.8,0,0,1-.6-7.36c0-1.28,0-2.59-.12-3.88A32.69,32.69,0,0,0,136.06,381a12,12,0,0,0-4.69,7.56c-3.17,17.31,12.29,30.8,13.53,47.38.21,2.84-.66,6.36-2.8,7.77a.35.35,0,0,1,.17.19,35.27,35.27,0,0,0,12.21,14.69l.62.42.06,0a14.43,14.43,0,0,1,3.27,2.68,14.69,14.69,0,0,1,2.44,5.76,14.28,14.28,0,0,0,2.2,5.36,13.92,13.92,0,0,0,3.27,2.74,15.68,15.68,0,0,1,3.23,2.64,17.7,17.7,0,0,1,2,3c.33.6.67,1.22,1,1.79h1.85l-.06-.6Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M165.3,479.53l-1-.62a19.32,19.32,0,0,1-4.58-3.76,13.11,13.11,0,0,0-4.64-3,19.66,19.66,0,0,1-3.73-2.05c-2.27-1.72-3.62-4.26-4.92-6.71a22.26,22.26,0,0,0-3.93-5.84,21.86,21.86,0,0,0-4.59-3.06c-.82-.46-1.67-.92-2.48-1.44a22.39,22.39,0,0,1-7.72-8.39,42.25,42.25,0,0,1-2-4.61,43.49,43.49,0,0,0-2-4.6c-1.47-2.75-4.41-5.76-7.68-6.27l-.13-.05a5,5,0,0,0-.56,2.31,13,13,0,0,0,1.47,5,141.45,141.45,0,0,1,6,16.07c.44,1.44.8,3.15,0,4.39,1.61.24,2.52,2.22,3.33,4,.27.58.52,1.13.77,1.56a9,9,0,0,0,6.48,4.26c.64.08,1.33.1,2,.12,1.7,0,3.46.08,4.84,1.15a7.49,7.49,0,0,1,1.46,1.63c.23.29.45.6.69.87a6.77,6.77,0,0,0,5.06,2.27c.41,0,.84-.05,1.25-.09a9.14,9.14,0,0,1,2-.06c2.37.27,4,2.06,5.54,3.79a15.87,15.87,0,0,0,3.09,2.89,16.55,16.55,0,0,0,2.92,1.35,10.45,10.45,0,0,1,4.17,2.38l0,0h3A25.7,25.7,0,0,0,165.3,479.53Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M227.34,407.49c-1,1.16-2.08,2.35-3,3.59a30.63,30.63,0,0,0-4.8,9.18c-.41,1.28-.75,2.61-1.08,3.89a29.78,29.78,0,0,1-2.93,8.15c-1.83,3-4.64,5.3-7.37,7.49a32.82,32.82,0,0,0-6.74,6.57c-2.25,3.28-3.19,7.33-4.11,11.25-1,4.32-2.05,8.79-4.85,12.3a30,30,0,0,1-5.61,5c-.72.55-1.47,1.11-2.18,1.69a15.71,15.71,0,0,0-5.07,6.25,12.58,12.58,0,0,1,5.14-4c.51-.25,1-.48,1.51-.7a18.51,18.51,0,0,0,5.2-3.09,17.68,17.68,0,0,0,2.16-2.63,16.4,16.4,0,0,1,2.61-3.05,16.74,16.74,0,0,1,4.15-2.35,17.06,17.06,0,0,0,3.82-2.1,16.68,16.68,0,0,0,3.77-5.1,30.8,30.8,0,0,1,2-3.23c2.13-2.91,5.18-5,8.13-6.94.69-.46,1.36-.91,2-1.36,2.9-2,6.88-5.21,7.93-9.62a.43.43,0,0,1,.18-.24,7.33,7.33,0,0,1-1.2-3.25c-.27-2.47.6-4.92,1.57-7.21,4.68-11.09,12.16-21.91,11-33.89-.22-2.36-1-5-3-6.19a35.24,35.24,0,0,1-4.47,13.35A38,38,0,0,1,227.34,407.49Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M110.89,460.56a15.14,15.14,0,0,1,4.86,1.29,14.73,14.73,0,0,1,4,3.58c.26.28.5.56.75.84,2.31,2.52,6,5.66,10.58,6.29.61.08,1.24.12,1.84.16a16.65,16.65,0,0,1,2.95.37c2.47.6,4.47,2.23,6.4,3.8.73.59,1.48,1.2,2.25,1.75,2.56,1.83,5.58,2,8.78,2.15.63,0,1.26.07,1.88.12a42.15,42.15,0,0,1,10.07,2,12.87,12.87,0,0,0-3.24-1.59,17.06,17.06,0,0,1-3.06-1.42,16.64,16.64,0,0,1-3.25-3c-1.54-1.69-3-3.3-5.06-3.53a8.35,8.35,0,0,0-1.86.06c-.43,0-.87.08-1.32.09h-.1a7.5,7.5,0,0,1-5.55-2.53c-.26-.3-.5-.62-.72-.92a7.3,7.3,0,0,0-1.32-1.48c-1.19-.91-2.74-.95-4.39-1-.68,0-1.39,0-2.08-.12a9.77,9.77,0,0,1-7-4.64,15.47,15.47,0,0,1-.81-1.63c-.76-1.65-1.61-3.51-2.89-3.56a.37.37,0,0,1-.27-.11,4.17,4.17,0,0,1-.46.33,3.5,3.5,0,0,1-2.69.33,16.54,16.54,0,0,1-3.28-1.28,6.07,6.07,0,0,0-8.29,3A20.75,20.75,0,0,0,110.89,460.56Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M131.74,479.07c-2.32-1.24-4.7-2.51-7.25-2.39a14.07,14.07,0,0,0-2.21.34,11.89,11.89,0,0,1-3,.36c-3-.14-5.29-2.33-7.43-4.55a5.88,5.88,0,0,1-1.42.54c-2.6.73-5.88,0-8.57.27-3,.33-6.43,2.35-5.84,5.71a3.38,3.38,0,0,0,1.61,2.27,9.67,9.67,0,0,0,2.7,1.12l44.84.2A32.51,32.51,0,0,1,134,480.22C133.22,479.86,132.47,479.46,131.74,479.07Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M153.33,481.57c-3.35-.18-6.48-.34-9.22-2.3-.78-.56-1.55-1.18-2.29-1.78-1.87-1.52-3.79-3.09-6.1-3.66a16.47,16.47,0,0,0-2.81-.34c-.63,0-1.27-.08-1.89-.17-3.8-.52-7.62-2.78-11-6.53l-.74-.82a14.37,14.37,0,0,0-3.84-3.44,14.92,14.92,0,0,0-4.63-1.21,22.42,22.42,0,0,1-3.37-.69l-.07,0a6.52,6.52,0,0,0-.3,2,6,6,0,0,0,2.76,5.22l.89.56a5,5,0,0,1,2,2.65,1.77,1.77,0,0,1-.25,1.34c2,2.11,4.25,4.17,6.91,4.3a10.86,10.86,0,0,0,2.79-.34,13.91,13.91,0,0,1,2.34-.36c2.75-.14,5.23,1.19,7.63,2.47.74.4,1.48.8,2.21,1.14,5.78,2.73,12.39,2.86,18.78,3,3,.06,6.08.12,9.12.45V483h.73a41.39,41.39,0,0,0-7.76-1.35Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M255.94,470.48c-.5.36-1,.74-1.48,1.1-2.62,2-5.31,4-8.53,4.69a22.34,22.34,0,0,1-6.68.1v0l-1.87-.14c-2.25-.13-5.51-.1-7.84,1.68a13.46,13.46,0,0,0-1.46,1.37,14.75,14.75,0,0,1-1.64,1.51c-2.65,2-6,1.73-9.24,1.5a21.35,21.35,0,0,0-6.45.19,19.42,19.42,0,0,0-2.08.68l-.2.07,34.26.15a48.88,48.88,0,0,0,17.91-8.6l.17-.13c2.53-1.95,5.05-4.28,5.5-7.55,0,0-.05,0-.07,0C263.27,466.45,260,467.53,255.94,470.48Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M207,482.93c.47-.15.94-.32,1.4-.49a20,20,0,0,1,2.19-.71,22.33,22.33,0,0,1,6.69-.21c3.24.23,6.3.44,8.72-1.35a12.86,12.86,0,0,0,1.54-1.43,16.4,16.4,0,0,1,1.55-1.44c2.54-1.94,6-2,8.36-1.84.62,0,1.26.09,1.88.15a22.11,22.11,0,0,0,6.45-.09c3.06-.67,5.68-2.64,8.21-4.54l1.52-1.12c2.66-1.94,6.67-4.41,10.86-3.55a5.47,5.47,0,0,0-1.19-3.4c-1.69-2.1-3.71-1.76-5.57-1.28-8.3,2.15-15.89,7.16-24.45,7.66-1.19.07-2.49,0-3.21-1.36a3.82,3.82,0,0,1,.8-4.34c7.93-8.33,19.85-13.62,24.25-24.31.89-2.15,1.37-4.8-.19-6.63a22.41,22.41,0,0,1-11.36,11c-1.46.62-3,1.11-4.55,1.59-3.73,1.17-7.26,2.27-9.46,5.18a17.75,17.75,0,0,0-2.22,4.44c-.82,2.06-1.65,4.19-3.36,5.69s-4.16,2.17-6.47,2.73c-2.6.65-5.06,1.25-6.62,3.17a12.09,12.09,0,0,0-1.62,3.11,10.77,10.77,0,0,1-2.1,3.71c-1.75,1.76-4.29,2.09-6.76,2.4s-4.82.62-6.35,2.27a9.52,9.52,0,0,0-.73.9,7.09,7.09,0,0,1-1.17,1.35c-1.36,1.15-3.15,1.18-4.88,1.2a10.51,10.51,0,0,0-3.53.45A11.77,11.77,0,0,0,183.5,483l-.17.12,22.58.1.24-.06Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M183.08,482.35a12.18,12.18,0,0,1,2.25-1.26,11,11,0,0,1,3.8-.5c1.67,0,3.24,0,4.4-1a6.88,6.88,0,0,0,1-1.21,10.15,10.15,0,0,1,.78-1c1.73-1.85,4.32-2.18,6.82-2.5s4.75-.61,6.31-2.18a10.16,10.16,0,0,0,1.94-3.46,12.61,12.61,0,0,1,1.73-3.31c1.72-2.11,4.43-2.78,7-3.42,2.21-.55,4.5-1.12,6.14-2.56s2.33-3.34,3.15-5.41a19.06,19.06,0,0,1,2.32-4.62c2.36-3.1,6.17-4.29,9.85-5.45a47.16,47.16,0,0,0,4.47-1.56,21.63,21.63,0,0,0,11-10.62.39.39,0,0,1,.15-.16,4.15,4.15,0,0,0-.63-.44,5.61,5.61,0,0,0-3.36-.74c-6.64.52-11.14,6.14-17,8.78a7,7,0,0,1-3.81.77,4.62,4.62,0,0,1-2.73-1.48c-1.17,4.58-5.23,7.85-8.2,9.92-.65.45-1.33.9-2,1.34-2.92,2-5.92,4-8,6.78a30.57,30.57,0,0,0-1.94,3.15,13.23,13.23,0,0,1-7.94,7.52,11.85,11.85,0,0,0-6.46,5.15,18.88,18.88,0,0,1-2.24,2.74,19.23,19.23,0,0,1-5.42,3.23l-1.5.69a12,12,0,0,0-4.7,3.56h1.51l.1-.06C182.34,482.84,182.72,482.59,183.08,482.35Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M184.18,476c.72-.59,1.47-1.15,2.2-1.7a29.63,29.63,0,0,0,5.47-4.89c2.69-3.38,3.71-7.76,4.7-12,.93-4,1.9-8.11,4.23-11.51a33.06,33.06,0,0,1,6.89-6.73c2.67-2.14,5.43-4.36,7.19-7.29a29.47,29.47,0,0,0,2.85-7.93c.33-1.31.67-2.65,1.09-4a31.55,31.55,0,0,1,4.91-9.41c.95-1.26,2-2.45,3-3.61a38.19,38.19,0,0,0,4.72-6.13,34.52,34.52,0,0,0,4.39-13.2.39.39,0,0,1,0-.14c-1.76-.69-3.74-.15-5.48.57-8.1,3.37-14.13,10.46-18.38,18.14s-7,16.07-10.6,24.07c-1.32,2.94-2.85,5.95-5.84,7.47a6,6,0,0,1-3.87.59,7,7,0,0,1-.73-.19,18.61,18.61,0,0,1-3,12.66c-.67,1-1.46,1.94-2.21,2.85-1.77,2.14-3.44,4.15-3.9,6.7a15.62,15.62,0,0,0,.21,5.05,15.79,15.79,0,0,1,.18,5.4,15.44,15.44,0,0,1-2.08,4.73c-.41.72-.84,1.47-1.2,2.22-.57,1.2-1.43,3.49-.74,5.28a3.77,3.77,0,0,0,.47,0C179.49,480.67,181.28,478.36,184.18,476Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M143.31,402a34.72,34.72,0,0,0,.59,7.2,17,17,0,0,0,3.79,7.45,36,36,0,0,0,3.28,3.14c.84.73,1.71,1.48,2.51,2.29,2.35,2.37,3.6,4.77,3.71,7.15a14.36,14.36,0,0,1-.62,4.19A21.6,21.6,0,0,0,156,436c-.51,4.12,1.46,8.14,3.24,11.19l1.25,2.07a33.23,33.23,0,0,1,4.23,8.8,33.79,33.79,0,0,1,.65,3.68,31,31,0,0,0,.7,3.85c.87,3.16,2.76,6,4.6,8.72a49.27,49.27,0,0,1,3.34,5.49,51.58,51.58,0,0,0-2.1-10.18c-.24-.7-.5-1.4-.75-2.07a27.07,27.07,0,0,1-1.53-5,27.78,27.78,0,0,1-.2-5.83,29.75,29.75,0,0,0-.11-5.17,31.19,31.19,0,0,0-1.64-5.94c-1-2.89-2.06-5.87-1.72-9a21,21,0,0,1,1.41-5c.24-.62.5-1.33.73-2a24.31,24.31,0,0,0-1-17.36,8.18,8.18,0,0,1-.77-.59c-1.55-1.44-1.94-3.56-2.4-5.54a49.7,49.7,0,0,0-9-19c-4.33-5.6-11.48-10.68-18.22-6.52a33.77,33.77,0,0,1,6.46,17.48C143.28,399.38,143.3,400.71,143.31,402Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-41",
			d: "M177,483.1v0h1.3l0-.07H177Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-41",
			d: "M181.14,392.48a.36.36,0,0,0,0-.09.35.35,0,0,0-.21-.2.37.37,0,0,0-.29,0,.41.41,0,0,0-.21.22.39.39,0,0,0,0,.15l.11,0A3.68,3.68,0,0,1,181.14,392.48Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-4",
			d: "M191,438.18a5.08,5.08,0,0,1-.82-.36,17.82,17.82,0,0,1-2.87,12.59c-.65,1-1.42,1.89-2.17,2.79-1.75,2.12-3.56,4.3-4.06,7.06a16.55,16.55,0,0,0,.2,5.3,15,15,0,0,1,.19,5.13,14.6,14.6,0,0,1-2,4.5c-.42.73-.86,1.49-1.23,2.27a10.79,10.79,0,0,0-1,3.5c0-.16-.08-.32-.12-.46-.75-2.82-1.46-5.48-.32-7.91a10.9,10.9,0,0,1,.55-1,8,8,0,0,0,.83-1.71c.65-2.09-.39-4.06-1.4-6a17,17,0,0,1-1.31-2.86c-.89-2.9.07-5.81,1.08-8.89a26.51,26.51,0,0,0,1.47-6,24.54,24.54,0,0,0-1.16-8.29c-.34-1.34-.69-2.71-.92-4.07a24.11,24.11,0,0,1,0-7.86l-.76-.13a24.86,24.86,0,0,0,0,8.12c.23,1.39.59,2.78.94,4.13a24.54,24.54,0,0,1,1.14,8,26.52,26.52,0,0,1-1.44,5.79c-1,3.06-2.05,6.23-1.09,9.35a16.89,16.89,0,0,0,1.37,3c1,1.85,1.9,3.59,1.35,5.38a7.64,7.64,0,0,1-.77,1.54,12,12,0,0,0-.58,1.06c-1.26,2.68-.48,5.61.27,8.44.24.88.43,1.62.6,2.39h1.28c-.7-1.81.16-4.1.73-5.3.36-.75.79-1.5,1.2-2.22a15.44,15.44,0,0,0,2.08-4.73,15.79,15.79,0,0,0-.18-5.4,15.62,15.62,0,0,1-.21-5.05c.46-2.55,2.13-4.56,3.9-6.7.75-.91,1.54-1.86,2.21-2.85A18.61,18.61,0,0,0,191,438.18Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-4",
			d: "M176.75,422.45A48.28,48.28,0,0,1,179,417a52,52,0,0,0,2.16-5.14c1.39-4.08,3.23-12,0-19.41a3.68,3.68,0,0,0-.66.06l-.11,0a.32.32,0,0,0,0,.14c2.32,5.25,2.33,12.15,0,18.95a53.48,53.48,0,0,1-2.12,5.06,50.64,50.64,0,0,0-2.29,5.51,25,25,0,0,0-.87,3.64l.76.13A22.8,22.8,0,0,1,176.75,422.45Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-41",
			points: "104.61 436.27 104.61 436.32 105.39 436.33 105.38 436.26 104.61 436.26 104.61 436.27"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-4",
			d: "M175.12,482.48s0-.07,0-.07a62.13,62.13,0,0,0-2.44-13c-.24-.71-.52-1.44-.76-2.1a20.37,20.37,0,0,1-1.68-10.52,31.47,31.47,0,0,0-.11-5.31,31.87,31.87,0,0,0-1.69-6.08c-1-2.94-2-5.71-1.67-8.65a19.88,19.88,0,0,1,1.37-4.84c.25-.66.51-1.35.73-2a25.07,25.07,0,0,0-.72-17.26,4,4,0,0,1-1-.38,24.38,24.38,0,0,1,1,17.4c-.23.69-.49,1.4-.73,2a21,21,0,0,0-1.41,5c-.34,3.11.71,6.09,1.72,9a31.19,31.19,0,0,1,1.64,5.94,29.75,29.75,0,0,1,.11,5.17,27.78,27.78,0,0,0,.2,5.83,27.07,27.07,0,0,0,1.53,5c.25.67.51,1.37.75,2.07a51.58,51.58,0,0,1,2.1,10.18,49.27,49.27,0,0,0-3.34-5.49c-1.84-2.73-3.73-5.56-4.6-8.72a31,31,0,0,1-.7-3.85,33.79,33.79,0,0,0-.65-3.68,33.23,33.23,0,0,0-4.23-8.8l-1.25-2.07c-1.78-3-3.75-7.07-3.24-11.19a21.6,21.6,0,0,1,.54-2.61,14.36,14.36,0,0,0,.62-4.19c-.11-2.38-1.36-4.78-3.71-7.15-.8-.81-1.67-1.56-2.51-2.29a36,36,0,0,1-3.28-3.14,17,17,0,0,1-3.79-7.45,34.72,34.72,0,0,1-.59-7.2c0-1.28,0-2.61-.12-3.92a33.42,33.42,0,0,0-6.49-17.46c-.22.13-.43.28-.64.43a32.69,32.69,0,0,1,6.36,17.08c.09,1.29.11,2.6.12,3.88a35.8,35.8,0,0,0,.6,7.36,17.86,17.86,0,0,0,4,7.79,36.28,36.28,0,0,0,3.36,3.21c.82.72,1.68,1.47,2.46,2.25,2.21,2.23,3.39,4.47,3.49,6.64a13.47,13.47,0,0,1-.6,4,22.06,22.06,0,0,0-.56,2.71c-.54,4.34,1.51,8.52,3.35,11.67.41.7.85,1.43,1.25,2.08a32.58,32.58,0,0,1,4.14,8.59,33.65,33.65,0,0,1,.64,3.61,30.23,30.23,0,0,0,.72,3.94c.89,3.27,2.83,6.16,4.7,8.94a34.61,34.61,0,0,1,4.25,7.68,4.19,4.19,0,0,1,.1.64h.78C175.17,482.88,175.15,482.68,175.12,482.48Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-41",
			d: "M171.72,483.18s.94,0,.94,0l-.07-.1,0,0h-.91A.75.75,0,0,0,171.72,483.18Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-4",
			d: "M169.57,478.26a15.68,15.68,0,0,0-3.23-2.64,13.92,13.92,0,0,1-3.27-2.74,14.28,14.28,0,0,1-2.2-5.36,14.69,14.69,0,0,0-2.44-5.76,14.43,14.43,0,0,0-3.27-2.68l-.06,0-.62-.42a35.27,35.27,0,0,1-12.21-14.69.35.35,0,0,0-.17-.19,4.4,4.4,0,0,1-.56.31.32.32,0,0,0,0,.19,36,36,0,0,0,12.48,15l.68.45a14.12,14.12,0,0,1,3.1,2.53,13.8,13.8,0,0,1,2.29,5.46,14.75,14.75,0,0,0,2.34,5.65,14.94,14.94,0,0,0,3.45,2.9,15.94,15.94,0,0,1,3.08,2.51,16.76,16.76,0,0,1,1.85,2.89c.24.44.52.93.81,1.4h.91c-.37-.57-.71-1.19-1-1.79A17.7,17.7,0,0,0,169.57,478.26Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-41",
			d: "M169.58,483.1s1,0,1,0l0-.06h-1Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-4",
			d: "M165.72,478.89l-.94-.62a18.2,18.2,0,0,1-4.43-3.63,13.8,13.8,0,0,0-4.9-3.15,19.5,19.5,0,0,1-3.59-2c-2.13-1.61-3.38-4-4.7-6.46a23.14,23.14,0,0,0-4.08-6,22.41,22.41,0,0,0-4.75-3.18c-.81-.44-1.65-.91-2.43-1.41a21.59,21.59,0,0,1-7.46-8.1,45.19,45.19,0,0,1-2-4.53,44.78,44.78,0,0,0-2-4.68c-1.53-2.87-4.6-6-8.06-6.64a4.34,4.34,0,0,0-.43.68l.13.05c3.27.51,6.21,3.52,7.68,6.27a43.49,43.49,0,0,1,2,4.6,42.25,42.25,0,0,0,2,4.61,22.39,22.39,0,0,0,7.72,8.39c.81.52,1.66,1,2.48,1.44a21.86,21.86,0,0,1,4.59,3.06,22.26,22.26,0,0,1,3.93,5.84c1.3,2.45,2.65,5,4.92,6.71a19.66,19.66,0,0,0,3.73,2.05,13.11,13.11,0,0,1,4.64,3,19.33,19.33,0,0,0,4.56,3.75l1,.63a25.7,25.7,0,0,1,4.24,3.52h1l0,0A25.68,25.68,0,0,0,165.72,478.89Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-41",
			d: "M163.24,483.11h2.62l-.07,0h.8l-.06-.06-3.61,0Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-4",
			d: "M162.32,480.62a16.55,16.55,0,0,1-2.92-1.35,15.87,15.87,0,0,1-3.09-2.89c-1.56-1.73-3.17-3.52-5.54-3.79a9.14,9.14,0,0,0-2,.06c-.41,0-.84.08-1.25.09a6.77,6.77,0,0,1-5.06-2.27c-.24-.27-.46-.58-.69-.87a7.49,7.49,0,0,0-1.46-1.63c-1.38-1.07-3.14-1.11-4.84-1.15-.67,0-1.36,0-2-.12a9,9,0,0,1-6.48-4.26c-.25-.43-.5-1-.77-1.56-.81-1.76-1.72-3.74-3.33-4a2.4,2.4,0,0,1-.53.63.37.37,0,0,0,.27.11c1.28.05,2.13,1.91,2.89,3.56a15.47,15.47,0,0,0,.81,1.63,9.77,9.77,0,0,0,7,4.64c.69.08,1.4.1,2.08.12,1.65,0,3.2.08,4.39,1a7.3,7.3,0,0,1,1.32,1.48c.22.3.46.62.72.92a7.5,7.5,0,0,0,5.55,2.53h.1c.45,0,.89-.05,1.32-.09a8.35,8.35,0,0,1,1.86-.06c2.08.23,3.52,1.84,5.06,3.53a16.64,16.64,0,0,0,3.25,3,17.06,17.06,0,0,0,3.06,1.42,12.87,12.87,0,0,1,3.24,1.59,42.15,42.15,0,0,0-10.07-2c-.62-.05-1.25-.08-1.85-.11-3.23-.17-6.25-.33-8.81-2.16-.77-.55-1.52-1.16-2.25-1.75-1.93-1.57-3.93-3.2-6.4-3.8a16.65,16.65,0,0,0-2.95-.37c-.6,0-1.23-.08-1.84-.16-4.56-.63-8.27-3.77-10.58-6.29-.25-.28-.49-.56-.75-.84a14.73,14.73,0,0,0-4-3.58,15.14,15.14,0,0,0-4.86-1.29,20.8,20.8,0,0,1-3.25-.66,3,3,0,0,0-.31.69l.07,0a22.42,22.42,0,0,0,3.37.69,14.92,14.92,0,0,1,4.63,1.21,14.38,14.38,0,0,1,3.82,3.41l.76.85c3.42,3.75,7.24,6,11,6.53.62.09,1.26.13,1.87.17a16.46,16.46,0,0,1,2.83.34c2.31.57,4.23,2.14,6.1,3.66.74.6,1.51,1.22,2.29,1.78,2.74,2,5.87,2.12,9.19,2.29l1.86.11a41.39,41.39,0,0,1,7.76,1.35l3.61,0,0,0A10.45,10.45,0,0,0,162.32,480.62Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-41",
			d: "M146,483l16.18.07V483l-17-.08Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-4",
			d: "M153.08,482.51c-6.39-.13-13-.26-18.78-3-.73-.34-1.47-.74-2.19-1.13-2.42-1.29-4.9-2.62-7.65-2.48a13.91,13.91,0,0,0-2.34.36,10.86,10.86,0,0,1-2.79.34c-2.66-.13-4.87-2.19-6.91-4.3a1.79,1.79,0,0,1-.57.52c2.15,2.22,4.49,4.41,7.44,4.55a11.89,11.89,0,0,0,3-.36,14.07,14.07,0,0,1,2.21-.34c2.55-.12,4.93,1.15,7.23,2.38.75.4,1.5.8,2.25,1.16a32.51,32.51,0,0,0,11.21,2.72l17,.08V483C159.16,482.63,156.07,482.57,153.08,482.51Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-41",
			d: "M178.67,483.16h.73l-.06.1h.9l.12-.17h-1.67Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-41",
			d: "M228.71,439s0-.1,0-.16a.38.38,0,0,0-.28-.46.42.42,0,0,0-.25,0A4.75,4.75,0,0,0,228.71,439Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-41",
			d: "M236.63,387.77a.43.43,0,0,0-.08-.29.4.4,0,0,0-.26-.14.38.38,0,0,0-.38.19,4.24,4.24,0,0,1,.7.37A.51.51,0,0,1,236.63,387.77Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-4",
			d: "M185.06,479.54l1.5-.69a19.23,19.23,0,0,0,5.42-3.23,18.88,18.88,0,0,0,2.24-2.74,11.85,11.85,0,0,1,6.46-5.15,13.23,13.23,0,0,0,7.94-7.52,30.57,30.57,0,0,1,1.94-3.15c2.05-2.81,5.05-4.81,7.94-6.76.68-.46,1.36-.91,2-1.36,3-2.07,7-5.34,8.2-9.92a4.75,4.75,0,0,1-.49-.6.45.45,0,0,0-.22.26c-1.05,4.41-5,7.6-7.93,9.62-.64.45-1.31.9-2,1.34-3,2-6,4.05-8.17,7a30.8,30.8,0,0,0-2,3.23,16.68,16.68,0,0,1-3.77,5.1,17.06,17.06,0,0,1-3.82,2.1,16.74,16.74,0,0,0-4.15,2.35,16.4,16.4,0,0,0-2.61,3.05,17.68,17.68,0,0,1-2.16,2.63,18.51,18.51,0,0,1-5.2,3.09c-.49.22-1,.45-1.51.7a12.58,12.58,0,0,0-5.14,4,15.71,15.71,0,0,1,5.07-6.25c.71-.58,1.46-1.14,2.18-1.69a30,30,0,0,0,5.61-5c2.8-3.51,3.85-8,4.85-12.3.92-3.92,1.86-8,4.11-11.25a32.82,32.82,0,0,1,6.74-6.57c2.73-2.19,5.54-4.45,7.37-7.49a29.78,29.78,0,0,0,2.93-8.15c.33-1.28.67-2.61,1.08-3.89a30.63,30.63,0,0,1,4.8-9.18c.93-1.24,2-2.43,3-3.58a38.55,38.55,0,0,0,4.8-6.25,35.24,35.24,0,0,0,4.47-13.35,4.24,4.24,0,0,0-.7-.37.39.39,0,0,0,0,.14,34.52,34.52,0,0,1-4.39,13.2,37.67,37.67,0,0,1-4.71,6.11c-1,1.18-2.1,2.37-3,3.63A31.55,31.55,0,0,0,218.8,420c-.42,1.3-.76,2.64-1.09,4a29.47,29.47,0,0,1-2.85,7.93c-1.76,2.93-4.52,5.15-7.19,7.29a33.06,33.06,0,0,0-6.89,6.73c-2.33,3.4-3.3,7.52-4.23,11.51-1,4.24-2,8.62-4.7,12a29.63,29.63,0,0,1-5.47,4.89c-.73.55-1.48,1.11-2.2,1.7-2.9,2.34-4.69,4.65-5.48,7.05,0,0,1.66,0,1.66,0A12,12,0,0,1,185.06,479.54Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-41",
			points: "111.95 436.36 113.42 436.36 113.52 436.3 112.06 436.29 111.95 436.36"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-41",
			d: "M256.79,432.65a.4.4,0,0,0-.17-.55.41.41,0,0,0-.29,0l-.07,0A5.23,5.23,0,0,1,256.79,432.65Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-4",
			d: "M185.61,481.81a10.51,10.51,0,0,1,3.53-.45c1.73,0,3.52-.05,4.88-1.2a7.09,7.09,0,0,0,1.17-1.35,9.52,9.52,0,0,1,.73-.9c1.53-1.65,3.87-2,6.35-2.27s5-.64,6.76-2.4a10.77,10.77,0,0,0,2.1-3.71,12.09,12.09,0,0,1,1.62-3.11c1.56-1.92,4-2.52,6.62-3.17,2.31-.56,4.69-1.15,6.47-2.73s2.54-3.63,3.36-5.69a17.75,17.75,0,0,1,2.22-4.44c2.2-2.91,5.73-4,9.46-5.18,1.52-.48,3.09-1,4.55-1.59a22.41,22.41,0,0,0,11.36-11,5.23,5.23,0,0,0-.53-.52.39.39,0,0,0-.15.16,21.63,21.63,0,0,1-11,10.62,47.16,47.16,0,0,1-4.47,1.56c-3.68,1.16-7.49,2.35-9.85,5.45a19.06,19.06,0,0,0-2.32,4.62c-.82,2.07-1.58,4-3.15,5.41s-3.93,2-6.14,2.56c-2.61.64-5.32,1.31-7,3.42a12.61,12.61,0,0,0-1.73,3.31,10.16,10.16,0,0,1-1.94,3.46c-1.56,1.57-3.86,1.87-6.31,2.18s-5.09.65-6.82,2.5a10.15,10.15,0,0,0-.78,1,6.88,6.88,0,0,1-1,1.21c-1.16,1-2.73,1-4.4,1a11,11,0,0,0-3.8.5,12.18,12.18,0,0,0-2.25,1.26c-.36.24-.74.49-1.11.7l-.1.06h1.46l.17-.12A11.77,11.77,0,0,1,185.61,481.81Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-41",
			d: "M266.4,466.32c0,.24-.06.5-.09.76a.43.43,0,0,0,.22-.06.42.42,0,0,0,.16-.25A.37.37,0,0,0,266.4,466.32Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-41",
			points: "135.85 436.46 138.49 436.48 138.67 436.41 136.1 436.4 135.85 436.46"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-4",
			d: "M266.35,466.31c-4.19-.86-8.2,1.61-10.86,3.55L254,471c-2.56,1.92-5.18,3.89-8.24,4.56a22.11,22.11,0,0,1-6.45.09c-.62-.06-1.26-.11-1.88-.15-2.37-.14-5.82-.1-8.36,1.84a16.4,16.4,0,0,0-1.55,1.44,12.86,12.86,0,0,1-1.54,1.43c-2.42,1.79-5.48,1.58-8.72,1.35a22.33,22.33,0,0,0-6.69.21,18.37,18.37,0,0,0-2.17.71c-.48.17-1,.34-1.42.49l-.83.23-.24.06h2.56l.2-.07a19.42,19.42,0,0,1,2.08-.68,21.35,21.35,0,0,1,6.45-.19c3.24.23,6.59.46,9.24-1.5a14.75,14.75,0,0,0,1.64-1.51,13.46,13.46,0,0,1,1.46-1.37c2.33-1.78,5.59-1.81,7.84-1.68l1.86.14s0-.06,0-.06v.06a22.34,22.34,0,0,0,6.68-.1c3.22-.7,5.91-2.72,8.51-4.67.5-.38,1-.76,1.5-1.12,4.05-3,7.33-4,10.3-3.41h.07A6.74,6.74,0,0,0,266.35,466.31Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M695.9,484.33c0,.4,0,.81-.1,1.23l6.67,0c-1.08-4.87-2.07-9.78-2.93-14.65-1.61-9.07-3.1-19.57-.45-29.47a80.75,80.75,0,0,1,5.59-13.72c1.18-2.45,2.4-5,3.44-7.51,3.59-8.69,4.1-15.77,1.58-21.64-.5-1.16-1.14-2.33-1.76-3.46-1.59-2.91-3.23-5.91-2.78-9.15a.48.48,0,0,1,.53-.4.49.49,0,0,1,.4.53c-.41,2.93,1.08,5.67,2.67,8.57.63,1.15,1.28,2.34,1.79,3.54,2.63,6.11,2.12,13.43-1.57,22.37-1.05,2.55-2.28,5.1-3.46,7.56A78.84,78.84,0,0,0,700,441.71c-2.6,9.71-1.12,20.1.46,29.06.88,4.93,1.88,9.9,3,14.83l4.85,0a.45.45,0,0,1-.07-.39c.79-3.12.14-6.26-.55-9.59a26.49,26.49,0,0,1-.82-8.59,27.63,27.63,0,0,1,2.92-8.26,31.14,31.14,0,0,0,2.7-7.1c.66-3.41,0-6.79-.58-10.37a42.23,42.23,0,0,1-.89-7.45,22.36,22.36,0,0,1,3.76-12.27c.91-1.38,2-2.69,3-4a39.45,39.45,0,0,0,3.56-4.88,16.63,16.63,0,0,0,2.23-10c-.33-3.38-1.74-6.68-3.1-9.87-.7-1.64-1.42-3.34-2-5-1.14-3.35-2.37-9.3.93-13.91a32.54,32.54,0,0,0-6.51,5.84c-2.53,2.73-5.84,5.63-10.16,6.72-1.05,3.72-.48,7.49.13,11.47a38.8,38.8,0,0,1,.65,8.87c-.34,4.25-2.09,8.3-3.79,12.22-.69,1.6-1.4,3.25-2,4.89-4.63,12.53-3.58,26-2.56,39A177.83,177.83,0,0,1,695.9,484.33Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M671.66,406.73c.39.58.82,1.17,1.24,1.73.7,1,1.42,1.93,2,3a23.57,23.57,0,0,1,2.76,7.71c1.07,5.49,1,11.13.86,16.58,0,2.06-.09,4.2-.06,6.29a105.2,105.2,0,0,0,10.23,43.54l6.15,0c0-.43.08-.85.1-1.28a174.13,174.13,0,0,0-.79-21.3c-1-13.1-2.08-26.66,2.62-39.38.61-1.66,1.33-3.32,2-4.94,1.66-3.84,3.38-7.83,3.71-11.91a38.27,38.27,0,0,0-.64-8.66c-.57-3.75-1.16-7.62-.23-11.39a14.51,14.51,0,0,1-2.59.23c-4.5,0-8.12-2-11.94-3.71a.43.43,0,0,1-.09.21c-3.1,4.26-2.57,9.57-1.58,13.27a63.28,63.28,0,0,0,2.49,7,67.83,67.83,0,0,1,2.34,6.45,34.28,34.28,0,0,1-3.15,26.43.45.45,0,0,1-.41.24.47.47,0,0,1-.4-.24c-2-3.54-2.05-7.5-2.07-11.33a42.78,42.78,0,0,0-.31-6c-.6-4-2.44-7.9-4.21-11.67-2.11-4.48-4.3-9.13-4.46-14a18.94,18.94,0,0,1,4.38-12.5.49.49,0,0,1,.3-.17,18.8,18.8,0,0,0-5.8.14c.86,1.26.07,2.78-1,3.68a11.56,11.56,0,0,1-1.86,1.16,15.9,15.9,0,0,0-1.47.89c-2.9,2.09-3,5.79-2.67,8.52A27,27,0,0,0,671.66,406.73Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M647,400.19a.47.47,0,0,1,.38.54c-.66,4,.83,8.45,4.54,13.57,1.14,1.57,2.41,3.12,3.63,4.62a61,61,0,0,1,5.8,7.93,26.6,26.6,0,0,1,3.6,14.88,52.12,52.12,0,0,1-1.33,8.06c-.94,4.29-1.82,8.34-1,12.45a33.35,33.35,0,0,0,3,8,47.68,47.68,0,0,1,2.54,6,22.07,22.07,0,0,1,1.06,7.19,8,8,0,0,1-.29,2l12.16.06a33.9,33.9,0,0,0-4.21-6.73,49.68,49.68,0,0,1-3.42-5c-2.74-4.9-3.6-10.93-2.48-17.44.38-2.22,1-4.47,1.55-6.64,1.27-4.76,2.57-9.69,1.61-14.49-1-5.29-4.75-10-8.34-14.52-1-1.25-2-2.55-3-3.84-4-5.48-8.06-13.45-4.23-20.3a.47.47,0,0,1,.63-.18.47.47,0,0,1,.18.64c-3.59,6.41.28,14,4.16,19.28.95,1.28,2,2.57,2.95,3.82,3.65,4.62,7.43,9.4,8.53,14.92,1,5-.34,10-1.63,14.92-.57,2.15-1.16,4.37-1.53,6.55-1.09,6.29-.27,12.1,2.37,16.81a50.08,50.08,0,0,0,3.35,4.95,32.39,32.39,0,0,1,4.46,7.29l5.57,0A106,106,0,0,1,677.56,442c0-2.11,0-4.25.05-6.32.11-5.4.22-11-.83-16.38a22.68,22.68,0,0,0-2.64-7.4c-.59-1-1.3-1.95-2-2.88-.42-.57-.85-1.16-1.26-1.75a28,28,0,0,1-4.67-11.82c-.42-3-.23-7.05,3-9.42a16.7,16.7,0,0,1,1.57-.94,11.69,11.69,0,0,0,1.72-1.08c.8-.65,1.35-1.69.83-2.43a.51.51,0,0,1-.08-.34,13.79,13.79,0,0,0-5.76,2.67c-4.62,3.91-3.86,10.43-10.41,12.87-1.93.72-4.21.92-6.25,1.51a12.9,12.9,0,0,0-4,1.89Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M709.1,485.47a.35.35,0,0,1-.07.15l6.84,0c2.5-5.43,2.29-11.51,2.09-17.41-.05-1.2-.09-2.45-.11-3.66a62.81,62.81,0,0,1,2.95-21.16,105.77,105.77,0,0,1,7.42-15.95c3.52-6.61,7.17-13.44,8.65-20.62,2.38-11.61-1-23.79-4-34.54a16.42,16.42,0,0,0-7.19-.68,15.24,15.24,0,0,0-4.27,1.19.46.46,0,0,1-.13.29c-4.5,4.37-3.17,10.9-2,14.41.57,1.67,1.28,3.35,2,5,1.38,3.26,2.82,6.63,3.17,10.16a17.56,17.56,0,0,1-2.36,10.57,38.79,38.79,0,0,1-3.64,5c-1,1.26-2.06,2.55-2.94,3.89a21.35,21.35,0,0,0-3.61,11.75,42.68,42.68,0,0,0,.87,7.28c.63,3.51,1.27,7.14.58,10.72a31.61,31.61,0,0,1-2.78,7.33,27.07,27.07,0,0,0-2.83,8,26.24,26.24,0,0,0,.81,8.28C709.24,478.73,710,482.13,709.1,485.47Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M634.38,449.4a50.6,50.6,0,0,0,4.53,5.57,37.16,37.16,0,0,1,5.84,7.82,32.31,32.31,0,0,1,2.2,6.71,30.32,30.32,0,0,0,2.2,6.67,35.49,35.49,0,0,0,3,4.58,36.54,36.54,0,0,1,3,4.63l3.86,0-.11-.14c-4.25-5.83-9.07-12.42-10.67-19.64a49.63,49.63,0,0,1-.83-5.76c-.4-3.81-.78-7.4-2.74-10.67a30.31,30.31,0,0,0-3-3.94c-.82-1-1.68-1.95-2.41-3-2.15-3-2.72-6-1.61-8.38a.45.45,0,0,1,.61-.23.47.47,0,0,1,.23.63c-1.29,2.76.4,5.84,1.52,7.43.71,1,1.55,2,2.36,2.93a29.79,29.79,0,0,1,3.12,4.06c2.06,3.45,2.47,7.32,2.86,11.06a51.23,51.23,0,0,0,.81,5.65c1.56,7,6.32,13.54,10.52,19.29.18.25.37.48.55.7l7.82,0a7.41,7.41,0,0,0,.32-2.06,21.29,21.29,0,0,0-1-6.88,47.75,47.75,0,0,0-2.5-5.86,34.12,34.12,0,0,1-3.12-8.22c-.81-4.3.14-8.64,1-12.83a51,51,0,0,0,1.31-7.91,25.73,25.73,0,0,0-3.47-14.36,60.21,60.21,0,0,0-5.72-7.8c-1.23-1.51-2.51-3.07-3.66-4.66-3.87-5.34-5.41-10-4.71-14.28a.29.29,0,0,1,0-.1,10.46,10.46,0,0,0-3.56,11c1.33,5,5.15,9.67,6.51,14.69.89,3.31-.44,7.67-5.44,8.28-4.37.54-8-2.29-12.44-2.82l-.31,0a.46.46,0,0,1,.29.57A20.77,20.77,0,0,0,634.38,449.4Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M718.89,468.2c.2,5.88.41,11.93-2,17.46l11.59,0a22.85,22.85,0,0,1,.5-9.19,70.78,70.78,0,0,1,7.75-19.92c.33-.58.67-1.15,1-1.72a34.93,34.93,0,0,0,3.53-7.15,32.33,32.33,0,0,0,1.1-6.83c.29-3.23.59-6.57,2.23-9.59a28.29,28.29,0,0,1,2.22-3.29,19.22,19.22,0,0,0,2.65-4.22c1.11-2.77.7-5.89.35-8.64a.46.46,0,0,1,.16-.43,9.12,9.12,0,0,1-2.17-4.24c-.21-.86-.37-1.73-.5-2.6-.85,3.1-3,5.89-5.11,8.61s-4.35,5.64-5.15,8.77a21.62,21.62,0,0,0-.1,7.62,32.53,32.53,0,0,1,.25,5.59,17.32,17.32,0,0,1-3.17,8.73,39,39,0,0,1-2.56,3.17,21.57,21.57,0,0,0-3.77,5.31c-1.36,3.14-.89,6.45-.4,10a20,20,0,0,1-1.69,13.94c-.42,1-.85,2-1.2,3-.26.74-.48,1.49-.67,2.25h-1a25.62,25.62,0,0,1,.75-2.55c.36-1,.8-2.07,1.22-3.07a19.06,19.06,0,0,0,1.63-13.43c-.49-3.49-1-7.09.47-10.48a22.48,22.48,0,0,1,3.92-5.55,38,38,0,0,0,2.5-3.09,16.43,16.43,0,0,0,3-8.26A31.86,31.86,0,0,0,736,433a22.61,22.61,0,0,1,.12-8c.85-3.32,3.12-6.26,5.31-9.11,2.72-3.52,5.29-6.84,5.31-10.74a.46.46,0,0,1,.21-.39c-.65-8.6.75-17.41-4.37-25.26a18.57,18.57,0,0,0-8.65-6.84c3,10.69,6.21,22.74,3.83,34.35-1.51,7.31-5.19,14.21-8.74,20.88a104.68,104.68,0,0,0-7.36,15.8,62,62,0,0,0-2.9,20.84C718.8,465.77,718.84,467,718.89,468.2Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M732,485.73a8.43,8.43,0,0,0,1.45-3.53,28.07,28.07,0,0,0,.3-3.31c0-.79.07-1.62.16-2.43a19.85,19.85,0,0,1,2.93-8.22,43.07,43.07,0,0,1,3.71-4.81c.94-1.13,1.93-2.29,2.78-3.48a25.36,25.36,0,0,0,4.92-15.38c0-.75-.07-1.53-.13-2.29-.17-2.41-.34-4.91.58-7.27a18.78,18.78,0,0,1,3-4.66c.29-.37.59-.74.87-1.11a33.38,33.38,0,0,0,6.07-12.57,19.25,19.25,0,0,1-4.67.1,7,7,0,0,1-3.22-1.32c.36,2.76.69,5.84-.46,8.7a20.24,20.24,0,0,1-2.76,4.43,27.41,27.41,0,0,0-2.16,3.18c-1.54,2.85-1.82,5.95-2.11,9.22a33.36,33.36,0,0,1-1.14,7,35.34,35.34,0,0,1-3.62,7.35c-.33.57-.67,1.14-1,1.71a69.73,69.73,0,0,0-7.65,19.65,21.62,21.62,0,0,0-.46,9Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M608.77,475.82c.32.87.56,1.76.79,2.63a15.57,15.57,0,0,0,1.71,4.48,12.85,12.85,0,0,0,2,2.26l11.15.05a16.43,16.43,0,0,0-5.36-5.68c-.57-.34-1.2-.64-1.81-.93a20,20,0,0,1-2.49-1.36,13.94,13.94,0,0,1-4.11-5.18c-1.14-2.06-2.22-4-4.49-5.19a.41.41,0,0,1-.2-.21c-.41.21-.82.42-1.21.64-.56.32-1.08.65-1.58,1A17.17,17.17,0,0,1,608.77,475.82Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M619.57,458.89a.47.47,0,0,1,.45.22c.76,1.25,2.56,1.64,4.46,2a17.25,17.25,0,0,1,3.21.91c3.6,1.55,4.48,5,5.34,8.31.24.94.49,1.91.79,2.8,1.17,3.38,3.73,6.42,6.08,8.95,1,1.08,2.09,2.17,3.27,3.21l10.9.05a38.06,38.06,0,0,0-2.69-4.07,35.43,35.43,0,0,1-3.06-4.71,31.44,31.44,0,0,1-2.27-6.87,32.49,32.49,0,0,0-2.13-6.52,36.36,36.36,0,0,0-5.7-7.61,49.66,49.66,0,0,1-4.61-5.67,21.74,21.74,0,0,1-2.93-18,.45.45,0,0,1,.38-.33,12.28,12.28,0,0,0-10.33,4.33.46.46,0,0,1,.22.49c-.86,4.38,1.09,9.39,5.8,14.89,1.16,1.35,2.41,2.69,3.63,4,2.82,3,5.74,6.12,7.68,9.65a48.93,48.93,0,0,1,2.26,5c1.21,3,2.35,5.89,4.61,8.3a.48.48,0,0,1,0,.67.44.44,0,0,1-.32.12.48.48,0,0,1-.34-.14c-2.38-2.54-3.61-5.62-4.8-8.59a44.51,44.51,0,0,0-2.21-4.95c-1.88-3.42-4.76-6.49-7.53-9.45-1.23-1.31-2.49-2.66-3.67-4-4.62-5.41-6.64-10.22-6.15-14.68a7.35,7.35,0,0,0-.34.76c-1.31,3.64.06,7.43,1,11.13C621.3,452.38,621.64,455.94,619.57,458.89Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M680.39,381.69a18.08,18.08,0,0,0-4.17,11.88c.16,4.71,2.3,9.26,4.37,13.66,1.8,3.83,3.67,7.79,4.29,11.93a43.42,43.42,0,0,1,.32,6.13c0,3.59,0,7,1.55,10.11a33.27,33.27,0,0,0,2.66-24.94c-.62-2.15-1.48-4.3-2.31-6.37a63.67,63.67,0,0,1-2.53-7.14c-1.05-3.91-1.59-9.52,1.74-14.07a24.06,24.06,0,0,0-5.66-1.84l-.45-.08.12.07A.47.47,0,0,1,680.39,381.69Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M604.59,485.15a42.35,42.35,0,0,1-4.1-6,1.67,1.67,0,0,0-.62-.75,2.38,2.38,0,0,0-.77-.16,3.8,3.8,0,0,1-.65-.1,2.38,2.38,0,0,1-1.42-1,12.49,12.49,0,0,0,1.15,8Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M597.67,476.25a1.29,1.29,0,0,0,1,.93,4,4,0,0,0,.53.08,3,3,0,0,1,1.08.25,2.56,2.56,0,0,1,1,1.13,41.57,41.57,0,0,0,4.49,6.52h2.6c-2-1.69-2.95-4-3.89-6.26-1.09-2.62-2.12-5.09-4.62-6.6a.47.47,0,0,1-.16-.64.45.45,0,0,1,.64-.16c2.76,1.66,3.9,4.39,5,7s2,4.88,4.31,6.44a.37.37,0,0,1,.16.19h2a11.76,11.76,0,0,1-1.4-1.76,16.21,16.21,0,0,1-1.83-4.74c-.23-.84-.46-1.71-.76-2.54a16.25,16.25,0,0,0-5.54-7.22,14,14,0,0,0-5,6.94A.47.47,0,0,1,597.67,476.25Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M614.29,463.23c-.32,4.06,2.56,8.16,7,10,.93.38,1.93.67,2.9,1a19.59,19.59,0,0,1,4.4,1.67c3.21,1.86,4.47,5,5.68,8,.2.49.4,1,.61,1.47l6.86,0c-.9-.84-1.74-1.7-2.53-2.56-2.42-2.6-5.06-5.73-6.29-9.28-.31-.93-.57-1.92-.81-2.87-.84-3.25-1.62-6.32-4.8-7.69a17.1,17.1,0,0,0-3-.85c-2-.43-4.09-.87-5.06-2.47a.36.36,0,0,1-.07-.17,6.87,6.87,0,0,1-.52.57,16.22,16.22,0,0,1-4.4,3A.6.6,0,0,1,614.29,463.23Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M611.41,471.63a13,13,0,0,0,3.83,4.86,17.08,17.08,0,0,0,2.36,1.29c.63.3,1.27.61,1.88,1a17.86,17.86,0,0,1,6,6.5l8.42,0c-.16-.37-.31-.74-.46-1.11-1.21-3-2.35-5.83-5.28-7.52a19,19,0,0,0-4.19-1.59,29.24,29.24,0,0,1-3-1c-4.73-1.93-7.83-6.29-7.62-10.66-2.09,1-4.38,1.83-6.49,2.82C609.15,467.56,610.3,469.62,611.41,471.63Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M767.41,485.89l.5-.35a30.41,30.41,0,0,1,4.88-2.43c2.64-1.12,5.12-2.19,6.69-4.07a12.44,12.44,0,0,0,2.2-5.41,24.54,24.54,0,0,1,.81-3,16.73,16.73,0,0,1,9.91-9.49.47.47,0,0,1,.4,0,7.77,7.77,0,0,0-1.64-6.14,10.42,10.42,0,0,1-5.12,7.07c-.38.22-.78.43-1.16.63a11.88,11.88,0,0,0-2.15,1.33c-1.3,1.13-1.76,2.69-2.25,4.34a21.27,21.27,0,0,1-.69,2.09,12.56,12.56,0,0,1-5.54,6.07,29.07,29.07,0,0,1-3,1.44c-.91.39-1.86.8-2.72,1.27a20.67,20.67,0,0,0-6.88,6.55Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M760.47,485.85a22.65,22.65,0,0,1,7.57-7.37c.91-.49,1.87-.9,2.81-1.3a31.7,31.7,0,0,0,2.94-1.39,11.68,11.68,0,0,0,5.14-5.62,19.5,19.5,0,0,0,.66-2,9.21,9.21,0,0,1,2.54-4.78,12.36,12.36,0,0,1,2.32-1.45c.37-.2.76-.4,1.12-.61a9.41,9.41,0,0,0,4.71-6.66.45.45,0,0,1,.22-.33,10.48,10.48,0,0,0-1.6-1.29,47.84,47.84,0,0,0-6.53-3c0,2.28-.88,4.7-2.88,7.57-.54.77-1.11,1.53-1.67,2.26a22,22,0,0,0-4.52,8.06,18.94,18.94,0,0,1-2.34,5,23.4,23.4,0,0,1-5.5,4.86L764,478.86c-2,1.45-4.6,3.69-5.06,6.44a.48.48,0,0,1-.47.4h-.08a.48.48,0,0,1-.38-.55c.52-3.09,3.35-5.51,5.44-7.05l1.49-1.08a22.45,22.45,0,0,0,5.28-4.64,18,18,0,0,0,2.22-4.78,30.24,30.24,0,0,1,1.28-3.24,31.23,31.23,0,0,1,3.38-5.09c.55-.73,1.12-1.48,1.65-2.23,2-2.89,2.87-5.26,2.68-7.45a14,14,0,0,1-2.33-1.41,7.48,7.48,0,0,1-2.36-3,7.65,7.65,0,0,0-4.23,5.68,25.4,25.4,0,0,0-.4,3.89,30.74,30.74,0,0,1-.29,3.42,17.76,17.76,0,0,1-6.18,10.51c-1,.89-2.21,1.7-3.33,2.48a21.47,21.47,0,0,0-5.42,4.71,17,17,0,0,0-2.28,5.76l-1.1,4.19Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M794.67,486a11.68,11.68,0,0,0,6.87-2.22,25.44,25.44,0,0,0,5.2-4.75c2.24-2.87,3.08-6.38,1.08-9.34a7.83,7.83,0,0,0-.8-1,18.09,18.09,0,0,1-7.56,10.7c-.83.57-1.72,1.09-2.58,1.59a23.07,23.07,0,0,0-4.25,2.94,21,21,0,0,0-1.76,2Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M789.65,486c.16-.18.31-.37.46-.57a21,21,0,0,1,1.89-2.16,23.56,23.56,0,0,1,4.42-3.07c.85-.49,1.72-1,2.52-1.55A17,17,0,0,0,806.21,468a12.25,12.25,0,0,0-3.48-1.84,5.14,5.14,0,0,1-2.3,6.09,13.86,13.86,0,0,1-2.49,1.1,10.4,10.4,0,0,0-2.68,1.27,7.6,7.6,0,0,0-2.16,3.24c-.18.41-.37.83-.58,1.23a14,14,0,0,1-5.67,5.72,19.8,19.8,0,0,1-2.42,1.13Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M745.81,485.79a6.9,6.9,0,0,0,2.17-3.67,12.45,12.45,0,0,0,0-3.8,9.92,9.92,0,0,1,.42-5.36c1.18-2.59,4.1-4,6.92-5.44,1.07-.53,2.18-1.08,3.17-1.68A16.6,16.6,0,0,0,766,448.57c-.09-.49-.2-1-.31-1.49-.45-2.1-.92-4.29-.09-6.38s2.54-3.42,4.24-4.84c.44-.37.88-.73,1.3-1.1,4-3.52,5.65-7.67,4.49-11.1a.47.47,0,0,1,.29-.59.45.45,0,0,1,.59.29c1.29,3.8-.49,8.32-4.76,12.11-.42.37-.87.74-1.31,1.11-1.62,1.35-3.28,2.74-4,4.47s-.31,3.77.13,5.84c.11.5.22,1,.31,1.51a17.51,17.51,0,0,1-8,18.24c-1,.62-2.15,1.18-3.24,1.73-2.8,1.38-5.44,2.7-6.49,5a9.16,9.16,0,0,0-.33,4.87,13.67,13.67,0,0,1,0,4.09,7.53,7.53,0,0,1-1.78,3.48l5.42,0,1.16-4.43a17.9,17.9,0,0,1,2.43-6.06,22.26,22.26,0,0,1,5.64-4.94c1.1-.77,2.25-1.57,3.26-2.43a16.8,16.8,0,0,0,5.86-9.94,30.75,30.75,0,0,0,.28-3.32,26.76,26.76,0,0,1,.42-4,8.58,8.58,0,0,1,4.81-6.37,11.29,11.29,0,0,1,.38-6.27c1.09-3.47,3-6.91,2.56-10.44-.5-4-4.45-7.5-9.68-9.44a3.51,3.51,0,0,1,0,1.48,7.51,7.51,0,0,1-3.38,4.42c-.74.49-1.53.94-2.3,1.38a13.67,13.67,0,0,0-4.38,3.26c-1.57,2.07-1.39,4.72-1.21,7.29l.05.67c.39,5.93-.51,14.11-7,19.47-.57.47-1.18.92-1.77,1.35a25.43,25.43,0,0,0-2.28,1.8c-2.63,2.41-3.85,5.61-5,8.7-1.79,4.71-3.63,9.46-5.45,14.1-.47,1.19-1,2.43-1.5,3.68Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M781.7,486a27.94,27.94,0,0,0,4.7-1.94,13.18,13.18,0,0,0,5.3-5.33c.19-.38.37-.79.55-1.18a8.44,8.44,0,0,1,2.45-3.61,10.93,10.93,0,0,1,2.92-1.4,13,13,0,0,0,2.32-1,4.11,4.11,0,0,0,1.74-5.33.56.56,0,0,1,0-.28,12.9,12.9,0,0,0-5.8-.17,29.72,29.72,0,0,0-4.21,1.44c-.75.31-1.5-.4-1-1a11.14,11.14,0,0,0,2-4,15.8,15.8,0,0,0-9.26,8.89,25.55,25.55,0,0,0-.78,2.85,13.31,13.31,0,0,1-2.39,5.8c-1.71,2.06-4.42,3.22-7,4.33a38.43,38.43,0,0,0-4,1.92Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M734.42,485.74c.6-1.37,1.14-2.73,1.65-4,1.82-4.64,3.66-9.38,5.45-14.09,1.16-3,2.48-6.5,5.27-9.06a26.28,26.28,0,0,1,2.37-1.87c.57-.42,1.17-.86,1.72-1.32,6.15-5.09,7-13,6.63-18.67l0-.66c-.18-2.62-.39-5.58,1.39-7.94a14.88,14.88,0,0,1,4.68-3.51c.75-.43,1.53-.87,2.23-1.34a6.66,6.66,0,0,0,3-3.81,2.54,2.54,0,0,0-.25-1.7,25.11,25.11,0,0,0-8.87-1.13s0,.07,0,.11a34.38,34.38,0,0,1-6.29,13.1c-.28.38-.58.75-.88,1.12a18.07,18.07,0,0,0-2.89,4.42c-.85,2.16-.69,4.44-.52,6.86.06.76.11,1.55.13,2.33a26.38,26.38,0,0,1-5.1,16c-.88,1.22-1.87,2.39-2.83,3.53a43.69,43.69,0,0,0-3.62,4.71,18.75,18.75,0,0,0-2.79,7.82c-.09.78-.13,1.59-.16,2.37a27,27,0,0,1-.32,3.43,9.87,9.87,0,0,1-1.23,3.36Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M702.47,485.59h.95c-1.09-4.93-2.09-9.9-3-14.83-1.58-9-3.06-19.35-.46-29.06a78.84,78.84,0,0,1,5.53-13.55c1.18-2.46,2.41-5,3.46-7.56,3.69-8.94,4.2-16.26,1.57-22.37-.51-1.2-1.16-2.39-1.79-3.54-1.59-2.9-3.08-5.64-2.67-8.57a.49.49,0,0,0-.4-.53.48.48,0,0,0-.53.4c-.45,3.24,1.19,6.24,2.78,9.15.62,1.13,1.26,2.3,1.76,3.46,2.52,5.87,2,12.95-1.58,21.64-1,2.52-2.26,5.06-3.44,7.51a80.75,80.75,0,0,0-5.59,13.72c-2.65,9.9-1.16,20.4.45,29.47C700.4,475.81,701.39,480.72,702.47,485.59Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-40",
			d: "M715.87,485.65h1c.17-.39.32-.77.46-1.16l-.89-.26C716.28,484.71,716.09,485.19,715.87,485.65Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-42",
			d: "M734,372.69c-.35-.14-.71-.27-1.07-.38,3,10.75,6.37,22.93,4,34.54-1.48,7.18-5.13,14-8.65,20.62a105.77,105.77,0,0,0-7.42,15.95,62.81,62.81,0,0,0-2.95,21.16c0,1.21.06,2.46.11,3.66.18,5.39.37,10.94-1.5,16l.89.26c1.92-5.21,1.73-10.83,1.54-16.3,0-1.19-.09-2.43-.11-3.64a62,62,0,0,1,2.9-20.84,104.68,104.68,0,0,1,7.36-15.8c3.55-6.67,7.23-13.57,8.74-20.88C740.16,395.43,736.92,383.38,734,372.69Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-43",
			d: "M674.15,381a.47.47,0,0,0-.65-.11.45.45,0,0,0-.19.31l.86-.17Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-42",
			d: "M670.89,407.27c.41.59.84,1.18,1.26,1.75.69.93,1.4,1.89,2,2.88a22.68,22.68,0,0,1,2.64,7.4c1.05,5.39.94,11,.83,16.38,0,2.07-.08,4.21-.05,6.32a106,106,0,0,0,10.12,43.53h1A105.2,105.2,0,0,1,678.49,442c0-2.09,0-4.23.06-6.29.1-5.45.21-11.09-.86-16.58a23.57,23.57,0,0,0-2.76-7.71c-.61-1-1.33-2-2-3-.42-.56-.85-1.15-1.24-1.73a27,27,0,0,1-4.52-11.41c-.38-2.73-.23-6.43,2.67-8.52a15.9,15.9,0,0,1,1.47-.89,11.56,11.56,0,0,0,1.86-1.16c1.1-.9,1.89-2.42,1-3.68l-.86.17a.51.51,0,0,0,.08.34c.52.74,0,1.78-.83,2.43a11.69,11.69,0,0,1-1.72,1.08,16.7,16.7,0,0,0-1.57.94c-3.28,2.37-3.47,6.43-3,9.42A28,28,0,0,0,670.89,407.27Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-43",
			d: "M702.71,386.39a.48.48,0,0,0-.31-.59.47.47,0,0,0-.58.32l-.15.58c.35-.06.69-.14,1-.22A.29.29,0,0,0,702.71,386.39Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-42",
			d: "M695,484.28c0,.43-.05.85-.1,1.28h.93c.05-.42.08-.83.1-1.23a177.83,177.83,0,0,0-.79-21.42c-1-13-2.07-26.45,2.56-39,.61-1.64,1.32-3.29,2-4.89,1.7-3.92,3.45-8,3.79-12.22a38.8,38.8,0,0,0-.65-8.87c-.61-4-1.18-7.75-.13-11.47-.33.08-.67.16-1,.22-.93,3.77-.34,7.64.23,11.39a38.27,38.27,0,0,1,.64,8.66c-.33,4.08-2,8.07-3.71,11.91-.7,1.62-1.42,3.28-2,4.94-4.7,12.72-3.64,26.28-2.62,39.38A174.13,174.13,0,0,1,695,484.28Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-42",
			d: "M665.83,420.64c3.59,4.54,7.29,9.23,8.34,14.52,1,4.8-.34,9.73-1.61,14.49-.57,2.17-1.17,4.42-1.55,6.64-1.12,6.51-.26,12.54,2.48,17.44a49.68,49.68,0,0,0,3.42,5,33.9,33.9,0,0,1,4.21,6.73h1a32.39,32.39,0,0,0-4.46-7.29,50.08,50.08,0,0,1-3.35-4.95c-2.64-4.71-3.46-10.52-2.37-16.81.37-2.18,1-4.4,1.53-6.55,1.29-4.87,2.63-9.91,1.63-14.92-1.1-5.52-4.88-10.3-8.53-14.92-1-1.25-2-2.54-2.95-3.82-3.88-5.26-7.75-12.87-4.16-19.28a.47.47,0,0,0-.18-.64.47.47,0,0,0-.63.18c-3.83,6.85.18,14.82,4.23,20.3C663.82,418.09,664.84,419.39,665.83,420.64Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-43",
			d: "M687,382.78a.47.47,0,0,0-.64.08l.82.36A.46.46,0,0,0,687,382.78Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-43",
			d: "M680,380.93l.23,0A.45.45,0,0,0,680,380.93Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-42",
			d: "M679.67,381.1a18.94,18.94,0,0,0-4.38,12.5c.16,4.9,2.35,9.55,4.46,14,1.77,3.77,3.61,7.67,4.21,11.67a42.78,42.78,0,0,1,.31,6c0,3.83.05,7.79,2.07,11.33a.47.47,0,0,0,.4.24.45.45,0,0,0,.41-.24,34.28,34.28,0,0,0,3.15-26.43,67.83,67.83,0,0,0-2.34-6.45,63.28,63.28,0,0,1-2.49-7c-1-3.7-1.52-9,1.58-13.27a.43.43,0,0,0,.09-.21l-.82-.36c-3.34,4.57-2.8,10.18-1.75,14.09a63.67,63.67,0,0,0,2.53,7.14c.83,2.07,1.69,4.22,2.31,6.37a33.27,33.27,0,0,1-2.66,24.94c-1.51-3.12-1.53-6.52-1.55-10.11a43.42,43.42,0,0,0-.32-6.13c-.62-4.14-2.49-8.1-4.29-11.93-2.07-4.4-4.21-9-4.37-13.66a18.08,18.08,0,0,1,4.17-11.88.47.47,0,0,0-.07-.66l-.12-.07-.23,0A.49.49,0,0,0,679.67,381.1Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-42",
			d: "M641.62,445.25a30.31,30.31,0,0,1,3,3.94c2,3.27,2.34,6.86,2.74,10.67a49.63,49.63,0,0,0,.83,5.76c1.6,7.22,6.42,13.81,10.67,19.64l.11.14h1.19c-.18-.22-.37-.45-.55-.7-4.2-5.75-9-12.26-10.52-19.29a51.23,51.23,0,0,1-.81-5.65c-.39-3.74-.8-7.61-2.86-11.06a29.79,29.79,0,0,0-3.12-4.06c-.81-.95-1.65-1.92-2.36-2.93-1.12-1.59-2.81-4.67-1.52-7.43a.47.47,0,0,0-.23-.63.45.45,0,0,0-.61.23c-1.11,2.37-.54,5.34,1.61,8.38C639.94,443.3,640.8,444.29,641.62,445.25Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-43",
			d: "M646.52,400.48l.39-.3A.49.49,0,0,0,646.52,400.48Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-42",
			d: "M654.86,419.52a60.21,60.21,0,0,1,5.72,7.8,25.73,25.73,0,0,1,3.47,14.36,51,51,0,0,1-1.31,7.91c-.91,4.19-1.86,8.53-1,12.83a34.12,34.12,0,0,0,3.12,8.22,47.75,47.75,0,0,1,2.5,5.86,21.29,21.29,0,0,1,1,6.88,7.41,7.41,0,0,1-.32,2.06h1a8,8,0,0,0,.29-2,22.07,22.07,0,0,0-1.06-7.19,47.68,47.68,0,0,0-2.54-6,33.35,33.35,0,0,1-3-8c-.78-4.11.1-8.16,1-12.45a52.12,52.12,0,0,0,1.33-8.06,26.6,26.6,0,0,0-3.6-14.88,61,61,0,0,0-5.8-7.93c-1.22-1.5-2.49-3.05-3.63-4.62-3.71-5.12-5.2-9.56-4.54-13.57a.47.47,0,0,0-.38-.54h-.12l-.39.3a.29.29,0,0,0,0,.1c-.7,4.27.84,8.94,4.71,14.28C652.35,416.45,653.63,418,654.86,419.52Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-42",
			d: "M624.29,462.07a17.1,17.1,0,0,1,3,.85c3.18,1.37,4,4.44,4.8,7.69.24.95.5,1.94.81,2.87,1.23,3.55,3.87,6.68,6.29,9.28.79.86,1.63,1.72,2.53,2.56h1.41c-1.18-1-2.26-2.13-3.27-3.21-2.35-2.53-4.91-5.57-6.08-8.95-.3-.89-.55-1.86-.79-2.8-.86-3.32-1.74-6.76-5.34-8.31a17.25,17.25,0,0,0-3.21-.91c-1.9-.4-3.7-.79-4.46-2a.47.47,0,0,0-.45-.22c-.13.18-.26.36-.41.54a.36.36,0,0,0,.07.17C620.2,461.2,622.28,461.64,624.29,462.07Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-43",
			d: "M631.26,431.58a.46.46,0,0,0-.2,0l.22,0Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-42",
			d: "M638.22,455.6a36.36,36.36,0,0,1,5.7,7.61,32.49,32.49,0,0,1,2.13,6.52,31.44,31.44,0,0,0,2.27,6.87,35.43,35.43,0,0,0,3.06,4.71,38.06,38.06,0,0,1,2.69,4.07h1.06a36.54,36.54,0,0,0-3-4.63,35.49,35.49,0,0,1-3-4.58,30.32,30.32,0,0,1-2.2-6.67,32.31,32.31,0,0,0-2.2-6.71,37.16,37.16,0,0,0-5.84-7.82,50.6,50.6,0,0,1-4.53-5.57,20.77,20.77,0,0,1-2.81-17.24.46.46,0,0,0-.29-.57l-.22,0a.45.45,0,0,0-.38.33,21.74,21.74,0,0,0,2.93,18A49.66,49.66,0,0,0,638.22,455.6Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-42",
			d: "M626,451.89c1.18,1.37,2.44,2.72,3.67,4,2.77,3,5.65,6,7.53,9.46a43.55,43.55,0,0,1,2.21,4.94c1.19,3,2.42,6.05,4.8,8.59a.48.48,0,0,0,.34.14.44.44,0,0,0,.32-.12.48.48,0,0,0,0-.67c-2.26-2.41-3.4-5.27-4.61-8.3a48.93,48.93,0,0,0-2.26-5c-1.94-3.53-4.86-6.64-7.68-9.65-1.22-1.3-2.47-2.64-3.63-4-4.71-5.5-6.66-10.51-5.8-14.89a.46.46,0,0,0-.22-.49,8.06,8.06,0,0,0-.84,1.31C619.4,441.67,621.42,446.48,626,451.89Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-42",
			d: "M621,474.08a29.24,29.24,0,0,0,3,1,19,19,0,0,1,4.19,1.59c2.93,1.69,4.07,4.52,5.28,7.52.15.37.3.74.46,1.11h1c-.21-.49-.41-1-.61-1.47-1.21-3-2.47-6.12-5.68-8a19.59,19.59,0,0,0-4.4-1.67c-1-.29-2-.58-2.9-1-4.46-1.82-7.34-5.92-7-10a.6.6,0,0,0,0-.24l-.9.43C613.13,467.79,616.23,472.15,621,474.08Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-42",
			d: "M606.11,466.9c2.27,1.18,3.35,3.13,4.49,5.19a13.94,13.94,0,0,0,4.11,5.18,20,20,0,0,0,2.49,1.36c.61.29,1.24.59,1.81.93a16.43,16.43,0,0,1,5.36,5.68h1.1a17.86,17.86,0,0,0-6-6.5c-.61-.36-1.25-.67-1.88-1a17.08,17.08,0,0,1-2.36-1.29,13,13,0,0,1-3.83-4.86c-1.11-2-2.26-4.07-4.56-5.39l-.94.45A.41.41,0,0,0,606.11,466.9Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-42",
			d: "M598.45,478.09a3.8,3.8,0,0,0,.65.1,2.38,2.38,0,0,1,.77.16,1.67,1.67,0,0,1,.62.75,42.35,42.35,0,0,0,4.1,6h1.21a41.57,41.57,0,0,1-4.49-6.52,2.56,2.56,0,0,0-1-1.13,3,3,0,0,0-1.08-.25,4,4,0,0,1-.53-.08,1.29,1.29,0,0,1-1-.93.47.47,0,0,0-.32-.38c-.13.41-.23.83-.32,1.25A2.38,2.38,0,0,0,598.45,478.09Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-42",
			d: "M607.9,476.15c.3.83.53,1.7.76,2.54a16.21,16.21,0,0,0,1.83,4.74,11.76,11.76,0,0,0,1.4,1.76h1.33a12.85,12.85,0,0,1-2-2.26,15.57,15.57,0,0,1-1.71-4.48c-.23-.87-.47-1.76-.79-2.63a17.17,17.17,0,0,0-5.65-7.49c-.27.19-.53.38-.78.58A16.31,16.31,0,0,1,607.9,476.15Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-42",
			d: "M599.89,472.31c2.5,1.51,3.53,4,4.62,6.6.94,2.25,1.92,4.57,3.89,6.26h1.44a.37.37,0,0,0-.16-.19c-2.27-1.56-3.26-3.93-4.31-6.44s-2.24-5.38-5-7a.45.45,0,0,0-.64.16A.47.47,0,0,0,599.89,472.31Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-42",
			d: "M735.45,485.74c.54-1.25,1-2.49,1.5-3.68,1.82-4.64,3.66-9.39,5.45-14.1,1.18-3.09,2.4-6.29,5-8.7a25.43,25.43,0,0,1,2.28-1.8c.59-.43,1.2-.88,1.77-1.35,6.46-5.36,7.36-13.54,7-19.47l-.05-.67c-.18-2.57-.36-5.22,1.21-7.29a13.67,13.67,0,0,1,4.38-3.26c.77-.44,1.56-.89,2.3-1.38a7.51,7.51,0,0,0,3.38-4.42,3.51,3.51,0,0,0,0-1.48c-.37-.14-.76-.27-1.15-.4a2.54,2.54,0,0,1,.25,1.7,6.66,6.66,0,0,1-3,3.81c-.7.47-1.48.91-2.23,1.34a14.88,14.88,0,0,0-4.68,3.51c-1.78,2.36-1.57,5.32-1.39,7.94l0,.66c.37,5.71-.48,13.58-6.63,18.67-.55.46-1.15.9-1.72,1.32a26.28,26.28,0,0,0-2.37,1.87c-2.79,2.56-4.11,6-5.27,9.06-1.79,4.71-3.63,9.45-5.45,14.09-.51,1.3-1.05,2.66-1.65,4Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-42",
			d: "M742.19,416.5c2.1-2.72,4.26-5.51,5.11-8.61-.15-1-.26-2.07-.33-3.1a.46.46,0,0,0-.21.39c0,3.9-2.59,7.22-5.31,10.74-2.19,2.85-4.46,5.79-5.31,9.11a22.61,22.61,0,0,0-.12,8,31.86,31.86,0,0,1,.24,5.43,16.43,16.43,0,0,1-3,8.26,38,38,0,0,1-2.5,3.09,22.48,22.48,0,0,0-3.92,5.55c-1.46,3.39-1,7-.47,10.48a25.79,25.79,0,0,1,.3,7.68,18.25,18.25,0,0,1-1.1,3.73l.88.31a19,19,0,0,0,1.14-3.89,26.65,26.65,0,0,0-.3-8c-.49-3.51-1-6.82.4-10a21.57,21.57,0,0,1,3.77-5.31,39,39,0,0,0,2.56-3.17,17.32,17.32,0,0,0,3.17-8.73,32.53,32.53,0,0,0-.25-5.59,21.62,21.62,0,0,1,.1-7.62C737.84,422.14,740.05,419.27,742.19,416.5Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-42",
			d: "M724.74,479.22c-.42,1-.86,2-1.22,3.07-.3.84-.75,2.52-.95,3.38h1c.18-.76.57-2.34.83-3.08.35-1,.78-2,1.2-3,.29-.68.58-1.38.85-2.08l-.88-.31C725.31,477.88,725,478.56,724.74,479.22Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-42",
			d: "M729.43,485.71a21.62,21.62,0,0,1,.46-9,69.73,69.73,0,0,1,7.65-19.65c.32-.57.66-1.14,1-1.71a35.34,35.34,0,0,0,3.62-7.35,33.36,33.36,0,0,0,1.14-7c.29-3.27.57-6.37,2.11-9.22a27.41,27.41,0,0,1,2.16-3.18,20.24,20.24,0,0,0,2.76-4.43c1.15-2.86.82-5.94.46-8.7a6.94,6.94,0,0,1-.81-.72.46.46,0,0,0-.16.43c.35,2.75.76,5.87-.35,8.64a19.22,19.22,0,0,1-2.65,4.22,28.29,28.29,0,0,0-2.22,3.29c-1.64,3-1.94,6.36-2.23,9.59a32.33,32.33,0,0,1-1.1,6.83,34.93,34.93,0,0,1-3.53,7.15c-.33.57-.67,1.14-1,1.72A70.78,70.78,0,0,0,729,476.52a22.85,22.85,0,0,0-.5,9.19Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-42",
			d: "M733.12,485.73a9.87,9.87,0,0,0,1.23-3.36,27,27,0,0,0,.32-3.43c0-.78.07-1.59.16-2.37a18.75,18.75,0,0,1,2.79-7.82,43.69,43.69,0,0,1,3.62-4.71c1-1.14,2-2.31,2.83-3.53a26.38,26.38,0,0,0,5.1-16c0-.78-.07-1.57-.13-2.33-.17-2.42-.33-4.7.52-6.86a18.07,18.07,0,0,1,2.89-4.42c.3-.37.6-.74.88-1.12a34.38,34.38,0,0,0,6.29-13.1s0-.08,0-.11l-.36,0-.6,0a33.38,33.38,0,0,1-6.07,12.57c-.28.37-.58.74-.87,1.11a18.78,18.78,0,0,0-3,4.66c-.92,2.36-.75,4.86-.58,7.27.06.76.11,1.54.13,2.29A25.36,25.36,0,0,1,743.32,460c-.85,1.19-1.84,2.35-2.78,3.48a43.07,43.07,0,0,0-3.71,4.81,19.85,19.85,0,0,0-2.93,8.22c-.09.81-.13,1.64-.16,2.43a28.07,28.07,0,0,1-.3,3.31,8.43,8.43,0,0,1-1.45,3.53Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-42",
			d: "M745.81,485.79h1.3a7.53,7.53,0,0,0,1.78-3.48,13.67,13.67,0,0,0,0-4.09,9.16,9.16,0,0,1,.33-4.87c1-2.28,3.69-3.6,6.49-5,1.09-.55,2.22-1.11,3.24-1.73a17.51,17.51,0,0,0,8-18.24c-.09-.5-.2-1-.31-1.51-.44-2.07-.86-4-.13-5.84s2.35-3.12,4-4.47c.44-.37.89-.74,1.31-1.11,4.27-3.79,6-8.31,4.76-12.11a.45.45,0,0,0-.59-.29.47.47,0,0,0-.29.59c1.16,3.43-.52,7.58-4.49,11.1-.42.37-.86.73-1.3,1.1-1.7,1.42-3.46,2.89-4.24,4.84s-.36,4.28.09,6.38c.11.5.22,1,.31,1.49a16.6,16.6,0,0,1-7.53,17.27c-1,.6-2.1,1.15-3.17,1.68-2.82,1.4-5.74,2.85-6.92,5.44a9.92,9.92,0,0,0-.42,5.36,12.45,12.45,0,0,1,0,3.8A6.9,6.9,0,0,1,745.81,485.79Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-42",
			d: "M761.61,485.86a20.67,20.67,0,0,1,6.88-6.55c.86-.47,1.81-.88,2.72-1.27a29.07,29.07,0,0,0,3-1.44,12.56,12.56,0,0,0,5.54-6.07,21.27,21.27,0,0,0,.69-2.09c.49-1.65.95-3.21,2.25-4.34a11.88,11.88,0,0,1,2.15-1.33c.38-.2.78-.41,1.16-.63a10.42,10.42,0,0,0,5.12-7.07,8.88,8.88,0,0,0-.66-.73.45.45,0,0,0-.22.33,9.41,9.41,0,0,1-4.71,6.66c-.36.21-.75.41-1.12.61a12.36,12.36,0,0,0-2.32,1.45,9.21,9.21,0,0,0-2.54,4.78,19.5,19.5,0,0,1-.66,2,11.68,11.68,0,0,1-5.14,5.62,31.7,31.7,0,0,1-2.94,1.39c-.94.4-1.9.81-2.81,1.3a22.65,22.65,0,0,0-7.57,7.37Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-42",
			d: "M753.49,485.82l1.1-4.19a17,17,0,0,1,2.28-5.76,21.47,21.47,0,0,1,5.42-4.71c1.12-.78,2.28-1.59,3.33-2.48a17.76,17.76,0,0,0,6.18-10.51,30.74,30.74,0,0,0,.29-3.42,25.4,25.4,0,0,1,.4-3.89,7.65,7.65,0,0,1,4.23-5.68,7.84,7.84,0,0,1-.31-.89,8.56,8.56,0,0,0-4.83,6.37,26.76,26.76,0,0,0-.42,4,30.75,30.75,0,0,1-.28,3.32A16.8,16.8,0,0,1,765,468c-1,.86-2.16,1.66-3.26,2.43a22.26,22.26,0,0,0-5.64,4.94,17.9,17.9,0,0,0-2.43,6.06l-1.16,4.43Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-42",
			d: "M778.73,457c-.53.75-1.1,1.5-1.65,2.23a31.23,31.23,0,0,0-3.38,5.09,30.24,30.24,0,0,0-1.28,3.24,18,18,0,0,1-2.22,4.78,22.45,22.45,0,0,1-5.28,4.64l-1.49,1.08c-2.09,1.54-4.92,4-5.44,7.05a.48.48,0,0,0,.38.55h.08a.48.48,0,0,0,.47-.4c.46-2.75,3.11-5,5.06-6.44l1.48-1.06a23.4,23.4,0,0,0,5.5-4.86,18.94,18.94,0,0,0,2.34-5,22,22,0,0,1,4.52-8.06c.56-.73,1.13-1.49,1.67-2.26,2-2.87,2.93-5.29,2.88-7.57-.33-.14-.65-.29-1-.44C781.6,451.77,780.75,454.14,778.73,457Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-42",
			d: "M769.12,485.89a38.43,38.43,0,0,1,4-1.92c2.61-1.11,5.32-2.27,7-4.33a13.31,13.31,0,0,0,2.39-5.8,25.55,25.55,0,0,1,.78-2.85,15.8,15.8,0,0,1,9.26-8.89c.07-.3.13-.59.18-.89a.47.47,0,0,0-.4,0,16.73,16.73,0,0,0-9.91,9.49,24.54,24.54,0,0,0-.81,3,12.44,12.44,0,0,1-2.2,5.41c-1.57,1.88-4.05,2.95-6.69,4.07a30.41,30.41,0,0,0-4.88,2.43l-.5.35Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-42",
			d: "M784.43,486a19.8,19.8,0,0,0,2.42-1.13,14,14,0,0,0,5.67-5.72c.21-.4.4-.82.58-1.23a7.6,7.6,0,0,1,2.16-3.24,10.4,10.4,0,0,1,2.68-1.27,13.86,13.86,0,0,0,2.49-1.1,5.14,5.14,0,0,0,2.3-6.09c-.36-.12-.72-.23-1.1-.32a.56.56,0,0,0,0,.28,4.11,4.11,0,0,1-1.74,5.33,13,13,0,0,1-2.32,1,10.93,10.93,0,0,0-2.92,1.4,8.44,8.44,0,0,0-2.45,3.61c-.18.39-.36.8-.55,1.18a13.18,13.18,0,0,1-5.3,5.33,27.94,27.94,0,0,1-4.7,1.94Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-42",
			d: "M790.87,486a21,21,0,0,1,1.76-2,23.07,23.07,0,0,1,4.25-2.94c.86-.5,1.75-1,2.58-1.59a18.09,18.09,0,0,0,7.56-10.7,9.44,9.44,0,0,0-.81-.72,17,17,0,0,1-7.27,10.61c-.8.55-1.67,1.06-2.52,1.55a23.56,23.56,0,0,0-4.42,3.07,21,21,0,0,0-1.89,2.16c-.15.2-.3.39-.46.57Z",
			transform: "translate(-69.81 -46.82)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-42",
			d: "M708.2,485.23a.45.45,0,0,0,.07.39H709a.35.35,0,0,0,.07-.15c.85-3.34.14-6.74-.54-10a26.24,26.24,0,0,1-.81-8.28,27.07,27.07,0,0,1,2.83-8,31.61,31.61,0,0,0,2.78-7.33c.69-3.58,0-7.21-.58-10.72a42.68,42.68,0,0,1-.87-7.28,21.35,21.35,0,0,1,3.61-11.75c.88-1.34,1.92-2.63,2.94-3.89a38.79,38.79,0,0,0,3.64-5,17.56,17.56,0,0,0,2.36-10.57c-.35-3.53-1.79-6.9-3.17-10.16-.7-1.62-1.41-3.3-2-5-1.19-3.51-2.52-10,2-14.41a.46.46,0,0,0,.13-.29,16.2,16.2,0,0,0-2.06,1.1c-3.3,4.61-2.07,10.56-.93,13.91.58,1.7,1.3,3.4,2,5,1.36,3.19,2.77,6.49,3.1,9.87a16.63,16.63,0,0,1-2.23,10,39.45,39.45,0,0,1-3.56,4.88c-1,1.28-2.09,2.59-3,4A22.36,22.36,0,0,0,711,433.87a42.23,42.23,0,0,0,.89,7.45c.63,3.58,1.24,7,.58,10.37a31.14,31.14,0,0,1-2.7,7.1,27.63,27.63,0,0,0-2.92,8.26,26.49,26.49,0,0,0,.82,8.59C708.34,479,709,482.11,708.2,485.23Z",
			transform: "translate(-69.81 -46.82)"
		})
	]
});
const ForwardRef = forwardRef(SvgOutdoor);
export default ForwardRef;
